webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/yCHHgW/%3F1724535926133&title=Counting%20One%27s%20Blessings&summary=Get%20%23Free%20%23Sample%20of%20Counting%20One%27s%20Blessings%20-%20%0D%0AWilliam%20Shawcross%27s%20official%20biography%20of%20Queen%20Elizabeth%20the%20Queen%20Mother%2C%20published%20in%20September%202009%2C%20was%20a%20huge%20critical%20and%20commercial%20success.One%20of%20the%20great%20revelations%20of%20the%20book%20was%20Queen...&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/yCHHgW/%3F1724535926133",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Get%20%23Free%20%23Sample%20of%20Counting%20One%27s%20Blessings%20%0Dhttps://textcafe.co/books/yCHHgW/%3F1724535926133&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/yCHHgW/%3F1724535926133&posttype=link&caption=Get%20%23Free%20%23Sample%20of%20Counting%20One%27s%20Blessings%20-%20%0D%0AWilliam%20Shawcross%27s%20official%20biography%20of%20Queen%20Elizabeth%20the%20Queen%20Mother%2C%20published%20in%20September%202009%2C%20was%20a%20huge%20critical%20and%20commercial%20success.One%20of%20the%20great%20revelations%20of%20the%20book%20was%20Queen...",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/yCHHgW/%3F1724535926133&description=Get%20%23Free%20%23Sample%20of%20Counting%20One%27s%20Blessings%20-%20%0D%0AWilliam%20Shawcross%27s%20official%20biography%20of%20Queen%20Elizabeth%20the%20Queen%20Mother%2C%20published%20in%20September%202009%2C%20was%20a%20huge%20critical%20and%20commercial%20success.One%20of%20the%20great%20revelations%20of%20the%20book%20was%20Queen...&media=https://textcafe.co/books/yCHHgW/tc-custom/9781466827745.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781466827745&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=L7u_UIpBQ-UC&amp;rdid=book-L7u_UIpBQ-UC&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781466827745').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/yCHHgW/tc-custom/9781466827745.jpg?1724535926133',
        alt: 'Counting One&#x27;s Blessings'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/contents", "xhtml/epigraph", "xhtml/illustrations", "xhtml/preface", "xhtml/part1", "xhtml/part2", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/yCHHgW/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_love_1__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_title__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_copyrightnotice__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_copyrightnotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_copyrightnotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_epigraph__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_epigraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_epigraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_illustrations__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_illustrations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_illustrations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_preface__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_part1__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_part1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_part1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_part2__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_part2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_part2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_part3__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_part3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_xhtml_part3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_part4__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_part4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_xhtml_part4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_photos1__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_photos1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_xhtml_photos1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_photos2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_photos2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_xhtml_photos2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_photos3__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_photos3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_xhtml_photos3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_photos4__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_photos4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_xhtml_photos4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_photos5__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_photos5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_xhtml_photos5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_photos6__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_photos6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_xhtml_photos6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_photos7__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_photos7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_xhtml_photos7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_photos8__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_photos8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_xhtml_photos8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_photos9__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_photos9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_xhtml_photos9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_photos10__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_photos10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_xhtml_photos10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_photos11__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_photos11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_xhtml_photos11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_photos12__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_photos12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_xhtml_photos12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_photos13__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_photos13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_xhtml_photos13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_photos14__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_photos14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_xhtml_photos14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_photos15__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_photos15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_xhtml_photos15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_photos16__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_photos16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_xhtml_photos16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_photos17__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_photos17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_xhtml_photos17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_photos18__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_photos18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_xhtml_photos18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_photos19__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_photos19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_xhtml_photos19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_photos20__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_photos20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_xhtml_photos20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_photos21__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_photos21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_xhtml_photos21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_photos22__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_photos22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_xhtml_photos22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_photos23__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_photos23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_xhtml_photos23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_photos24__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_photos24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_xhtml_photos24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_photos25__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_photos25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_xhtml_photos25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_photos26__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_photos26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_xhtml_photos26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_photos27__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_photos27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_xhtml_photos27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_photos28__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_photos28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_xhtml_photos28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_photos29__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_photos29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_xhtml_photos29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_photos30__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_photos30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_xhtml_photos30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_photos31__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_photos31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_xhtml_photos31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_xhtml_photos32__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_xhtml_photos32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_xhtml_photos32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_xhtml_photos33__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_xhtml_photos33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_xhtml_photos33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_xhtml_photos34__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_xhtml_photos34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_xhtml_photos34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_xhtml_photos35__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_xhtml_photos35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_xhtml_photos35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_xhtml_photos36__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_xhtml_photos36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_xhtml_photos36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_xhtml_photos37__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_xhtml_photos37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_xhtml_photos37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_xhtml_photos38__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_xhtml_photos38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_xhtml_photos38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_xhtml_photos39__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_xhtml_photos39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_xhtml_photos39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_xhtml_photos40__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_xhtml_photos40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_xhtml_photos40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_xhtml_photos41__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_xhtml_photos41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_xhtml_photos41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_xhtml_photos42__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_xhtml_photos42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_xhtml_photos42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_xhtml_photos43__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_xhtml_photos43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_xhtml_photos43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_xhtml_photos44__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_xhtml_photos44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_xhtml_photos44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_xhtml_photos45__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_xhtml_photos45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_xhtml_photos45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_xhtml_photos46__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_xhtml_photos46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_xhtml_photos46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_xhtml_photos47__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_xhtml_photos47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_xhtml_photos47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_xhtml_photos48__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_xhtml_photos48___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_xhtml_photos48__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_xhtml_photos49__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_xhtml_photos49___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_xhtml_photos49__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_xhtml_photos50__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_xhtml_photos50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_xhtml_photos50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_xhtml_love_2__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_xhtml_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_xhtml_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_xhtml_tree__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_xhtml_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_xhtml_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_xhtml_note__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_xhtml_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_xhtml_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_xhtml_index__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_xhtml_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_xhtml_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_xhtml_adcard__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_xhtml_adcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_xhtml_adcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_xhtml_copyright__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_xhtml_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_xhtml_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_xhtml_footnote__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_xhtml_footnote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_xhtml_footnote__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_last__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_last__);
/*jshint esversion: 6 */












































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/contents",
    "name": "xhtml/contents",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents___default.a
  }, {
    "path": "/xhtml/epigraph",
    "name": "xhtml/epigraph",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_epigraph___default.a
  }, {
    "path": "/xhtml/illustrations",
    "name": "xhtml/illustrations",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_xhtml_illustrations___default.a
  }, {
    "path": "/xhtml/preface",
    "name": "xhtml/preface",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_xhtml_preface___default.a
  }, {
    "path": "/xhtml/part1",
    "name": "xhtml/part1",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_xhtml_part1___default.a
  }, {
    "path": "/xhtml/part2",
    "name": "xhtml/part2",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_xhtml_part2___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_73__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Shawcross\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("William Shawcross")]), _vm._v(" became a writer after leaving University College Oxford in 1968. He was in Czechoslovakia during the Soviet occupation; this inspired his first book, a biography of Alexander Dubcek, the Czechoslovak leader, which was published in 1970. Since then he has written and travelled widely. In 1995 he wrote the BBC Television series "), _c('I', [_vm._v("Monarchy")]), _vm._v(". In 2002 his BBC Television series and book, "), _c('I', [_vm._v("Queen and Country")]), _vm._v(", celebrated the Queen's Golden Jubilee and examined the changing face of Britain during her reign. He is also the author of "), _c('I', [_vm._v("Justice and the Enemy: Nuremberg, 9/11 and the Trial of Khalid Sheikh Mohammed")]), _vm._v(" (2012). He lives in England.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yCHHgW/tc-custom/9781466827745.jpg?1724535926133",
      "alt": "This image is the cover for the book Counting One's Blessings"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Counting One's Blessings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("William Shawcross's official biography of Queen Elizabeth the Queen Mother, published in September 2009, was a huge critical and commercial success.One of the great revelations of the book was Queen Elizabeth's insightful, witty private correspondence. Indeed, "), _c('i', [_vm._v("The Sunday Times")]), _vm._v(" described her letters as \"wonderful . . . brimful of liveliness and irreverence, steeliness and sweetness.\""), _c('br'), _c('br'), _vm._v("Now, in "), _c('i', [_vm._v("Counting One's Blessings")]), _vm._v(", Shawcross has put together a selection of her letters, drawing on the vast wealth of material in the Royal Archives and at Glamis Castle. Queen Elizabeth was a prolific correspondent, from her early childhood before World War I to the very end of her long life at the beginning of the twenty-first century, and her letters offer readers a vivid insight into the real person behind the public face.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus and Giroux\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_vm._m(0)]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_vm._m(0)]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_vm._m(0)]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_vm._m(0)]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epi"
    }
  }, [_vm._v("Epigraphs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/illustrations#ill"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("Part One: Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2#pt2"
    }
  }, [_vm._v("Part Two: Duchess of York")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Queen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: Queen Mother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos1#pho1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/tree#tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Family Trees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by William Shawcross")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘Letters are like wine; if they are sound they ripen with keeping’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("S"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AMUEL")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UTLER")])]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘Sometimes, one’s heart quails at the thought of the things that lie ahead, and then one counts one’s blessings – and things don’t seem so bad!’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE")]), _vm._v(" Q"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UEEN")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("5 May 1939 to the Archbishop of Canterbury")])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ill"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos1#pho1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Elizabeth Bowes Lyon with her mother (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos2#pho2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Elizabeth, David and Jock Bowes Lyon (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos3#pho3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Elizabeth, aged about five (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos4#pho4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" A letter written by Elizabeth aged six (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos5#pho5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Beryl Poignand in 1915 (By courtesy of Richard Hall)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos6#pho6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" A letter from Elizabeth to Beryl Poignand (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos7#pho7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Jock, May and Rose Bowes Lyon (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos8#pho8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Elizabeth with Prince Paul of Yugoslavia (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos9#pho9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" Elizabeth with Doris Gordon-Lennox, Freddy Dalrymple Hamilton, Bruce Ogilvy, Geordie Haddington, Alix Cavendish and Diamond Hardinge (By courtesy of the Earl of Strathmore, digital image by P. J. Buxton)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos10#pho10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" Prince Albert in 1920 (Photograph by (Mary) Olive Edis © National Portrait Gallery)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos11#pho11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" Elizabeth in 1920 (Photograph by Swaine © Daily Herald Archives/SSPL/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos12#pho12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" At Bisham, Ascot week 1921. (RCIN 2585024.b © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos13#pho13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Elizabeth with Princess Mary and Geordie Haddington (RCIN 2585069 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos14#pho14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Elizabeth at Glamis with her dogs, Peter and Biffin (RCIN 2585078 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos15#pho15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" A house party, September 1921 (RCIN 2585060 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos16#pho16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" The Duke and Duchess of York on the balcony of Buckingham Palace (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos17#pho17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" The bride and groom leaving for their honeymoon (Hulton Archive/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos18#pho18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" The Duchess of York trying her hand at the coconut shy (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos19#pho19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" The Duke and Duchess at the Empire Exhibition, October 1925 (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos20#pho20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" The Duke and Duchess of York (RCIN 2111468 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos21#pho21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" The Duke and Duchess on tour in Australia (RCIN 2940859 © Reserved/The Royal Collection/Simpson, Bell & Co., Coolangatta, Queensland)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos22#pho22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" The Duchess and Lady Strathmore with the Princesses (RCIN 2112235 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos23#pho23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" The Duchess, King George V and Queen Mary with Princess Elizabeth and Princess Margaret (RCIN 2112338 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos24#pho24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" The Duke of York with the Princesses (RCIN 2112417 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos25#pho25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" The Prince of Wales, the Duke of York and the Princesses (RCIN 2112539 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos26#pho26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" The Coronation of King George VI (Hay Wrightson © National Portrait Gallery)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos27#pho27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" A Christmas invitation to Sir Richard Molyneux (RA QEQM-OUT-MOLYNEUX-91)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos28#pho28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The King and Queen on board the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Empress of Australia,")]), _vm._v(" bound for Canada, May 1939 (Evening Standard/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos29#pho29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" The King and Queen in Washington DC with President and Mrs Roosevelt, and the President’s aide, Major-General Edwin Watson, June 1939 (Photo by Hulton Archive/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos30#pho30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" The King and Queen surveying the damage caused by the bombing of Buckingham Palace (RCIN 2941132 © Reserved/The Times)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos31#pho31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" The King and Queen in the gardens of Buckingham Palace, photographed by Cecil Beaton (RCIN 2088561 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos32#pho32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" The King, Queen and the Princesses with General Smuts (RCIN 2704839 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos33#pho33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" The Royal Family on the balcony at Buckingham Palace (Popperfoto/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos34#pho34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Queen Elizabeth II’s Coronation (Photo by Topical Press Agency/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos35#pho35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Queen Elizabeth with the jockey Dick Francis (Photo by Fox Photos/Getty Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos36#pho36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" At the controls of a Comet, 1952 (RCIN 25946633 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos37#pho37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" At Saks 5th Avenue (Harry Harris/AP/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos38#pho38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" On tour in Bulawayo (AP/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos39#pho39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" On tour in Canada (RCIN 2599730 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos40#pho40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" With veterans of the Boer War (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos41#pho41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" Attending a reception for the London Scottish Regiment (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos42#pho42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" At a London University Ball (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos43#pho43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" With Prince Charles and John Elphinstone (RCIN 259594344 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos44#pho44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" With the Queen and Princess Margaret (RCIN 2595713 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos45#pho45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" A letter to Sir Frederick Ashton (By courtesy of Anthony Russell-Roberts)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos46#pho46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" Queen Elizabeth with her horse, Special Cargo, which had just won the Whitbread Gold Cup at Sandown Park, April 1984 (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos47#pho47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Queen Elizabeth enjoying a pint of bitter (PA/PA Archive/Press Association Images)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos48#pho48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" Queen Elizabeth and her friend Dick Wilkins (RCIN 2324847 © Reserved/The Royal Collection)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos49#pho49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Queen Elizabeth with her nephew Simon Bowes Lyon and his wife Caroline (RCIN 2599944 © Reserved/The Royal Collection/Studio Neill, Biggleswade)")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photos50#pho50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" One of Queen Elizabeth’s last public engagements (PA/PA Archive/Press Association Images)")])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "pre"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("H"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ER")]), _vm._v(" M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AJESTY THE")]), _vm._v(" Q"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("UEEN")]), _vm._v(" graciously permitted me to compile and edit this collection of letters of Queen Elizabeth the Queen Mother. I am deeply indebted to her. As a result of her generosity, I was allowed unrestricted access to the Royal Archives, where I had worked on the official biography of Queen Elizabeth, published in 2009, and to all other sources which I had used for that book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As well as to Her Majesty the Queen, I am very grateful to other members of the Royal Family who have helped me, in particular the Duke of Edinburgh, the Prince of Wales, the Duchess of Cornwall, the Duke of York, the Earl of Wessex, the Princess Royal, the Duke of Gloucester, the Duke of Kent, Princess Alexandra, Viscount Linley, Lady Sarah Chatto and the Earl of Snowdon for their assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thank Her Majesty for permission to quote material from the Royal Archives, as well as from all other letters subject to her copyright. Anyone who has worked in these archives knows what a pleasure that is. Once again, I was assisted in the most efficient and supportive way by the Registrar, Pam Clark, and her staff, including Jill Kelsey, Allison Derrett and Lynne Beech. Felicity Murdo-Smith kindly assisted in transcribing letters in the Archives. The Curator of the Royal Photograph Collection, Sophie Gordon, the Assistant Curator, Lisa Heighway, and Shruti Patel and her staff at the Royal Collection Photographic Services were all immensely helpful in providing photographs to illustrate this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At Glamis Castle, the ancestral home of the Bowes Lyon family, I must thank the Earl of Strathmore for permission to quote papers within the family’s possession. The Archivist at Glamis, Ingrid Thomson, helped me in every way, tracing names and dates and letters. Among other members of the Queen Mother’s family, Sir Simon and Lady Bowes Lyon again allowed me access to their papers at St Paul’s Walden, one of the Bowes Lyon family homes, and I must thank Queen Elizabeth’s nieces, Lady Mary Clayton, Lady Mary Colman and the Hon. Mrs Rhodes (née Margaret Elphinstone) for their assistance. I have also been generously assisted by Queen Elizabeth’s nephew the Hon. Albemarle Bowes Lyon and her great-nephew James Joicey-Cecil, by her cousin John Bowes Lyon and by her great-nieces Rosemary Leschallas, Lady Elizabeth Shakerley and Rosie Stancer, and by Jenny Gordon-Lennox.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am much indebted to everyone who allowed me to quote from their own letters and who gave me access to letters from Queen Elizabeth which they held. These include Sir Antony Acland, Sir Edward Cazalet, Mrs Alan Clark, Lady Katharine Farrell, the Hon. George Fergusson, Canon Dendle French, the Earl of Halifax, Mrs Anthony Harbottle, Sally Hudson, Carol Hughes, Joanna Johnston, Henrietta Knight, Mark Logue, David Micklethwait, John Murray, the Hon. Lady Murray, Susan Crawford Phipps, Lady Penn, Anthony Russell-Roberts, the Marquess of Salisbury, Alexandra Sitwell, Susanna Sitwell and the Osbert Sitwell Estate, Sir Jock Slater, Earl Spencer, Lord Tweedsmuir, Violet Vyner, Cath Walwyn, Diana Way, Robert Woods, Lady Wyatt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have received help from the staff of many archives and libraries as well as from the archivists of private collections. They include Dr Nicholas Clark, Librarian at the Britten–Pears Foundation; Tanya Chebotarev, curator of the Bakhmeteff Archive, Columbia University; Helen Langley, Curator, Modern Political Papers, Department of Special Collections and Western Manuscripts, Bodleian Library; Michael Meredith, Librarian at Eton College; Susan Worrall, Cadbury Research Library: Special Collections, University of Birmingham; Allen Packwood, Director, and Madelin Terrazas, Archives Assistant, at the Churchill Archives Centre, Churchill College, Cambridge; Giles Mandelbrote, Librarian, and the Trustees of Lambeth Palace Library; Kathryn McKee at St John’s College, Cambridge; Alison Metcalfe at the National Library of Scotland; Vicki Perry, Head of Archives and Historic Collections at Hatfield House; Bruce Bailey, archivist at Althorp; staff at the Harry Ransom Center, University of Texas at Austin; staff at the Franklin D. Roosevelt Presidential Library and Museum, Hyde Park, New York. I am grateful to them all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have been helped by many members of the Royal Household, as I was with my official biography of Queen Elizabeth. They include Sir Christopher Geidt, The Queen’s Private Secretary, and Samantha Cohen, her Assistant Private Secretary. Sir Christopher has a superb understanding of the monarchy’s place in British life and I am grateful to him for approving this collection. Miss Cohen oversaw the publication of my biography of Queen Elizabeth with consummate talent and grace, and was especially generous with her time on this work also.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I am indebted to the Royal Librarian, the Hon. Lady Roberts, and to Sir Hugh Roberts, former Director of the Royal Collection, and to his successor Jonathan Marsden. All of them gave me the benefit of their knowledge and insights. So too did Lady Susan Hussey and the Hon. Mary Morrison, each of whom has served the Queen for over fifty years.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the office of the Duke of Edinburgh, Dame Anne Griffiths was extremely helpful and at Clarence House I was assisted by Sir Michael Peat, Private Secretary to the Prince of Wales, and his successor William Nye, as well as by David Hutson, Virginia Carington and Paddy Harverson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I thank Ailsa Anderson, Press Secretary to The Queen, always a fount of impeccable and witty advice, Zaki Cooper and other members of the Palace press office. As always, the Buckingham Palace switchboard under Michelle Redpath was marvellously efficient.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Many of the Queen Mother’s Household and friends provided me with great help. They include Dame Frances Campbell-Preston, Martin and Catriona Leslie, Jamie Lowther-Pinkerton, Lucy Murphy, Leslie Mitchell and Jacqui Meakin. Ashe Windham, former equerry and friend of Queen Elizabeth, and Lady Penn, former lady in waiting to Queen Elizabeth, gave me particular friendship and assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are many others to whom I am grateful for different forms of help. They include Sir Eric and Lady Anderson, Fiona Bruce, Sir Edward and Lady Cazalet, Miss Pamela Fleetwood, Dame Drue Heinz, Nigel Jaques, Lady Rupert Nevill, Patty Palmer Tomkinson, Brigadier Andrew Parker Bowles, Simon Parker Bowles, Major Johnny Perkins, Lord and Lady Sainsbury, the Dowager Countess of Strathmore, Colin Thubron, the Duchess of Westminster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As with my biography of Queen Elizabeth, I owe debts to other writers, particularly to Hugo Vickers, author of many books on the monarchy, including "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Queen Elizabeth")]), _vm._v(" (2005), who gave me generous access to letters in his own archives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Above all I am indebted to those who helped me most closely, in particular Lady Elizabeth Leeming, a skilled editor in her own right, great-niece of Queen Elizabeth and sister of the Earl of Strathmore, the head of the Bowes Lyon family. She tirelessly worked through many drafts of this book and, through her careful research, discovered not only family facts but also many others. She and her husband Antony were also very hospitable to me, allowing me to work and stay in their house in Cumbria. I am once again very grateful to Sheila de Bellaigue, former Registrar of the Royal Archives, who was my peerless scholarly companion on this book, as on the official biography. Without her meticulous scholarship and erudition I could never have completed either book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My literary agents, Carol Heaton in London and Lynn Nesbit in New York, were supportive and helpful as always. In New York I was happy to be published by Jonathan Galassi of Farrar, Straus and Giroux, and in London I was fortunate that once again Georgina Morley of Macmillan was my editor. It was not a simple book to create but she accomplished it with patience, charm and skill. Peter James copyedited the book with precision, Jacqui Graham arranged publicity with skill, Tania Wilde was coolheaded and managed all the final details of publication with dexterity. As before, I was privileged to have Douglas Matthews create the index.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally, I am grateful to my family, especially my wife Olga, and Conrad, Ellie, Alex and Charlie for their patience while I had the joy of assembling these letters.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ETTERS HAVE ALWAYS")]), _vm._v(" been treasured, sometimes revered. Archives and museums all over the world cosset them. So do people, in the drawers of their desks, in bundles hidden in boxes, in attics or in wardrobes. Letters are history, public and personal. They can evoke times, characters, hopes and fears like almost nothing else. And, above all, they can evoke love. There is almost nothing so exquisite as a letter bearing, describing, offering love. The crackle of paper drawn out of envelopes has a mystery, if not a magic, that evokes an age gone by. The letters of many prominent people – statesmen, politicians, writers, artists, lovers, kings and queens – can command both awe and high prices.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Throughout the ages, letter writing has flourished. In the nineteenth and early twentieth centuries, pen and paper were almost as natural and frequent a means of communication as word of mouth for those with money and time. In central London and other great cities, the postal services were superb and swift – letters written and posted in Mayfair would be delivered in Belgravia an hour or so later. Mornings in many households, both grand and less so, were given over to letter writing, certainly by the lady of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But today letters sometimes seem of another time, almost as ancient as calligraphy. In this digital age into which the world has been thrust, almost without warning, the art of letter writing is already being swamped by emails, text messages and tweets and many more means of communication that only recently could hardly be imagined. How will historians of the future manage without the glorious primary source of private thoughts in private letters?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Of course, lamenting the death of letter writing long predates the current revolution in technology. Roger Fulford, the editor of an earlier collection of royal letters, pointed out in 1964 that phrases such as ‘Nobody writes letters nowadays’ and ‘The art of letter writing is dead’ were already constant lamentations in the middle of the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Fulford was introducing the first of what became five volumes of correspondence between Queen Victoria and her daughter Victoria, the Princess Royal and later Crown Princess of Prussia and mother of the last Kaiser of Germany. He ruminated about how such mid-nineteenth-century letters should be presented to readers of the 1960s. Should they be to and fro, or is a one-sided correspondence enough? Should they deal with a specific period of a life, or with the whole life? He did not lack for material – for over forty years, the Queen wrote to her daughter at least twice a week and the Princess replied almost as often. All those letters have survived. The Queen alone wrote half a million words to this one daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Roger Fulford had to decide whether to publish a selection of the most interesting letters from four decades in a single volume, or to concentrate on a shorter period in order to be able to show ‘the interests and occupations of the Queen’. He chose the latter and his first volume, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Dearest Child,")]), _vm._v(" covers only four years, ending with the death of the Queen’s husband and the Princess’s father, Prince Albert, in December 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In this book, by contrast, I have chosen letters from all ten decades of Queen Elizabeth’s life. I hope nevertheless to have avoided the ‘distracting’ effect of a selection which ‘jumps the reader from decade to decade’, in Fulford’s words."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#preface-1",
      "id": "pre-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("1")])]), _vm._v(" And I hope also that the wide variety of those to whom the letters are addressed reflects the breadth of this Queen’s interests and occupations.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("W"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HEN")]), _vm._v(" I "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("BEGAN RESEARCH")]), _vm._v(" in the Royal Archives on the official biography of Queen Elizabeth, box after box of material was brought to my desk and I was immediately struck by the wonderful letters she wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unlike Queen Victoria, she had beautiful clear handwriting from the age of ten to the age of a hundred. From childhood onwards, her words danced on the page, teeming with vitality, ebullience and optimism. Although by today’s standards her formal education was limited, her letters showed a relish for language, and sparkled with the sheer joy of living.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I quoted from many such letters in the biography. But there were far more which I was not able to include even in part, let alone in whole, for simple reasons of space. And so I must repeat my gratitude to Her Majesty The Queen for granting me the huge pleasure, and responsibility, of delving again into Queen Elizabeth’s letters to make the selection in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The structure is simple. I have followed the path of her life and have written short passages and notes to provide context and information about those to whom she was writing and those whom she mentions. I have kept her childhood spelling but corrected her rare mistakes as an adult. In addition, I have included extracts from diaries that she kept in her early years and quotations from her remarkable recorded conversations in the 1990s with Eric Anderson, then Provost of Eton College, in which she recalled many incidents and relationships throughout her life."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn1",
      "id": "fn_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The letters span the entire twentieth century, as did her life. They are drawn from the thousands that Queen Elizabeth wrote to family and friends. Naturally, not all of these have survived. In all families, letters are thrown away, letters are put somewhere safe and forgotten, letters are lost. Sometimes letters are deliberately destroyed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When I made my first trip to Glamis Castle I was astonished to be handed a box containing hundreds of letters written during the First World War by the adolescent Elizabeth to Beryl Poignand, her governess and friend. Many of these letters are ten or more pages long and some are filled with girlish enthusiasms, even nonsense, but almost all of them are fun – except, of course, those that deal with sombre matters of war and death. Many of them discuss the soldiers who came to convalesce at Glamis during the war, and with whom Elizabeth and Beryl made friends and played games. They show the spontaneous, joyous side of her character which she later had to control as the wife of a prince – in public at least.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Prince Albert, the second son of King George V and Queen Mary, fell in love with her in 1920 and the letters between them during their courtship – he did most of the courting – are at times almost unbearably poignant, testament to his dedication and to her hesitancy. After their marriage in April 1923, letters between them are much rarer, probably because they spent very little time apart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are almost no letters from Elizabeth to her father; sadder still, many of those to her mother are missing. They had an extraordinarily close, affectionate relationship, and as a child Elizabeth confided completely in her mother. The day after her wedding to the Prince, now Duke of York, Elizabeth wrote to her, ‘I could not say anything to you about how utterly miserable I was at leaving you and Mike & David & father. I could not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" have said it to you – but you know I love you more than anybody in the world mother, and you do know it, don’t you?’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#preface-2",
      "id": "pre-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")])]), _vm._v(" Lady Strathmore replied at once, ‘I won’t say what it means to me to give you up to Bertie – but I think you know that you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("by far")]), _vm._v(" the most precious of all my children, & always will be.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#preface-3",
      "id": "pre-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As soon as she entered the Royal Family, the Duchess of York made it a rule never to talk (let alone write) about her new relations, even to her Strathmore family. This discretion was wise and she maintained it for the rest of her life. Nevertheless, her letters to her mother would probably have included more accurate reflections of her thoughts and hopes and fears than any others. Unfortunately few of these letters have been found.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is important to remember that for the first twenty-two years of her life Elizabeth Bowes Lyon was a private individual with no expectation of becoming a public figure, let alone a prominent member of the Royal Family. And after she became Duchess of York and then Queen, she continued to write private letters to friends and family with little thought that they would one day be published. Indeed, one or two of the recipients of her letters said to me, quite understandably, that they regarded their missives from Queen Elizabeth as private and not for publication.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Princess Margaret felt strongly about this; she made little secret of the fact that in the 1990s she ‘tidied’ her mother’s papers and consigned many of them to black bin-bags for burning. These bags, she said, included letters from the Princess of Wales to the Queen Mother. After the Princess’s death in 1997, her mother, Frances Shand Kydd, shredded the correspondence she found in her daughter’s home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everyone is entitled to privacy, especially in a world where far too much becomes too public too fast. In letters, each of us sometimes writes things in haste which, on consideration, we might have phrased differently – and would not wish to see published. Sometimes letters are too long, or too repetitive. I have tried to edit these letters with these concerns in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The vagaries of life have already made their selection of Queen Elizabeth’s letters. Yet so many have survived that the hardest task has been to decide what to discard from the pen of this prolific and talented letter-writer. I can only hope that this book truly displays the great loves – for God, for family, for Britain and for life – which, from first to last, inspired Queen Elizabeth and her writing.")])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ELIZABETH")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘A flashing smile of appreciative delight’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORD")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORELL")])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIZABETH")]), _vm._v(" A"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NGELA")]), _vm._v(" M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ARGUERITE")]), _vm._v(" B"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OWES")]), _vm._v(" L"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("YON")]), _vm._v(", born on 4 August 1900, was the ninth child of Lord and Lady Glamis, Claude and Cecilia. She was followed in 1902 by her brother David, to whom she became exceptionally close. Cecilia Glamis called these last two children ‘My two Benjamins’. They had eight siblings: Violet, born in 1882, was followed by Mary Frances (May), Patrick, John (Jock), Alexander (Alec), Fergus, Rose and Michael. (Violet died of diphtheria in 1893 at the age of eleven, just two weeks before the birth of Michael.) In 1904 Claude Glamis’s father, the thirteenth Earl of Strathmore and Kinghorne, died and he succeeded to the title.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Life for these children was as contented and secure as any childhood could be. In the first decade of the twentieth century, visitors to St Paul’s Walden Bury, their handsome Queen Anne house of rose-red brick in the fields of Hertfordshire, found a bustling, happy household, full of laughter, kindness and a wish to do good in the community.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth’s first biographer, Cynthia Asquith, later wrote, ‘Its atmosphere of a happy English home recalls to one’s memory so many of the familiar delights of childhood – charades, schoolroom tea, homemade toffee, Christmas Eve, hide-and-seek. Nowhere in this well-worn house, one feels, can there ever have been very strict rules as to the shutting of doors, the wiping of boots, or the putting away of toys.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-1",
      "id": "par-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Throughout Elizabeth’s childhood, country-house life continued with little change. White tablecloths were still spread for tea on spacious lawns; field sports, especially shooting, were immensely popular among the aristocracy and their friends.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Years later, in conversation with Eric Anderson, Queen Elizabeth remembered her childhood years:")]), _vm._v(" "), _c('p', {
    staticClass: "ex"
  }, [_vm._v("We were a very big family, you see. I had six brothers. I was nearly the youngest. It’s so nice being brought up by elder brothers. They kept a good eye you know. I was the youngest practically except for one little brother and so we were cherished and also disciplined, which is a very good thing. We all liked each other tremendously, I think. My very elder sister was at the very beginning of the family. She was a long way up. My middle sister was an absolute angel. Everybody loved her. In a way, my generation was very lucky – you feel very safe in a big family. It was a great thing to be loved."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-2",
      "id": "par-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("Cecilia Strathmore was the greatest influence on the household. She was a woman of both gaiety and religious conviction who brought up her children in love of God, love of family and love of country. ‘Noblesse oblige’ may not have been a term she used, but Lady Strathmore certainly impressed on her children that they had been born very lucky and that their responsibility, indeed their duty (an important word to her), lay in being generous to others, especially those less fortunate. ‘Work is the rent you pay for life,’ she would tell her children.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth was from infancy vivacious, loving the company of adults as well as of her siblings. One of her governesses later recalled that she had ‘a small dainty figure, a narrow, finely shaped rather pale little face, dark hair and lovely violet-blue eyes’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-3",
      "id": "par-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An admirer, Lord Gorell,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn2",
      "id": "fn_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" later recalled that she had even as a child ‘that blend of kindliness and dignity that is the peculiar characteristic of her family. She was small for her age, responsive as a harp, wistful and appealing one moment, bright eyed and eager the next, with a flashing smile of appreciative delight.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-4",
      "id": "par-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her brothers were all sent to Eton, but Elizabeth was educated at home by governesses. After lessons, she and David would play together in the outbuildings around the house, and explore the vegetable garden. One governess observed, ‘Lady Elizabeth was adept at crawling under the netting and filling herself with strawberries while lying on her stomach.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-5",
      "id": "par-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("5")])]), _vm._v(" Elizabeth herself recalled the ‘absolute bliss’ of being in the stable surrounded by the smell of horses and leather, bits of which the groom allowed her to polish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Every August, the family travelled to the Strathmores’ Scottish home, Glamis Castle. They would go up by train, with some of their servants, for the opening of the grouse season on 12 August. It was a great adventure for a child – Glamis was a thrilling place, with its tower, its turrets, its history and its myths.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Castle was lit by hundreds of candles – electric light did not come until 1929 – and there were immense fires in many rooms. Two pipers marched around the table at the end of dinner, and then there were games or songs in the drawing room, led by Cecilia at the piano. Lord Gorell wrote later that the family was without any stiffness or formality. ‘It was all so friendly and kind … No wonder little Elizabeth came up to me once as my visit was nearing its end and demanded “But why don’t you beg to stay?”’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-6",
      "id": "par-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Both houses employed many of the local people. At Glamis, the Castle provided employment for inhabitants of the village near by; in Elizabeth’s memory all those who worked there – housemaids, kitchen maids, grooms – were friends of the family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The new century into which Elizabeth was born was seen at the time as a moment of great optimism. Nineteenth-century industrialization had enriched Europe and North America as never before. Railways, steamships, motor cars and even bicycles had created an almost unprecedented revolution in transport. Aged ten, Elizabeth wrote an essay entitled ‘A recent invention, Aeroplanes’: ‘An aeroplane is usually shaped like a cigar, and has a propellor at one end, and on each side the great white wings, which makes it look like a bird [ … ] They are not quite safe, yet, and many, many axidents have happened.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-7",
      "id": "par-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Among her happiest childhood memories were the trips she made to Italy with her mother to visit her maternal grandmother in her various homes in Florence, San Remo and Bordighera."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn3",
      "id": "fn_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Two affectionate letters to her father from Italy survive and one of them opens this collection.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("At Christmas 1909 she was given a diary and for a few weeks thereafter she kept it diligently – ‘Jan 1 1910 – I had my first nevew – great exitment.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-8",
      "id": "par-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("8")])]), _vm._v(" This was John, Master of Glamis, first son of her eldest brother Patrick, Lord Glamis, who had married Lady Dorothy Osborne, daughter of the Duke of Leeds, in 1908.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In July 1910, only weeks after the death of King Edward VII and the accession of his son, King George V, Elizabeth’s older sister May got married. By now Elizabeth had developed her happy letter-writing habit and wrote to May, ‘Darling May-Di-kin’, several times on her honeymoon. And whenever her mother was away, Elizabeth wrote her affectionate letters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth was dismayed when David was sent to preparatory school and then to Eton, but she wrote to him constantly. She remained at home whether in the country or at their rented house in London, in St James’s Square, with a succession of governesses, while making short forays to small schools including that of the Misses Birtwhistle in Sloane Street. She said later that she did not think she learned anything there – ‘A little bit of poetry I certainly remember. So I’m afraid I’m uneducated on the whole.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-9",
      "id": "par-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("9")])]), _vm._v(" In fact her school reports, preserved in the archive at Glamis, show her doing well in English, scripture and history, not so well in mathematics.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Probably the most effective governess was a young German woman, Käthe Kübler, who arrived in 1913. She was struck by Elizabeth’s love of her mother and their shared devotion to the Bible, which they read together every day. But she was shocked by how disorganized Elizabeth’s education had been. ‘With true German thoroughness I drew up a timetable for her lessons and a plan of study, both of which were approved by Lady Strathmore.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-10",
      "id": "par-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("10")])]), _vm._v(" Fräulein Kübler’s work was brought to an end by the outbreak of war on Elizabeth’s fourteenth birthday, 4 August 1914. On that day, everyone’s world changed for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Elizabeth’s brothers Patrick, Jock, Fergus and Michael all marched off at once to war, with hundreds of thousands of young men from all over Europe. Like many great country houses, Glamis and St Paul’s Walden Bury were converted into convalescent homes for wounded soldiers. Elizabeth was told by her mother that her task – her duty indeed – was to make the soldiers feel at home, visiting the wards, talking, running errands, playing cards with them. She did it all with grace and ease. One soldier said later, ‘She was always the same, asking, “How is your shoulder? Do you sleep well? Does it pain you? Why are you not smoking your pipe? Have you no tobacco? You must tell me if you haven’t and I’ll get some for you.” For her fifteen years she was very womanly, kind hearted and sympathetic.’ Everyone in the Castle ‘worshipped’ her."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-11",
      "id": "par-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her closest companion throughout the war was Beryl Poignand, whom Lady Strathmore engaged as her governess and companion in November 1914. Thirteen years older than Elizabeth, Beryl became her best friend and co-conspirator, and Elizabeth’s extraordinary letters to her were full of the joy, excitement and fears of adolescence. Beryl ceased to be Elizabeth’s governess in 1917 but remained a close friend thereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Like so many families, the Strathmores tasted tragedy in the First World War. Fergus, serving as an officer with the Black Watch, was killed at the Battle of Loos in September 1915. Elizabeth and her family, particularly her mother, were devastated. When her brother Michael was reported missing in 1917, the family went through more agony until he was discovered to have been taken prisoner, at which moment she wrote one of her typically exuberant letters to Beryl to declare that she was ‘!!MAD WITH JOY!!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part1-12",
      "id": "par-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her share of wartime suffering did not end with the Armistice of November 1918. Nine months later, one of her closest friends was killed in August 1919, fighting for the White Russian cause. She was inconsolable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By this time Elizabeth was no longer a carefree girl but a mature young woman. She was beautiful, charming, even coquettish, and attracted the attention of many young men. But there was much more to her. She had always displayed great sensitivity, and as a result of the sufferings of her own family and of the wider circle in which she had moved during the war, she had acquired an understanding of human problems, strengths and frailties which was to stand her in good stead in later life.")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 February 1909 to Lord Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Poggio Ponente")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Bordighera")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Italy")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("My darling Father, Thank you very much for the interesting letter you sent me. Yesterday I went down to the sea shore and enjoyed myself very much on the rocks. I could not go far because of the sea, it was lovly? Mother and Auntie Vava"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn4",
      "id": "fn_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" went to Florance on Sunday evening at 7 oclock. There is a dear little donky here called Marguarita and we put it in a little carrage and I drive it is so quiet have got nothing more to say exept it is a lovly garden my best love to yourself good by from your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Xxxxxxxxxxxxx")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oooooooooo")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Cecilia Strathmore’s mother, Mrs Harry Scott, spent a good deal of time in Florence and in Bordighera, on the Italian Riviera. Elizabeth and her mother made several visits there. When in England, she lived at Forbes House, Ham.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: 1 January 1910")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("I had my first nevew great exitment. Same day went to Lady Littens Fancy dress party and had great fun. Jan 2 Sunday – did nothing went to church. Jan 3 lessons in the morning – in the afternoon I went to a party at Kings Walden there was a Xmas tree. Jan 4 had lessons in the morning. At 7 in the evning May, Rosie, David and I went to Lady Verhner in Fancy dress it was great fun, there were proggrams too and supper at half past nine. We went away at ten. It was from 7 to 12.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Elizabeth began her diary on 1 January 1910. Her handwriting was strong and even, but her interest in recording her life waned – as so often happens.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 July 1910 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("20 St James’s Square"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn5",
      "id": "fn_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("S.W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling May-Di-kin,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This letter will reach you just after the one I wrote last night, perhaps you will think it funny me writing so soon, but I have got such a lot more to ask and tell you, that I am writing before I forget it. Aslin has been a donkey, she has been looking in all your draws (I don’t mean what you wear) and was going to send you those fans (you know the ones you told me you were going to leav behind) and all sorts of things, but Mama told her not to touch a thing, except the trousseau dresses and things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David and I are going down to Ham in an hour for Sunday and on Tuesday we go to P.W. [St Paul’s Walden].")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("wasn’t it funny when they showered Sidney and you with rice,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn6",
      "id": "fn_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" how far did you go with the shoes fastened on the motor, the boys told Charles May to stand in front of them so you would not see.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your loving E.A.M.B.L.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Please tell me if I am to call Sidney Darling or Dear.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘We always had cricket week at Glamis. A good many Eton people came and played … it was great fun, it really was. We played the neighbours, my father bowled. We played the Airlies")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn7",
      "id": "fn_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("from next door. Then there was a very good team called the Dundee Drapers.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn8",
      "id": "fn_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("It was easier then. People stayed in the house. I don’t suppose you could do that nowadays. What used to be so good was that lovely weekend in London at Lord’s in the old days when Eton played Harrow. That died didn’t it after the last war?’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 20 November 1910 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Welwyn")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Darling Lovie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to tell you Alec"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn9",
      "id": "fn_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" is much much better. In fact he feels nearly quite well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday afternoon, Furgus made a big oven in the Yew Roundabout. We took down a frying pan, and roasted chesnuts and potatoes. Darling, Mother I do hope that the visit wasn’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" dull. Jockie got up early this morning and went to Holy Communion, he is going with Fergie and us again at 11. Everybody sends there love to You, Father, and Rosie. Please give mine too from your "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 13 December 1910 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Sweetie Lovie Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope Alec is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("much")]), _vm._v(" better. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Please please")]), _vm._v(" don’t worry "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" much about him. We "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" miss you so! Hester Astly has got a party on the 17th of this month, it is a sort of meeting to explain the Childrens Union. If we are not to go please tell Lady Hastings. Outside your bedroom door here there is a long parcel which has the smell and touch of Umbrella’s! May is here and this afternoon we went into the wood with Ferges and her and we got some wild hyacinth bulbs in a place where they will not show. Poor Juno’s right leg is very lame! and her shouldour. I hope you won’t mind lovie, dovie but I took your rain umbrella to church with me on Sunday because it was raining so hard. [ … ] Miss Wilkie has not been here yet, but she sent me a letter to say what she would like David and me to do she said – essays, music, geografy, and sums. Good-bye darling lovie dovie from your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS David’s love and May’s and Furges’s, my love to Alec, Father and Rose.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 December 1910 to Fenella Trefusis")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Neva,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn10",
      "id": "fn_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" very much for the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" box of chocolates. You did not put who it was from, but two or three day’s later Rosie wrote and told me it was you. Is’nt it awful perhaps we are going to have Xmas in London!!!! Think of it "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Xmas")]), _vm._v(" in London. Yours was the first present I have recieved. It was most awfully kind of you to think of us. I have’nt the slitest notion of where you are staying so I am going to look in the Red Book. I am afraid you will hardly be able to read my writing as it is nearly tea-time and the lamps have not come yet. It has been raining and blowing for the last three days.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David send’s his love and wants me to thank you for his chocolates.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye with much love from")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 February 1911 to Miss Ela Collins")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Miss Ela Collins"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn11",
      "id": "fn_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are feeling quite well. We are at St Pauls Walden, and it is a lovely day. This morning David and I got up at 6 o clock.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We first went and let out – Peter, Agiratem, Bumble-bee, Lionmouse, Beauty and Delicate, our six silver-blue Persian kitten-cats. After that we went to see the ponies, then we fed the chickens, there are over three hundred. Then we went to get Judy, Juno, her four puppies, and Major. Then we went to look for eggs for breakfast. After that we had breakfast, then went for a ride. After that lessons till lunch-time. Then lessons till half past four, then we took our tea into the wood and when we came home I began to write this letter. Good-bye Miss. Ela & with")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Love from")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth A. M. B. Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I spent half my life in the stables when I was a child. And of course the groom was one’s best friend who allowed one to sit and polish bits of leather. Absolute bliss.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday 11 October 1911 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Musselburgh")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Darling Precious, I must just write a line to say goodnight and to tell you about the journey. Well about three miles from Perth we heard sssssssss, and we found a tyre had burst. Charles only took ten minutes putting on the other one, so we only just caught the train. We had a very nice journey, but it was very foggy when we got to Edinburgh. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do give Rosie, Father and Alec my love, and a lot of kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good night darling precious lovie duck from your more than loving Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 December 1911 to the Hon. Clarence Bruce"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn12",
      "id": "fn_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear ‘Rotton Tomato’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for the dee-licious peppermints. Its awfully kind of you to think of me. I hope you have had a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" happy Xmas, and I hope you will have a very nice New Year. You know in your letter you put ‘from the Green Tomato’. Well it isn’t ‘Green’ its ‘Rotton’. I haven’t forgotten you in the least. I am afraid I cant write you a very long letter, as I have got so many to write. I hope you are very well. Thank you again very much for the Peppermints.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye, Yours Affec Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Please excuse my bad writing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[With two small drawings of heads, one scowling, the other smiling. Also a Christmas card signed ‘Elizabeth Lyon’, with a piece of dried heather inside.]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 17 February 1912")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("At St Pauls Walden with Rosie, Father, David. Went out riding with Rosie from eleven o’ clock, till three o’ clock. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Great")]), _vm._v(" fun. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Lovely")]), _vm._v(" Day. Sunday Feb. 18 Went to Church with, Rosie, David & Father. Lovely day. Went for walk with R, D & F. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘St Paul’s and Glamis are both very much the same in one’s mind. We loved Glamis very much. Well, I think I stayed in them fifty fifty … St Paul’s is a dear old Queen Anne house – rather lovely gardens – and, of course, in those days very, very villagey. Before buses the villages focused on each other you know. It was very medieval in a way. We all adored my mother who really ran everything. My father, as people were in those days, was rather inclined not to take great part in running the family. He lived more of his own life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: March 1912")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Wednesday")]), _vm._v(" Not at all well. Took some Gregory Powder."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn13",
      "id": "fn_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Grannie and Auntie arrived in the afternoon was not allowed to see them in case I had influenzer. [ … ] Dr Thomas came."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn14",
      "id": "fn_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Felt quite well, a little tired. He said it was just a chill. So I came downstairs and saw Grannie. Michael arrived with his friend Lyonel Gibbs before lunch. They played tennis in afternoon. [ … ] Grannie gave me a little cup. Goodnight.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 10 May 1912 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Preacious Love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you had a good journey to Glamis (kiss kiss kiss). This morning Lady Kinnaird sent me a beautiful little snuff-box of "), _c('span', {
    staticClass: "epub-strike"
  }, [_vm._v("tortashell")]), _vm._v(" tortoisshell inlaid with mother-of-peal and gold. I think I have got a little chill today because my head is aching and I cant write properly. We read the bible this morning about Samson. We have got to do lessons in a minute so my writing will be very bad. David’s bycicle has come, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cant")]), _vm._v(" help envying him. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hot today that its quite uncomfortable, one person in London has already died of the heat. I am missing you dreadfully lovie. Please give Darling Mickie a lot of love and say to him from me ‘Fie! Fie! who forgot the cigarettes’. I think it is the heat which has given me a headache because I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("have")]), _vm._v(" been to the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Ahem")]), _vm._v(". Please give Darling Father my love too. I simply must fly to lessons, but I will write you a longer letter tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("kiss.-kiss.-kiss.-kiss.-kiss.-kiss.-kiss.-kiss kisskisskisskisskiss for you. Ditto for Father & Mickie. Ditto trice for you lovie from your more than loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("XoXoXoXoXoXoXoXoXoX")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 September 1912 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Preacious Love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are having fun at Pauly. Is it nice weather. Yesterday here, it was gloriouse. We went to see Roslin Chapel."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn15",
      "id": "fn_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I took some photographs of it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I never in my life have seen such a beautiful thing the shape, the carving its too lovely. We also went to see some Prehistoricle caves, where Robert the Bruce is supposed to have hidden. I cannot remember the name of the place but I will tell you in my next letter Love. There are huge cliffs on each side of the river, running by the house, and they are finding new ones, and secret passages everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Baby, Sidney and May are very well. I am writing this in bed, before I go and see May to have a cup of tea. I hope you are very well Lovie, and are having lots of fun. I believe we are going to see Nina Balfour"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn16",
      "id": "fn_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" this afternoon, it is about forty miles there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye darling Preaciouse lovie duckie dodulums,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘[My mother] would say, now darling you must look at these two houses, we were passing. One was ugly and one was beautiful in her eyes. So we had to learn. This is the beautiful one, you see, and bypass the ugly one.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl-ns"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 October 1912 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Glamis Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Glamis")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("N.B."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn17",
      "id": "fn_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" Preasious LoveableLove")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you had a very good journey. Please give every kind of message to David.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" bring him up if you can. Lovie I was so sorry to have cried when you went away. I couldnt help it though. Love if you could get something for the dessert for our party do and put it down to Father. I am writing just as I am getting into bed, your train is just passing through Glamis Lovie darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good night Love, I hope David is all right.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("David had started prep school at St Peter’s Court in Broadstairs, Kent, in September 1912. Elizabeth missed him greatly. Princes Henry and George, two of King George V’s younger sons, also attended this school.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: 3–7 January 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("January 1st")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Overeat myself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thursday Jan 2nd")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Headache in the morning. very good tea. Christmas cake, Devonshire Cream, honey, jam, buns & tea. eat too much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Friday Jan 3rd")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Not quite the thing today Breakfast very good. Sausages, kedgeree, Brown Bread, Scones & honey. Excellent lunch – beefsteak – 3 helps – ham and roley poley. I eat a good deal.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Sat Jan 4th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am putting on weight. My waist measurement today 43 inches. Appetite good.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Sunday 5th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Appetite still good, After healthy breakfast went to church. Came back very hungry for lunch. Roast beef, chicken, Yorkshire pudding, Plum pudding, cheese, cake & oranges. Oh, my poor tummy. Just going to have tea. Am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very hungry")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Monday Jan 6th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Quite an ordinary breakfast. No jam today! Rode Wonder in the morning & came in simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ravenous")]), _vm._v(" for lunch. Omelette – two helps of roast chicken, finished up the bread sauce – five chocolate éclairs rium rium. Chocolate éclairs for tea – as no one else liked them, finished them up. Wish I was allowed more supper – always "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hungry by the time I go to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tuesday Jan 7th")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Barrel of apples arrived today – had one for breakfast. 10 am eat an apple. 11 am had an apple for 11 oclock lunch. 12. had an apple. Roast pigeons and chocolate pudding & apples for lunch! 3 pm eat an apple. 3.15 pm David and I fought and have got bruise on my leg because he said I was greedy. eat two apples for supper."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn18",
      "id": "fn_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 15 April 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("At present we are at Poggio Ponente. This evening we are starting to Florence, Mother, Auntie, David & me, by the 7.30 from Bordighera. We are very busy packing. I have got 25 francs to spend, but I can always get some out of the Post Office Savings Bank if I see anything extra pretty. We are only staying till Friday evening.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Wednesday 16 April 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("We have arrived in Florence at about 7 o’clock. We went straight to the Hotel Minerva. It is just next door to the Santa Maria Novella Church. Poor Mother was not feeling at all well, but she came with us all the same. First to the Duomo, then the Baptistry, the Singing Gallery, then we went and had lunch at 11.30 at a resterant. We also went to Cettepassi, and arranged about the pearls. I also bought an old cross, pearls & red stones, it was very pretty £6.0.0, but Mother paid half. In the afternoon we hired an open motor and drove right around Florence, up to Fiesole, where we saw the old roman remains and the Cathedral. It was lovely. 50 francs. In the evening Auntie & I did a little shopping.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 17 April 1913")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Mother was quite well that day. In the morning Mrs Jefferson took David & I to see St Marco’s Convent, where Savonorola was a long time, we saw a lot of Michael Angelo’s pictures. On the way back I bought 4 very pretty old cups & saucers. Then Mother, Auntie [Vava], D & I went to see Meacci,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn19",
      "id": "fn_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Auntie gave us each a picture by him.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very pretty ones, she also gave Mother a lovely one. Then we went back to lunch. Directly after we went to the Pitti Gallery, and then to Canta Gali, David & I each bought 3 plates, & Mother gave us each a pretty blue jar. Then Angelina took us to see Caponi, I love it. After that we met M & A at Jiacosa and had tea.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘When we were children both my grandmothers lived in Italy in the winter, and I just loved Italian things. I had a very clever Cavendish-Bentinck aunt, who took us to the Uffizi in Florence. She only allowed us to look at one picture … it was wonderful. Instead of poor little legs getting flabby with exhaustion, I remember looking at the Primavera. I can see it now. I suppose I was ten. I thought it was very clever of her really.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18 July 1913 to David Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling David")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are very well. We have come down here for good now, at least till you come home. Fraulein"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn20",
      "id": "fn_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" goes to Germany on Tuesday 22nd next. Well, and ’ow are yer, Hay? Boo, you haint no good, you haint woggeling yer tooth. Oi ham. Dur. Whats the good o’ not woggeling. Hay? Aint no good at all. Arthur Duff has given me a new pony. Its 16 years old, but awfully good still. Only 11 more days now [until the summer holidays].")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("HOORAY,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("WHAT HO!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PIP, PIP.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Its a very short time. Everybody’s well. Do write me a letter soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please do Ducky.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye your very very very very very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Xxxxxxxxxoooooooo")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 November 1913 to David Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My darling David,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your delightful pc. I’m afraid Ive been a dreadfull long time writing but Ive been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("horribly")]), _vm._v(" busy, trying to knit Xmas presents and doing lessons.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Only 18 days to the holidays. 2 weeks and 4 days. It’s nice to think about. Mother got two enormous stockings the other day. I do look forward to us two opening them. I suppose next week you’ll write and wish Fergie a happy Christmas and a bright New Year. I really don’t know what to give him Its so awfully difficult to give a man something which he really likes, except guns and motors. Good thought. I might send him a motor. Shall we give it between us? Only a few hundreds! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ta Ta young-feller-me-lad")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your respaactible E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 26 June 1914 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Most terrible goings-on here. At this present moment Fraulein is crying and sobbing in her room, and David is doing lessons with Mr Hewett. They had a dreadful quarrel just before tea, two at lunch, and I really "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("don’t")]), _vm._v(" know what to do. For the last week I haven’t had one single moment of peace, even in my room, and its "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("too")]), _vm._v(" awfull. I cant tell you how I look forward to Thursday, oh it will be nice. I really cant help just one tear now and then. But I do hope you will enjoy your weekend at Ham House, was Bisham fun? Only six more days! Hooray. We are going to tea with Freda Robertson tomorrow Saturday, and Gavin"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn21",
      "id": "fn_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is going to take us out in his motor, one day. Everybody is very well, I don’t know about Fraulein, but I do pity her poor thing, and I’m afraid she’ll go away for good, with a bad feeling against this family, though I believe she quite likes me. I had such a nice letter from Mikie this morning, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" funny, I’m going to wait till I’m cheerfull again to reply to him. Good-bye lovie, from your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday 27 June 1914 to Michael Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mike")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you most awfully for your delightful episal. I was glad to get it, and it made me laugh some, you bet. I suppose you’r moving around pretty slick just now, dinner, balls ect. I hope you are having plenty of champenge, clarit, ’oc, mosel, and baeer, Baaeer, Baaeer, wonderful baaer, fill yourself right up to here (neck). That was by Shakespeare. Oi ad an horful noice toime yesterday playing ’opscotch with Fairweather,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn22",
      "id": "fn_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" oi can taal you he got a talent for ’opscotch.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are coming down on Thursday next, it will be nice seeing you all again. I’ts not very peaceful here! I am sorry to see by your picture that Spicer has’nt been shaving his nose lately, do tell him before I come down. Williams is playing the concertina most wonderfully, it’s really a delight to hear him, he attracts "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("crowds")]), _vm._v(" of people from all round. How’s old Rosie. I hope your health is good. Been to ‘Hullo Tango’ lately? I went to the Alhambra last night, jolly good show. Waal, good-bye Mike old gump, (Mike Gump) Ha Ha I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" call that funny. From your very loving and sweetly Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘The war broke out on my birthday. We went to the theatre and two people in the box were called up and one was a [young man called] William who had been in the Eton Eleven. I can’t remember who the other one was. The streets were full of people shouting, roaring, yelling their heads off – little thinking what was going to happen.’")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Soon after this, Elizabeth went to see her brother Mike off at the station, on his way to war:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘There was a very young little officer going off, and his mother – I can see her now – was weeping. And I remember my brother leaning out of the train and saying “Don’t worry, I’ll look after him.” And do you know, he was killed the next day. It was so awful when one thinks about it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 October 1914 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Miss Poignand"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn23",
      "id": "fn_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother wishes me to write and tell you our address in Herts:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("St Pauls Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Welwyn")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Herts")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She is very busy as we have just heard this morning that my brother Michael is starting for the front at any time, so I expect she will fly down South to say good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please excuse my bad writing, as I’m in rather a hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 August 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Miss Poignand")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very very much indeed for your long and amusing letter, no news of you, comments on my letter, but all the same great fun talking or rather writing about our mutual friends. First I will try and answer one or two of your questions.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We sat in the stalls at the Hippodrome, right in the middle just under the gangway thing, so I got a lot of extra amusement, because you see the actors & actresses all walk along it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("2) Yes, we did have rather an exciting journey up to Glamis, in this way. Two "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("most")]), _vm._v(" beautiful sailors were also travelling in the same corridor. [ … ] We had long conversations in the corridor in the morning, David and I were travelling alonio. Rather amusing, what?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("3) My hat is only a rotton little shiny rainproof one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The soldiers are charming. My dear Miss Poignand you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("are")]), _vm._v(" missing something! One is a fisherman and a Naval Reserve, he has been shipwrecked five times. Blue eyes, black hair, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice. Reminds me of Henry."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn24",
      "id": "fn_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" By the way it’s getting awful. The vulgar and insulting telegrams on my birthday were about darling Henry’s stomach, was it real or a cushion, he was just having his 25th anniversary on the stage & such insults. Really it’s awful. Dear Beautiful One,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn25",
      "id": "fn_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I do so miss him, it was great luck, before I went, he had to pass right under the window so I had a good look at him, he really, honestly (bar rot) is very good looking and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("clean.")]), _vm._v(" You know what I mean by clean, not like Fatty."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn26",
      "id": "fn_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Wouldn’t it be wonderful if Fenella succeeded in getting a photograph of Henry, he would go first place on my dressing table. But I’m afraid he’s too modest to have any published. Father gave me a little horseshoe in pearls and diamonds for my birthday. [ … ] It’s very pretty stones, tho’ it would have been prettier "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" a horseshoe.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must end now, haven’t I written a lot of rot? Can you read my writing? David is yelling for me")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("au revoir, y l")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Glamis became a sort of hospital and St Paul’s Walden was a hospital and we had ward jobs in the First World War, helping a bit in the hospital. Rosie did proper nursing and I only went and played cards with them in the evenings or perhaps wrote a letter or things like that. They all cheated like anything. It was all right – we played one of those games when you can cheat quite easily. There were about fifteen of them, mostly convalescent from the big hospital and I think they were really happy there. Then all my brothers went off. Everybody went. There was nobody left.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 August 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Miss Poignand,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Perfectly wonderful, marvellous, absolutely indescribable news, prepare yourself---------.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lavinia"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn27",
      "id": "fn_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has a first cousin")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("who ------------—")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("KNOWS")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("HENRY")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("VERY")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("WELL!!!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("He is 35 (Hahahoo, Rosie and Mike will be squashed!) & she is going to write & find out the colour of his eyes, & everything, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("also")]), _vm._v(" – get his signature. Isnt it absolutely unbelievable. Darling Henry. I am so pleased. I feel that it was quite worth sticking up for him all this time. Oh my sacred Aunt in pink tights, perhaps we shall even "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("meet")]), _vm._v(" him, help I shall die in a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Friday Aug 27 1915. Spare neither time nor money in procuring a couple of photos of Basil Hallam."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn28",
      "id": "fn_28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("T’is of great importance.")]), _vm._v(" The news of Henry is wonderful. I really do not despair of "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("meeting")]), _vm._v(" or at least seeing him. Oh my sacred Aunt, you wait a few days. You just wait.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From the usual person")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 August 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Miss Poignand")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I will now try to write you a letter with some news in it. (Not so much of the Darling.)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Fergus"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn29",
      "id": "fn_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has been home on leave, only 5 days. He went back on Saturday. Christian and the Baby are both here the baby is going to be called Rosemary.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went to tea with Lady Jellicoe on Saturday last, she lives quite close. She had heard from Sir John who said he thought it wasn’t true about the Moltke"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn30",
      "id": "fn_30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" being sunk, that it was only damaged, but that he wasn’t yet sure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mademoiselle [Lachaise]"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn31",
      "id": "fn_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" went away this morning. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Isn’t it quite too wonderful about Henry. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Please")]), _vm._v(" try and get some pictures of Basil. You know that postcard shop in Regent St we both hunted for? Well, I know where it has now moved to!! Please try there for Basil. Photograph preferred to a P.card. I enclose a plan of where it is. In Piccadilly, same side as Piccadilly Hotel. Nearly opposite St James’ Church. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("The")]), _vm._v(" only place. If they don’t keep ’em they get ’em for you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye Write soon,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the moon turns blue")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 September 1915 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you had a very good journey down, & also David. I miss you both "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" much. I wonder if you could ask Catherine,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn32",
      "id": "fn_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" if she has time, to buy me some hair ribbon like the enclosed pattern as I have none at present? Darling Mother, don’t forget, a little white fox neck thing, a really chic hat, the ‘dernier cri’ in shirts, & a warm winter coat, the newest mode!!!!!! There is nothing much to say, as everything goes on just the same. I am feeling much better. I shall write to David. Please give him lots of kisses from me, and to you. Love to Jock & Neva from your very very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 September 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Miss Poignand")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks for your letters. I will first answer your questions. [ … ] Yes, the Zeppelins did a good deal of damage,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn33",
      "id": "fn_33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Wood St demolished as you say, and a Rubber Factory gutted, also, most of the casualties were from a bomb dropping on to a motor bus. They knew a whole day before that they were coming and yet made no preparations. I hear we have captured a German aeroplane & pilot at Wantage. That’s good. Its quite true. London is full of dreadful rumours. Dardanelles is going badly for us. But much the worst is that Kitchener is going to resign. [ … ] But, Sidney, who wrote about it, says that he does’nt think that this long suffering country would stand that, for they have such faith in K of K."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn34",
      "id": "fn_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I hear the Russians are getting a much better supply of ammunition now, perhaps they will pick up a bit. I am going back to Glamis this afternoon, Oh,oh,oh, Miss Poignand old sport. How terribly you would have envied me. I spent the whole afternoon on the shores of the Forth. So near the ships that I could see people. And a conversation with a most beautiful sailor, with blue eyes and black lashes and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" good looking. That was yesterday. He pointed out all the ships to me. First, nearest the bridge, came the Lion, then Tiger, New Zealand, H.M.A.S. Australia (to which he belonged), Indefatigable, Queen Mary and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("many")]), _vm._v(" others. They looked too fine for words. I simply revelled in ’em. And simply hundreds of beautiful brown Lieutenants, Subs, Snotters [midshipmen], Admirals and sailors. Oh my. They were all most amorous! While I was watching the ships, they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" turned round, it looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice. Beatty’s fleet I suppose.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Love Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 26 December 1915 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Dear Silly Ass")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very much for your letter. Always received with grateful thanks. I wonder if you have left London, anyhow I shall send this to Cheltenham.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, I hope you had a very happy Christmas, and nice presents. Would you like to know what I had?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father gave me a wrist watch, Mother a kettle, Rosie some handkies, David some chocolates, Nurse a box with patience cards, Catherine a hankie, Auntie Vava a picture, Grannie a bowl, May a pair of shoe buckles etc in fact rather nice useful presents. I hope you liked the book. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The men liked the Tree very much I think, they each got an electric torch, a shirt & chocolate & crackers & things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I believe the noise last night at ‘lights out’ was something appalling, trumpets & squeaky things going like mad etc. Abell said, ‘It’s a funny thing, I wanted a bloomin’ cigarette case, and I wanted a blinkin’ electric torch and I got ’em both’! So he ought to be quite pleased. Pegg asked me if you’d gone to Cheltenham. Ernest was simply delighted with his book. Of course we drank ‘To Hell with the b— Kaiser’ last night and good ’ealth to Henry and Larry!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn35",
      "id": "fn_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Nurse gets passionate love letters from Ralph & Co, also from one who signs himself ‘Prince William the Conqueror’. I think he must have got slightly mixed up! ’Ow h’are you my h’only h’adored one? Pretty bobbish??"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn36",
      "id": "fn_36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good-bye, farewell, fare ye well, Tarry not, so long, au revoir good bye farewell etc etc etc etc and so on for 2 pages.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 February 1916 to Mrs Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mrs Poignand"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn37",
      "id": "fn_37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you very much for the delightful cutting about Mr Ainley and your letter. We have now got a huge box of cuttings, photographs and ‘poems’ all about him and we always welcome any addition to the collection! It must be delightful the spring flowers out, we have none up here yet, only Christmas roses and daisies. We all went into Dundee to the theatre there the other evening. Miss Poignand behaved herself in a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("disgraceful")]), _vm._v(" manner, she very nearly got chucked out by the ‘chucker out’! She sang "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so so")]), _vm._v(" loud that the manager came and asked her if she would kindly stop, whereupon, she sang "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("most")]), _vm._v(" aggressively to him (the poor man had a red nose) ‘Put a bit of powder on it’, which is a vulgar song. To crown all that, she drank "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("three")]), _vm._v(" cocktails on reaching home, and had to be carried up to bed by Barson,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn38",
      "id": "fn_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who seemed to enjoy the job!!! I really felt quite ashamed of her! Thank you very much for your wishes about my exam. I don’t really think I shall pass, you see I don’t know much, and I’m most stupid. I think much the best plan would be for Miss Poignand to let her hair down, put on a short frock and do it for me. I should pass & get many distinctions! Don’t you [think]? Yes, she looked too funny for words on the pony, with her legs flapping, & her arms wagging about, I laughed till I nearly cried. But she stuck on all right, which was the chief thing! When we get to London she & me are going to have a gay time, we’re saving up for it. Thank you so much for your letter. Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 March 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Just a little letter to tell you the news from here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I began my examination today."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn39",
      "id": "fn_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I started soon after 8 this morning, and got to Hackney about 9.30! Bus and tram, it’s the only way. I did a ‘memory drawing’ paper, which ended 10.45, so I came back for lunch, & then went back again at 1.30! I did a ‘model drawing’ paper this afternoon and got home about 4.30. Altogether it took 4 hours on journeying from here to Hackney and back again! I’m what you might call ‘slightly fatigued’. The exam place is about the last house on that side of London, green fields beyond, stupid sort of place "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" call it. My cold is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("much")]), _vm._v(" better, but staying in bed, even for only 2 days makes me feel ‘pale’ for a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going down to Eton tomorrow, to see David, May and Sidney are coming. I am taking him an Angel cake, six plums, & one lb of grapes, is that right? I hope that you are quite well Lovie, also Father, Rosie & Mike. I got a letter from Father this morning, what beastly weather you must be having, it’s fairly warm here just now. How are those horrible beastly, disgusting, food-gobbling, hideous, putrid, and above all "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("USELESS")]), _vm._v(" chickens? I have never seen such supercilious and snobbish birds in all my life. I am going to see "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Henry")]), _vm._v(" next Friday when I’ve done my exam, you said I might, didn’t you? I am saying ‘Miserere’ "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("this")]), _vm._v(" Friday but "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("next")]), _vm._v(" Friday I shall say ‘jubilate’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve got to start at 8 tomorrow morning!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("So goodbye darling Mother from your very, very loving Elizabeth ooooooxxxxxxxxx")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("25 March 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother Lovie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very very")]), _vm._v(" much for your letter this morning. Yes, I am very happy to stay another week, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do so")]), _vm._v(" hope you won’t be lonely. I am going down to Slough with May this afternoon, to see her little house, with no roof, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("or")]), _vm._v(" drains "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("or")]), _vm._v(" bath!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then on to tea with David. I am staying the night with her. Lady Airlie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn40",
      "id": "fn_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" got on the telephone this morning, and said ‘when are you coming to see me?’ And I’ve got to go to tea with her on Monday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("am")]), _vm._v(" so dreadfully frightened. I can’t think why she asks me, it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" kind of her but I wish she would’nt. I wish I’d suggested Tuesday, because then Rosie would have been there. [ … ] May is giving me a mauve linen dress by a French dressmaker who was with "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("PAQUIN")]), _vm._v(","), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn41",
      "id": "fn_41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" aren’t I smart?!!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I got a letter from Father, and he said that I didn’t tell him all the little bits of news that I told you, I didn’t think that they would interest him, being a man, but I will write him a really ‘chatty’ one now. I hope he is quite well. I am afraid I’ve failed in my exam, the Geography and Arithmetic were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" hopeless, much too complicated for me! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling Mother from yr very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 March 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie arrived all right this morning, though her train was rather late. We went out shopping together before lunch, she seems very well. We tea’d with May, and had to wait over an hour for a taxi! A terrific gale blowing, sheets of snow and altogether beastly weather. It must be disgusting at Glamis. [ … ] My tea went off fairly well with Lady Airlie!! Only she and Mabel"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn42",
      "id": "fn_42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" were there. [ … ] Lavinia wants me to go to tea, to meet Princess Mary"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn43",
      "id": "fn_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and Prince Albert"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn44",
      "id": "fn_44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" next Sunday. They don’t frighten me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" as much as Queens. I do hope that Father’s cold is better. I sent Mike some papers today, and I’m bringing some songs with me too. Good bye darling Mother, don’t you think I’m very good at writing?! From your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 April 1916 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you will get my telegram about David today. I wanted to go down and see him today, but he said that the doctor didn’t want him to see anybody for a day or two, and he was feeling ‘extraordinarily well’. Also he is leaving Eton Thursday or Friday, and, from his telegrams, sounded very cheerful, so I hope he’s not bad. Rosie is going down tomorrow. I can’t as I’ve got the dentist.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My tea on Sunday with Lavinia was rather frightening – in fact, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(". She had to get a few people to meet them, Princess Mary & Prince Albert I mean. The Duchess of Sutherland (young)"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn45",
      "id": "fn_45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" was there, she’s rather pretty is’nt she? Moucha Cecil,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn46",
      "id": "fn_46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Lady Bury,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn47",
      "id": "fn_47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" Maud Cavendish,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn48",
      "id": "fn_48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" all the Spencers also a Mr Penn,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn49",
      "id": "fn_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")]), _vm._v(" who asked after Lady ‘Rosie’, a Mr Robinson who was very nice, & a Mr Dill.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a table all to myself at tea, with Mr Robinson on one side, & Mr Dill on the other, and I nearly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("burst")]), _vm._v(" trying to think of something to say! Prince Albert was next door, he’s rather nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was photographed yesterday. I am so afraid that you will be disappointed in them, the other photos there were all "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hard but they’re coming tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May took me to the matinée this afternoon. Henry did a most weird and eerie sort of little play. The masks they wore were designed by Dulac,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn50",
      "id": "fn_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who hopped about in brown velveteen the whole time. Henry has got "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("the")]), _vm._v(" most "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wonderful")]), _vm._v(" voice, and he was universally admired. He is so dreadfully shy, that it’s quite painful I believe. Thelma Cazalet"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn51",
      "id": "fn_51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" said that they’de often asked him to lunch and that he was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" shy that he’de accepted, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v(" telegraphed an excuse, poor old Henry!!! I’m so glad as it shows that he is’nt a fast sort of man. There was a delightful orchestra conducted by Sir Thomas Beecham, who played some beautiful music. All the usual ‘matinee’ people were there. The "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("beeeeautiful")]), _vm._v(" siren, Lady Diana Manners,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn52",
      "id": "fn_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Nancy Cunard (???!!!) Duchess of Rutland (white haggard face, red lips and ‘oh oh’ eyes!)"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn53",
      "id": "fn_53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Lady Lytton,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn54",
      "id": "fn_54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" quite pretty, Mrs Bonham Carter (otherwise Miss Asquith),"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn55",
      "id": "fn_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" a beautiful widow, unknown, fast, slightly painted, but undeniably good looking, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the Duchesses, and the Dowager Duchesses, Queen Alexandra & family, & last but not least ME!!! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("And")]), _vm._v(" of course dear Henry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I suppose I’de better wait and come with David on Saturday night? Rosie dined with Marjorie Dalrymple Hamilton last night, Freddy was up for the evening."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn56",
      "id": "fn_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I lunched with May today. Two munitions men were there. The powder factory in Kent blew up, because somebody was walking about, smoking a cigarette, which was the stupidest thing that could possibly be done! Also the Zepps dropped 90 bombs round Waltham Abbey our biggest "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cordite")]), _vm._v(" place, and killed – three chickens! Which was extraordinarily good luck. The damage done by the gale last week is frightful. They say it will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite three months")]), _vm._v(" before the train service is normal again, & every telegraph wire is down. Tell Father they’ll want poles. All ours come from Russia.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, darling Mother, I do hope that you are not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" dull at Glamis. Rosie & I got a few dress stuffs at Harvey & Nichols, I hope you will like them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling Mother from your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 April 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn57",
      "id": "fn_57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ] I shall have to start right now answering all your questions. Two records of Henry have arrived, ‘Sing, Belgians sing’. Mike said, ‘Yes, he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("has")]), _vm._v(" got a beautiful voice’, which was a lot for him! Though of course it doesn’t sound so good on the gramophone. I shall fly to the Haymarket directly I get to London. We must try and go together, because we are about the only two people who "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" appreciate the poor darling! Well, now I have got a bit of news for you. ROSIE is engaged to be married! Aren’t you surprised? to Wisp Leveson Gower! She got engaged last Friday! I know you always want to know everything so I will give you his full address: Commander the Hon William Spencer Leveson-Gower RN."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn58",
      "id": "fn_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" He’s Lord Granville’s next brother. He’s been staying here the last few days, and he went down to London last night, and comes up again tomorrow for about 2 days. They wanted to be married in May, which is in less than three weeks, isn’t it awful. Though as he’s a sailor I hope she will be able to be a good deal with us, when Wisp’s at sea. He’s got a destroyer. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Barson is very well thank you, he’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v(" well! The Nurse is coming May 2nd, and Mother is going to re-open May 3rd. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("All")]), _vm._v(" our soldiers have now left Dundee. Tommy, the Sergeant, & Nicky have been discharged & gone. Pegg has been sent to a New Zealander’s hospital, where I expect he will be happier than in Dundee, & poor little MacGilhuddyreeks goes to a consumptive hospital. I don’t know about Freddy and Stevie, but I think they’ve all gone. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, I must stop now. I will send you one of the dreadful photos of me when they arrive.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Gott strafe Miss Jemima Goodman."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn59",
      "id": "fn_59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Gott strafe Hackney. Gott strafe Dalston Junction, Gott strafe the tapioca pudding (most especially), Gott strafe the whole exam, "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("but")]), _vm._v(" God bless Henry. God bless the shops with his photograph and all the nice things, we won’t strafe them. Shall we say ‘Gott strafe Medusa Poignand, the curse of the Poignands? "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("No")]), _vm._v(", we shall not. We shall say Gott "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("bless")]), _vm._v(" Medusa Poignand, the source of continued worry & anxiety to Elizabeth Lyon, who makes eyes at Fatty & conducts herself in a most unseemly manner.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours forever")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 April 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Little House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Clova")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Forfarshire")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t for one moment imagine that Glamis is burnt or blown up, because it is’nt. We’ve only come up here for the day, to plant & tidy etc. It is the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("first fine day")]), _vm._v(" that we’ve had since I came up from London, the weather has been hopeless. David & I are coming down next Monday if all’s well. He goes back to Eton on Wednesday, & I prophesy that Tuesday evening will be taken up. Most probably ‘Stand & Deliver.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Wisp thinks he won’t be in for a refit anyhow before May 10th, so the wedding can’t be fixed. Rosie & he go down tomorrow. She’s got to get her trousseau, & he joins his ship. I didn’t realise what a lot of things have to be got for a trousseau. I should "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" be able to use "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("2")]), _vm._v(" dozen of everything, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lingerie")]), _vm._v(" I mean, good heavens, I’m thankful to say no. She and Wisp will be very poor. His destroyer is the Comet I think, & he is in the Grand Fleet up North. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All that I say is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("DAMN THE EXAM!!")]), _vm._v(" I always was good at poetry wasn’t I?!! I’m not going to tell "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anyone")]), _vm._v(" about it, anyhow till they ask me!! Good heavings! What "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("was")]), _vm._v(" the use of toiling to that er, place er Hackney? None, I tell you, none. It makes me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("boil")]), _vm._v(" with rage to think of that vile stuff, tapioca, eaten for – nothing? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie will probably be married between the 16th & 26th, some time about then. [ … ] [She] gets all sorts of funny letters amongst her "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hundreds")]), _vm._v(" of congratulations. Lord Curzon called her ‘an unplucked blossom’ [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You remember that Friday (it’s always Friday) the last one I mean, after we’de been with Lavinia, & we had to go to tea with Mlle Lachaise?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We went by tube, & there were two old gentlemen sitting opposite, & they never took their eyes off me for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("one")]), _vm._v(" second, it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" embarrassing. And a little foreigner who heard us speaking French in the lift followed us all the way, & sat next to us, & absolutely "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dwelt")]), _vm._v(" on our words, he simply loved us, & was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")]), _vm._v(" disappointed when we got out!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("To hell with all such people as the Oxford Examiners.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye & behave yourself. A bientot Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘It’s a funny thing working for exams, it doesn’t last very long, does it? I remember working up a history bit or something. It’s awfully easy to forget. I think it’s easier to go round Windsor Castle and learn from that. There’s the whole of history there. From William the Conqueror and the stones coming up from Caen in Normandy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 May 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("[Addressed to ‘Miss Medusa Pinpoint Poynard Poynment Poiggnand Poignand’")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("‘If "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("NOT")]), _vm._v(" away please do "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("NOT")]), _vm._v(" forward.’]")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote you a most beautiful letter yesterday, and now I’ve had to tear it up & begin all over again, as I got one from you this morning! Zut! I mean Phut or Fut or Futte. We arrived yesterday morning from Glamis, quite safely, lots of sailors.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We left father and Barson sorrowfully drinking cocktails. It was 9 o’clock when we left & the sun was setting. I’ve never seen it look "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" so lovely. You see it sets right behind the hills now, & it was yellow & pink & gold, going gradually down to deeper & deeper blue, with a few huge yellow stars. Lordy how pretty it was. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father comes on Tuesday, I expect he will spend his days in the Army & Navy Stores buying toothbrushes & sponges & campstools & such things! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till Henry is no longer our beloved")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 August 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you many times for your charming & amusing letter. I am so glad that you are enjoying yourself at Ramsgate. Did you know I did "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a silly thing! Before I left London I wrote a long & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good poem all about our adventures (very private) and then went and left it in the blotting book in the Morning Room! Fool that I am.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike left London for France yesterday. Damn. [ … ] Admiral Jellicoe"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn60",
      "id": "fn_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came over to tea last week. He’s too nice, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" silly, just like a sailor! We went over to tea with him and his spouse last Friday, that is, Rosie & I. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie went off yesterday to see Wisp. She will be about three weeks away. Mike went the day before, Rosie yesterday, my best soldier friend also yesterday, so I’m in a BAD temper! My ‘best boy’ being the Drummer boy as I don’t know any of them very well. I went & played ‘Donkey’ with them the night before last, at the end there was a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wall")]), _vm._v(" of faces standing round and watching! Oh it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" embarrassing! One has the D.C.M. Most of the men won’t believe him, tho’ he has his ribbon. There are 15 men. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are often getting Zeppelin scares, at least about 9 o’clock they telephone that the Zepps are here or coming, and by 11 all’s well. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother is better thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, good bye, I don’t think it’s at "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("all")]), _vm._v(" proper you pushing soldiers about. I wish you’d met Ernest!! Well old thing "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("BE GOOD")]), _vm._v(" & luck pursue you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 September 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t know whether you’ve heard anything about the fire yet? It’s a beastly nuisance. Yesterday, Saturday at 5.30, we saw smoke coming from the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" top roofs. Nine soldiers & Sister had gone to the ‘pictures’, but the remaining 4 & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the maidservants rushed up and handed buckets like old Billy-o. The more water, the more smoke, we absolutely could "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" find the fire. We then telephoned for the Forfar and Dundee fire brigades.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Before they arrived the little flames were sort of creeping through the roofs, you know – where the tiles are. It was too awful. Before 10 minutes the whole village was down! The former was absolutely "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" use, having only a hand pump. The Dundee one heard at 6 o’clock, & was here in 26 minutes! Wonderful. They had powerful engines, and by midnight most of it was out. But the danger was great, & we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" so thankful when the water started. From 6.30 till about 10 o’c I stood just outside the drawing room door, sweeping down the water. The cistern upstairs had burst and the flooding was dreadful. Four soldiers who were harvesting on the farm helped very well, also people from the village. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("All")]), _vm._v(" the furniture on the top two floors had to be carried down, & I had an awful job trying to find place. The drawing room was full, then King Malcolm’s Room, then your room (Mdlle’s) & the Strathmore Room! Only the very top rooms (where the empty turret is) were absolutely gutted, and the most awful amount of damage by water. It was pouring into the Drawing Room "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" night, and the Chapel is a wreck. All the pictures with "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("huge")]), _vm._v(" smudges, it’s beastly. The Blue Room & Crypt were flooded, & the water didn’t stop till 5 this morning. Everybody was splendid, & my word I do ache!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You see there was none of us indoors, and I had to direct every man bringing down the furniture, also it began to get dark, & I had to get candles. Mrs Stewart commanded everybody, & Mrs Swann was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" flurried, just like a little partridge!! I can’t tell you all the little incidents, but it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" dreadful, we thought the whole place would be burnt. Captain Weir, the Chief of the Dundee F.B said that if the fire had been today (a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("strong")]), _vm._v(" wind is blowing) nothing on earth would have saved the castle. I can’t tell you how unhappy we were, the flames were so awful. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Half an hour after it started")]), _vm._v(", Lady Airlie telephoned to say would we come over if it got too bad, then Hughie Munro to ask us, then the Douglas’s telephoned, then the Fotheringhams, then Lady Dalhousie, all thought the Castle was burnt to the ground. The photographer, Dunn, (our old friend) was here last night, & presented me with postcards this morning. He took the charred remains today. I will send you one or two. Oh Lor, I’ve swept the big stairs the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("whole")]), _vm._v(" morning, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so tired.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the firemen leave (they like this place!)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Two firemen are staying. It broke out again this morning, and wants watching for a day or two.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("When the fire broke out Elizabeth’s father and brother David were shooting and many of the soldiers were at the pictures in Forfar. Elizabeth seized the initiative, calling the fire brigade and organizing the effort to save the pictures and other valuable contents of the Castle. The")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Dundee Courier")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("reported that she was ‘a veritable heroine’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn61",
      "id": "fn_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Her mother wrote to Beryl, ‘Eliz’th was wonderful … Poor darling she was quite worn out after and ached all over for days.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn62",
      "id": "fn_62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 October 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" much for all your charming letters! I hope you are enjoying Richmond. Nothing doing up here. I go to the Ward every evening now. They are very nice. I wrote a ‘poem’ for dear Sergeant Little’s book"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn63",
      "id": "fn_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" yesterday. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("All")]), _vm._v(" by myself. I did it when I woke up in the morning. Sister always teases him about his mental condition, because the poor man put a postal order in the fire by accident, and he does talk rather nonsense! Its rotten!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His mental state, said Sister")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Gives me quite a fright")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He talks such dreadful nonsense")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Morning, noon and Night.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("[ …]")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Though Sergeant Little’s brain is weak")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("His arm is very strong,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He strafes the Bosche like anything")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Here’s Luck to him life long!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("They all thought it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" wonderful! They really thought I had brains! Also I was given the Queen of Spades "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("11")]), _vm._v(" times. I wondered what the terrific joy was about, & I found they’de been passing it under the table to give me! They are such babies! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye swine, write soon to Me")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘When the soldiers came to be nursed or convalesce, were they fun?’")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("asked Eric Anderson.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("She replied:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Oh, yes. And one kept up an enormous correspondence when they went back, you know … one used to hear what was going on, you know. Oh no, they were absolutely splendid.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("25 October 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Mr Dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks for your charming long letter. I was delighted to get it. I’m "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" sorry that you are cold, but you’ll be nice and warm when you die, which must be a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" consolation to you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m feeling sick already. Tomorrow they’ve got one of those – whist drives (pardon me oh), but really my feelings are a bit too much for me! I of course have got to present the prizes, and I shall "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("die")]), _vm._v(". "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("SIXTEEN")]), _vm._v(" huge men, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the Hoggs and Stewarts and oh it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" awful. And not even you to hold my hand. Damn. Ten men go on Friday. I know them quite well now. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote another poem and sent it back by Mother! It was to Harding, who delights in giving me the Queen of Spades! It goes thus – and is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("frightfully")]), _vm._v(" bad!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I sometimes go into the Ward")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And play a game or two;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And if I get the Queen of Spades")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tis only due to you – Private Harding!")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Apparently he is delighted, and Sister said that he and Nix are very haughty now!!! Nix is angelic. I love him. You would too. He’s very small and merry with a golden heart as you might say. Did I tell you that Mother & I were solemnly photographed with all the soldiers?! By Mr Dunn? They all dressed up yesterday evening, and looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" funny. The Glamis Band gave a selection! Twelve sit in a circle and one conducts. The gramaphone in the middle. The dinner horn is tooted, a bell is rung, the melodeon is squeaked, two penny whistles, a penny rattle rattled, a drum beaten, no tune at all, just only as much noise as they can possibly make! The noise is infernal! Poor Mrs Swann sits on a bed with an agonised expression on her face, stoping up her ears! Sister likes it! They are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" mad. Harding was the Queen of Spades!! That was a great joke! Nix was ‘His Lordship’s Jockey’ and frightfully pleased with himself. I believe I’m going to be confirmed on 5th November, and we come South the 7th or the 9th. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye from yours I like whist drives")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 October 1916 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a line to tell you about the whist drive. I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("perfectly terrified")]), _vm._v(" all yesterday, but it wasn’t so bad as last time, somehow. The ‘Housekeepers Room’ people had got it up, and Catherine arranged it nearly all. [ … ] Wilson made a long speech, and then said that he wouldn’t keep them any longer as Lady Elizabeth had a long speech to make!! My face and jaw fell down to the ground with horror! However I didn’t! Harding got the 1st prize, 6 handkerchiefs, Pat Keeney an Irishman got 2nd, & McCleod got Booby. The two Booby prizes were a chocolate Nurse & a chocolate kiltie [a Highland soldier]. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then, we danced! Rosie & I led off with Sergeant Robinson & Gordon. I with Gordon, who waltzed round & round "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("and")]), _vm._v(" round, till I nearly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("died")]), _vm._v(", then thank the Lord his shoe came off, or else I should have fallen down with giddiness! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ten of them went this morning, at eight o’clock. I’ve just waved them off from the Ward window. They were all dreadfully unhappy, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" darling. They say they are all coming back in February.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The little Irishman wished me a merry Christmas & happy New Year!! Williams said ‘God bless you’ and they all said, thank you, very nicely. I do wonder if they caught their train! Because every two steps, they stopped, threw their kit bags into the air, and waved frantically, and of course "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" the kit bags fell down, so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("that")]), _vm._v(" took about 3 minutes to pick them all up. They all enjoyed themselves frightfully last night. No other news at all. [ … ] Well, I hope I shall see you in a couple of weeks. There is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" excuse for you because there are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hundreds")]), _vm._v(" of trains to Richmond and it’s only sixpence. The little tiny funny Irishman said ‘You’ll get a letter from Ireland’. I don’t expect I will!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the moon turns blue")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 January 1917 [misdated 1916] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so sorry not to see you last week but we were only there for the dancing & Wednesday, & left Thursday. David went on Wed. Will you come to a play with me soon? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We might be coming to London in February, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" so. Rosie is going to be painted by P de Laszlo"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn64",
      "id": "fn_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" with the money that the tenants gave her for her wedding. She went to see him to arrange about sitting, and he simply went into raptures about her! He pulled down her hair, & did it up again quite differently, he bent her best hat and ruined it, and said she was exactly like Lady Hamilton you know, [George] Romney’s Lady H. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Too")]), _vm._v(" funny.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Must fly goodbye. Oh, I had two letters from the front Nix and the Fish boy, both amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours till the cows come home. E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 3 May 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a line to tell you we had a telegram this morning to say that Mike is missing on April 28th."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn65",
      "id": "fn_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I don’t know what to say, you know how we love Mike, and it would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" terrible if he’s killed. It’s horrid & selfish of me to write you a miserable letter, but I’m so unhappy, & added to that I can’t help worrying about Mother in London. I thank the Lord that Rosie is there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s dreadful, and somehow I never thought Mike could get killed. If he’s all right, he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be, I’ll tell you. Your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 May 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" much for your letter, it was such a nice letter. It’s so dreadful having to "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("wait")]), _vm._v(", I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish we could hear something. Somehow I never thought anything could happen to Mike, everybody is so fond of him, but one forgets that doesn’t count in a War, but you know I still have a hope that he is all right, because one simply "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("can’t")]), _vm._v(" tell, can one? I think you know, that Mike is the favourite of the whole family, Father’s very favourite son, & you know how Mother adores him, & Pat & Jock too, Rosie & me, everybody. It would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" dreadful if he was killed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m going down [to London] tomorrow night. I’m afraid Mother is in a terrible state, & Pat you know is at St James’ Sq waiting for a [medical] board, & he is very bad too, I’m afraid. I’m "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" sorry writing such a depressed letter, and "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("how")]), _vm._v(" I hope the next one will be mad & full of the usual rubbish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("He said in his last letter you know, ‘If I’m pipped, I think little John"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn66",
      "id": "fn_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" had better have my guns’, and so he knew they were going to have a bad time I suppose. I’ll tell you what Mother’s found out so far. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Ten")]), _vm._v(" officers of the 16th & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("many")]), _vm._v(" of the 15th are missing, and only "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("2")]), _vm._v(" in his battn are wounded, none killed so far. Sidney went to the W.O. [War Office] & found that out. Then May [Elphinstone] asked old Princess Christian"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn67",
      "id": "fn_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" if she’d write to the Crown Princess of Sweden who would find out quicker if he is a prisoner. Princess C "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cabled")]), _vm._v(", so we ought to hear quite soon if he’s a prisoner of war. That’s all we could do. I’ll let you know the "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" minute we hear anything, and thank you again for your letter so much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 22 May 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Ma Chere Medusa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m quite and absolutely stark, staring, raving mad. Do you know why? Can’st thou e’en guess ? I don’t believe you can!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("AM I MAD WITH MISERY OR WITH JOY??")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("WITH")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("!! JOY !!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike is quite safe! Oh dear,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("nearly")]), _vm._v(", nearly burst this morning, We had a telephone message from Cox’s [Bank] to say they’d received a cheque from Mike this morning, so we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("rushed")]), _vm._v(" round, and it was in his own handwriting, & they think he’s at Carlsruhe. Is’nt it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(", "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" heavenly. I can’t believe it, yes I can but you know what I mean, & how awful the last 3 weeks have been.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours madly, Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 October 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your nice ‘scrappy’ letter. I was so glad to get it. How "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("exciting")]), _vm._v(" about your War Office job, I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" glad it’s near us, and I do hope you’ll like it. How beastly the air raids must be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We’ve had "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" an excitement here! The Forfar ‘boys’ came to tea last Thursday, and ours gave them a concert! I got back from Carberry on the Wednesday, & was met at Tay Bridge Station by Wright & Morris, the two "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("angelic")]), _vm._v(" & darling regulars. I do love them – you would too. Morris is a second Twinkley in a way. That evening we had the ‘dress rehearsal’ in the drawing room. Mother was accompanist, and the performers numbered 5. They came in at the door leading to the billiard room, & sang at that end of the room. Of course they were dressed up, & made up. It was "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("too")]), _vm._v(" priceless & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" excellent. About a dozen songs, including a frightfully funny thing of ‘Annie Laurie’. They all five come on and sing Annie L. When they get to the middle, Wright goes wrong. ‘Hi stop, stop, you’re wrong.’ Then to Holley, ‘You’re out of it’. ‘’Oo? Me?’ ‘Yes, you’re out of it.’ ‘Alright, sing it yourself then’. And Holley departs. They start again. At the same place Wright goes wrong & the whole thing is done over again – till he is left alone to sing it. Then comes the "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("supreme")]), _vm._v(" joke of the concert!! He goes wrong again, and this time it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Mother")]), _vm._v(" that’s ‘out of it’! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Yells")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("roars")]), _vm._v(" of laughter. Mother also says – ‘sing it yourself then’ & goes ‘off’. He sings again, & has just got started when Morris comes ‘on’. ‘The stage manager wants to see you’ – & that’s the end of the song. My goodness, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("what")]), _vm._v(" a success it was. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We sing every evening nearly, even "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("me")]), _vm._v(" too!!! Mother plays, & we go through "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dozens")]), _vm._v(" of songs. Last night was Wright’s last night, he went this morning. We shall miss him "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")]), _vm._v(", he is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" darling. When I was saying goodbye, he said ‘I’ll write’. So I remarked what a lot said that & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("didn’t")]), _vm._v(". So, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" seriously he said, ‘I take an oath I will’. We are all great friends – it’s like old days! Waring has black eyes, ’ooo and they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" glitter, it’s quite awful! I amused them most immensely yesterday evening, by singing ‘Wonderful Girl, Wonderful Boy, Wonderful Time’. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cannot")]), _vm._v(" make out the joke, I sang the ladies’ part, & they sang the man’s! I must find out what amused them so. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop, as the post is going – people seem to think Peace is nearer now. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope so.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye my love, & keep safe from these air raids –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very coldly")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("(we’ve had snow here)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 21 October 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your delightful letter,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pleased to get it. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Chapel was well attended this morning, and the hymns went very well. The men are very nice just now, only 10 of them. Yesterday afternoon, Sister, Waring & I went in to Dundee to the War Hospital to see Morris. It is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("horrid")]), _vm._v(" place, dreary and smoky. We found Morris simply miserable. He had lost "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("6lb")]), _vm._v(" since leaving Glamis one week ago, and was looking dreadfully thin and ill. He was buried for 2 days & ½, his chest was crushed, and he can breathe only very badly. He is simply longing to get away. You see he’ll be discharged, (he’s had 13 years’ service, enlisted at 14) & so Mother has written to Major Young. Everybody likes Morris,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn68",
      "id": "fn_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" he’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice, and very upright & honest. He quite depressed us! We took him eggs, butter etc. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There is a terrific gale blowing today. There is nothing thrilling to tell you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 November 1917 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just back from a nerve racking and terrible experience – bidding good-bye to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("FOURTEEN")]), _vm._v(" men! It really makes me weep & a lump in my throat. I can’t bear it ever. And there is such a nice dear Sergeant whom I took a violent affection to yesterday evening, he is so nice tho’ dreadfully ugly. I begged Sister to push him downstairs or give him a blister or something. I wish I didn’t take violent affections too late – it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v(" the day before they go!!! I always have to say goodbye after dinner now, because firstly they go at 7 A.M. and secondly Sister likes to show me off in evening dress, because they never have seen evening dresses which embarrasses me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" dreadfully. They invariably look at my shoes, except the ones that gaze rapturously into my eyes sighing deeply all the while, which are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("nil")]), _vm._v(", nowadays that I have my hair up etc!! Some of them are charming, but oh! the difference from Dec. 1914! I was just remembering this evening, that night when Mr Brookes, Harold Ward, Teddy, David (in pyjamas) & I had a bun fight in the crypt, and David chased Nurse A round the Ward with cocoa & water to pour, & how it all got spilt on the floor, & her black fury!! It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" fun – weren’t they darlings? I have been thinking so much between these lines that it is now 10.15 & I must go to bed. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s so dreadful saying goodbye, because one knows that one will never see them again, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hate")]), _vm._v(" doing it. Do you remember our goodbyes on the doorstep, & waving them all the way up the Avenue? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall come down next week I expect, I’ll let you know the date later. Goodbye from your loving but at the moment depressed –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I remember quite well thinking when I was seventeen I could never be happy again. I mean everybody was unhappy. Because one knew so many people. Every day somebody was killed, you see. It was a real holocaust. It was horrible. I remember that feeling quite well.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 January 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Chere Medusie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("splendid")]), _vm._v(" about your brother’s promotion. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" glad, thousands of congratters. He’s very young isn’t he? I expect you are deeeeeelighted, m’sure. Poor overworked thing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You must come here for a Sunday soon to recuperate. The apple house is overflowing (at the moment), so there will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("something")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother, David & I went up to London for the night on Tuesday, but I hadn’t a moment to ring you up. It was a terrible rush. On the way from the station, we were dropped at the dressmaker, & I tried on my dress. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The next day, D & I were "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("slightly")]), _vm._v(" en retard for breakfast! Then I rushed & had my hair washed (!) (ze leetle naturrral currrls) & rushed all over London trying to get some shoes to go with my dress. Swallowed some lunch, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("just")]), _vm._v(" caught the 1.35!! I was a white haired wreck on reaching here. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh by the way, I had a lecture the other day from Mother & David! That I ought to be more flirtatious! I nearly died of surprise. You know I daresay I’ve got rather quiet from having all those Australians & NZ (!!!) at Glamis, as one simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" sit on them! Wasn’t it funny? And the worst of it was, Major Metcalfe came here yesterday, & I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("absolutely forgot")]), _vm._v(" to try the ’appy ’optic on him!! It would have been such a chance! Never mind, Captain Jebb is coming this evening to stay, tho’ I know I shall be just as mouse like when he’s here!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("did")]), _vm._v(" laugh. Ha Ha.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What I remember of Mr Parker"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn69",
      "id": "fn_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" was one evening at dinner, he asked me if my birthday was between August 1st & 10th or some such dates. I said ‘yes’, & he then remarked mysteriously ‘ah, that accounts for it’. I asked him what he meant, but he refused to disclose the dread secret! However, next morning I made him tell me, and apparently he’d read some book in N.Z., about stars, & dates & calculations & things, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" know the sort of book. It put all the ways of finding things, & apparently he’d worked out that ‘THE’ person for him’s birthday had to be some time between August 1st & 10th!!! Somehow, you calculated between the two birthdays. I laughed, couldn’t help it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" he’s found a charming gurrrrl in N.Z.! That’s the best thing for him. His Father was an Englishman. Everybody liked Mr Parker, I did too, & David did, which was a good thing. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am coming up on Monday, as my dance is on Tuesday (ugh), so if you get this in time, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" come in, if you can get off after tea, & have supper with me. I shall be alone as Mother isn’t coming till Tuesday. So "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" if you can on Monday. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("expect")]), _vm._v(" I shall come up in the morning, so "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" ring up if you have a moment, & perhaps you could come to lunch "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Must fly,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("V loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 January 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing in my bedroom to tell you about the dance, & also why I didn’t ring you up this morning. Well, I trembled all yesterday afternoon! I arrived at Lady Dorothy Wood where I was dining for the dance at about 8.15. The ladies there were – Sybil Scott (Buccleuch), Vere Smith, Margaret Sutton (whose dance it was), a ‘Wood’ girl & Lady Dorothy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The men consisted of Mr Wood (our host),"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn70",
      "id": "fn_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Mr Johnson, Archie Balfour, Count de Grünne & Lord Halifax. I sat between Lord Halifax & Lord St Audries who didn’t turn up. The dance was quite close, & we arrived at a little before 10. Michael Biddulph (Adèle’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn71",
      "id": "fn_71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" brother) was there & I danced with him, Archie, Mr Johnson, a Mr Phillips, Mr Brocklehurst, Mr Ogilvy"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn72",
      "id": "fn_72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" & last but not least little Willy de Grünne."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn73",
      "id": "fn_73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" He dances "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" divinely, & is at the Embassy. I danced every single dance, & Mother came to fetch me, & we departed at about 1.30. [ … ] I enjoyed it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much. One could only dance with such few people tho’ because the dances were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" long, but I loved it, and enjoyed it fearfully. Do you know I think my dress really looked quite pretty. [ … ] I saw Lavinia at the dance, but she had an ugly dress on, & wasn’t looking half as nice as I’ve seen her look, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" so sorry. And Delia"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn74",
      "id": "fn_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" old, but perhaps she was bored or something.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh! When I arrived here yesterday what do you think I found? A letter from –! Yes it was! Mr Parker! He had left England about the middle of November, & so he must have sent that story thing off himself. His letter was dated Nov 29th. He said he had not been able to get off before. The two other New Zealanders who had been at Glamis, were also on board with him, rather curious, wasn’t it? So he must have arrived in N.Z. by now. Ought I to thank him for his letter? Oh dear! it’s so muddling! I expect we shall come up next week, but I’ll let you know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving & perplexed")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 February 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Where are you? Why do you hide away? Why don’t you ring up? Don’t be shy dearie, nobody’s looking & ’ere’s the mistletoe.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh dear I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so worried. You remember I told you that we were having a tiny dance tonight, sort of to ask back people who’d asked me etc? Well, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("millions")]), _vm._v(" of people have proposed themselves & it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("grown")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("grown")]), _vm._v(", & nearly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("everybody")]), _vm._v(" is coming. I really had no idea that the Strathmore family was so popular, it’s awful. And really, people "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" propose themselves rather too much I think. Well, I’m so mixed up. I can’t write but I’ll tell you all about it later. Lavinia is coming. I’ll show you the sort of thing that happened. Mother asked Delia to bring a very few people, & she is bringing "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ten")]), _vm._v(", lots of people are doing that, so it mounts up "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Such")]), _vm._v(" a funny thing happened!! You remember the little Lieut I told you about? (Naval of course.) Well, he rang me up on the phone last night, & we had a I-don’t-know-how-to-describe-it talk. Poor little man, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" sorry for him. You know I’ve got a soft spot in my ’eart for a bhoy in blue, so ’ave you and he was so pathetic! I’ll tell you about it, if it would amuse you, when I see you. And I’ve written four pages to Mr Parker, but I simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can’t")]), _vm._v(" get the last bit in! I wish I could talk to him, it’s so difficult writing, & I know it will just miss him in New Zealand! If you get this tomorrow "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" ring up – I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("might")]), _vm._v(" be here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("These young men "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" worry me so, I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("wish")]), _vm._v(" they wouldn’t. Do come round & give me some more of your sage (?) advice!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" run down & weak, & it will be quite a long time before he goes back to Eton I expect. Dr Thomas examined me ’eart, & said it was enlarged!! I laughed! Couldn’t help it! It sounds "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" funny, doesn’t it? Anyhow I’m not to do much, & I suppose I oughtn’t really to dance! Must stop, I’m all trembly inside me, oh oh – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" ring up if you can. Yours full heartedly (!!) Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I haven’t seen you for years – "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" come.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Mother wants me to ask you this. She has promised to have a small dance for Overseas Officers next Tuesday from 8–12!! Can you come? We could put you up for the k-night. You simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(", it would be such fun. You really must come, & if you have a friend – a young nice-looking one mind, send her along too. If you know anybody who could get home at night I mean. None of these "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("fast")]), _vm._v(" people, my dear Medusa who are corrupting your poor mind, but anyhow "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("you")]), _vm._v(" must come – Pip Pip!!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday 13 March 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear old thing")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" for your amiable letter, ah, what joy! What "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("palps")]), _vm._v(" the mere sight of that wonderful handwriting gives me! Etc etc.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, Mother & I came up yesterday, and Mother went back to St Paul’s Walden this morning, & I am going this afternoon. The reason we are going back, is, that it is Father’s birthday tomorrow, & we must be there for at least a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("portion")]), _vm._v(" of it! We are coming up again tomorrow afternoon, as Lady Portarlington’s dance is in the evening, and I shall probably stay here till Monday. We went to Lady Hastings’ dance last night, it was quite fun. [ … ] Katie was there,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn75",
      "id": "fn_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" looking supremely bored, till I took her up to the top of the house, & we giggled foolishly for a few minutes, then she cheered up!! We got home just before two.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The darling [Elphinstone] children came to tea yesterday. Elizabeth has lost her front teeth, otherwise they are just the same. They "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" so darling. I called Elizabeth ‘Toothy’ at tea, whereupon they all burst into yells of laughter, & food was sputtered all over the place! They’ve got extraordinary senses of humour, and see jokes in the most harmless things! I am going down to Pauly with them this afternoon. I foresee a riotous journey. ‘Let’s draw’. ‘Draw me a cow Peter’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn76",
      "id": "fn_76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" ‘No Peter, draw me a bow wow’. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("You")]), _vm._v(" know! I am writing in bed which is horribly lazy isn’t it. It’s 11.30 so I must get up.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("12.30 Just as I wrote that Catherine came up to say that Lieut. Hamilton was here. I tumbled out of bed, and was dressed in "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("10 minutes")]), _vm._v(". I always like seeing Freddy, he cheers one up so much, because he really is ridiculous! He’s just gone, as he’s only passing through London on his way to Dover, where he is joining a new ship called the ‘Murray’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going to lunch with May so I must ’urry. When shall I see you? "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Do")]), _vm._v(" ring up. I shall be here by tea time tomorrow probably. There is very little to tell you really, so I will now draw to a close hoping this finds you as it leaves me at present in the Pink. (Pretty good, that.)")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall be late for lunch!!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 22 March 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t know "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("why")]), _vm._v(" I start writing letters to you at this hour! I am in bed, & feeling tired after 2 late nights, but not sleepy! I had great fun last night at the Harcourts’. Rather a terrifying dinner first, in which I sat between the Prince of Wales"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn77",
      "id": "fn_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & Count Michael Torby."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn78",
      "id": "fn_78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" It was very nice tho’. As usual I danced the first dance with P.W., I don’t know why, but I usually do! I danced three with him, & several with my faithful friend, Victor Cochrane Baillie."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn79",
      "id": "fn_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" He is very nice, but extremely ugly poor thing. Also Gerard Brassey,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn80",
      "id": "fn_80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" who is very nice, & all my old friends. It was the last dance for some time, so tho’ I enjoyed it very much, I felt slightly depressed at moments. Such a lot of these boys are going out quite soon – in fact nearly everybody I know. I suppose they expect fearful casualties. They are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" young, a great many only nineteen. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good night and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" write soon, and cheer me up for losing my young men. I do hope your brother was well. Your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 March 1918 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope you had a good journey up to Glamis, & arrived alright. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" a bore having to go off & I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" looking forward to your return. I expect you won’t be back till Wednesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I got down here alright yesterday and found the children staying awake for me. Father is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" well, & so far has eaten quite well. I feel very flourishing, tho’ a tiny bit tired, & have been out all the afternoon. It has been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" hot, I couldn’t wear a coat or gloves or flannel petticoat or anything warm! It is too delicious for words.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I enjoyed Lady Harcourt’s dance "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much, tho’ I felt a little depressed, because it was the last dance, & I expect nearly everyone I know will be gone by the next one. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please remember me to Sister and the Ralstons & everybody. I am longing for you to come back Mother darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop as it’s post time. Good-bye darling Mother, from your very very")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 April 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We’ve just come back from Devonshire. It was deliciously warm there, and very pretty. The cliffs are such a wonderful red colour there, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you’d")]), _vm._v(" adore it because of the bathing! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I won’t write about the War – It’s too awful. I heard from Nina Balfour yesterday, that Lord Settrington"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn81",
      "id": "fn_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is reported wounded & missing. I am so sorry, he is so nice, & I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" he’ll turn up alright. So very many are missing now aren’t they? It was snowing hard last night but it’s warmer today! I wonder if Peace will "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" come. I feel as if I never want to go to a dance again, one only makes friends & then they are killed. Don’t you feel depressed lately! But the news is better now, I hear that Foch"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn82",
      "id": "fn_82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is quite pleased. I do hope you’ll enjoy yourself frightfully. V loving E")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Please forgive a deadly dull letter but I am cold, and depressed! Do write soon old thing. The children leave on Monday.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 May 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Dutch House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Dovercourt")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("4 o’clock")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Here is my promised letter. I am still waiting for yours! It is great fun here, tho’ we did nothing till yesterday when we dined with Wisp. My first visit to a warship of any kind at all! We have just come back from lunching & will be shortly returning to dine!!! Well, I’ll tell you all about it. You see we didn’t go before as he was boiler cleaning. We take the train out to Parkeston (5 minutes) and there his motor launch meets us and we go alongside the ‘Scott’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn83",
      "id": "fn_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Then there is a ‘wavy ladder’ (thank the Lord there are ropes each side) and when you get to the top a couple of sailors who salute, and one feels foolish and doesn’t know if one ought to bow low and return their salutation! Then one falls heavily down the hatch (is it?) into the waiting arms of a Sub or (preferably) a Lieut! Wisp’s cabins are most luxurious & beautifully fitted, as of course it is one of the very newest ships. He has his meals in lonely splendour, the Ward room is opposite. He’s got three pipers & they always play during meals which is very nice. I haven’t seen over the ship yet, but hope to soon. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The station master (Syme) at Glamis’ son is still with Wisp. He is a very good looking man, and excellent I believe. He bursts in at meals with Signals, he is Yeoman of Signals. The Sub also yells things in & says ‘Aye Aye Sir’ & altogether it’s fearfully nautical!!! Mess traps. Hatch somethings. Port holes. Cocktails. Aft – Forrard! Etc Etc. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 13 June 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" a swine in St James’ St yesterday. You made me blush like anything! I knew what you were thinking – two couples walking out one behind the other!! We went and had lunch with Freddy at the Berkeley, a very riotous one I assure you! But it was great fun. In the evening I dined with Lord and Lady Powis, a huge dinner party and we danced afterwards till about 1 o’clock. I had several dances with a little American"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn84",
      "id": "fn_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" from the Embassy with such nice eyes. He was so funny and asked me to come to the play with him. I said ‘wouldn’t that be fun’ and he’s coming to tea next week! Oh Lor I’ve gone and been and done it now! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lord Erskine would insist on walking home with me, and whenever I danced with the American he looked furious and whenever I danced with him the American was angry! It was awful. ‘Oh Gawd’ as the private soldier said when he was doing Macduff. I have suddenly taken to blushing again. I do hope it will go soon, it’s such a bore. Oh dear, do write and let me know how you are enjoying yourself, you know I haven’t seen you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("properly")]), _vm._v(" for some time now – I don’t count our midnight conversation last week! Have a very good time. V loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10pm Saturday 21 September 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Thank God – it’s all over! I’ve made my speech, and now there are only the hymns to play in Chapel tomorrow, & I shall be at peace. I’ve really had an awful time these last few days – things "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("invariably")]), _vm._v(" crop up when Mother goes away, and I’ve had "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a lot to decide. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had this sale in Forfar today! I was so sick and frightened and can’t remember anything about it except that I managed to get through my speech without a mistake! Adèle and I were greeted by Mr Tubey, then Adèle, Eupham Douglas & I went up on to the platform with a clergyman on each side of us!!! I was presented with a bouquet! ’Orrible. I am so glad it’s over I feel weak and dithery this evening in consequence! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Pip Pip! I feel so tired, must stop. Goodbye old darling do behave. Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I was brought up like that: “Well darling, it’s your duty” and saying to one’s mother “I can’t”. But you know that, aged seventeen, you’ve got to go and open the flower show: “It’s your duty, darling.”’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 1 October 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many many thanks for your letter – I was beginning to wonder what had happened to you if you’d eloped with —— or some such ’orrible affair! You must be very very hard worked, I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish you could come up here for a holiday. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("would")]), _vm._v(" be so heavenly! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very nice men in the hospital now. We sing in the evenings a certain amount – they love it. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bulgarian news is good isn’t it? I do hope Turkey will be reasonable. What about Peace next Spring?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye old thing, do write when you can, as I shall feel so lonely. R & Wisp also going today, oh why can’t you come?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS We had Holy Communion on Sunday, & 4 soldiers came & Sister. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish you could have painted a picture of them kneeling before the Altar, in their hospital blue with Sister. It really was a beautiful sight, tho’ it gave me a lump in my throat. I keep on thinking of it. Poor dear boys, it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pathetic somehow. You can’t imagine quite I daresay, but it would have made a heavenly picture. The white & silver Altar, & the blue suits with Sister’s white apron & cap etc.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("22 October 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many many thanks indeed for thy charming letter – I am so glad you are having a nice quiet rest at Westgate – it will do you a lot of good.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was just thinking how sad it would have been if I’d never met you! You are my best friend and adviser now – worse luck pour vous! I am writing at 11.30 p.m. and ought to be in bed. I’m in my dressing gown anyway and all ready for bed. The two Aussies are very nice. Mr Williamson is good-looking & very nice; Mr Rohan is tall, fat and merry and also nice. We have great jokes and they are always saying the most complimentary things to me which I take as a terrific joke; so we are great friends. Mr W is really a dear, I am very fond of him – poor boy, he has got a very badly smashed foot and has been very ill. I give them quinine twice a day and feed them up, so I am called ‘Nurse’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday we all drove into Forfar in the wagonette (Rosie is still here) and did lots of shopping. I went with Mr Williamson to try to get a pair of shoes, but he couldn’t get one anywhere near on. I’m afraid he was dreadfully disappointed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well – on Saturday I got quite a good post – two letters and a parcel from France, and one from an Australian!! A very long and really quite interesting letter from my little Canadian,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn85",
      "id": "fn_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" with an iron cross in the parcel. I am so pleased with it – one from Victor Cochrane Baillie – he is coming on leave at the end of the month, and wonders whether I shall be in London – which I shall not. And some photos from this Aussie who had been staying with the Ralstons. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes – what shall we do about Ernest?"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn86",
      "id": "fn_86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" It must be over 6 months since we heard. Do you think he can be killed or anything? I cannot understand his not writing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Here is the post coming – I hear Barson and a crackle of papers arriving? What for me? Nothing? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, there isn’t much to tell you, I must go and give my little boys their quinine and they will say some silly things!! I do wish you were here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good byeee old darling,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("At eleven o’clock in the morning of 11 November 1918, the Armistice was signed and the war ended. Elizabeth was at Glamis and years later would recall the soldiers from the Castle marching happily together to the pub.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘They went straight to the village to celebrate and I think they drank too much. Seats got broken up to make a bonfire and all that sort of thing. I can see them now, all going to enjoy this wonderful moment.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 November 1918 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Thweet Medutha")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ithn’t it thad? I’ve developed a lithp. Do you like lithpth? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mr Williamson, Mr Rohan & a friend of theirs came to tea with me today. They were very nice & so silly, & we yelled songs round the piano after tea. I did so hope you would come in, why didn’t you? I would have liked you to have seen them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel depressed now. Can’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("think")]), _vm._v(" why. No reason on earth. Everything is wonderful. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("So")]), _vm._v(" long waiting for Mike perhaps – see only 241 officers have arrived in a fortnight. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Do")]), _vm._v(" ring up; Mr W has such a funny soft voice. Mr R just as fat & nice & jolly as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Let’s go to a play. Find out what’s good pleeeeese.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 January 1919 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so dreadfully sorry to fly off and leave you in that rude fashion on Friday! We simply dashed off to the station and arrived just as a train full of repatriated prisoners got in. However, [Mike] wasn’t there and we watched five trains in and at last he came at about 7 o’clock. We waited with such amusing people from Kennington and Whitechapel!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike is fairly well and cheerful, it is so delicious having him. He and David are playing billiards at the moment and I am rushing between the gramophone and this here letter! Mike brought a friend with him to stay on Friday, a man called Lathom. He looked very ill and absolutely dazed. He merely sat and looked at the fire. Tho’ he certainly looked much better after a good night’s rest. Poor boys, they must have had a beastly time, they hate talking about it. It was so pathetic at the station, you ought to go and watch a special in from Ripon. Personally I rather loved ‘The man from Toronto’. Did you? Do ring me up as we are coming up tomorrow for two days – must stop. Goodbye darling old thing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Armistice had been greeted with joy across Britain but by the spring of 1919 the country was struggling with the enormity of the sacrifices that had been demanded of it. Three-quarters of a million British people had been killed. At the end of the war millions of people around the world were out of work and at least twenty million are thought to have been killed by the Spanish flu epidemic. Economic output had collapsed. Discontent grew and the siren calls of revolution were heard (and sometimes accepted) across Europe.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday undated [22 March 1919] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("many")]), _vm._v(" thanks for your note. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went with Adèle & her mother today to see the Guards"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn87",
      "id": "fn_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" from the Equitable Insurance Office, in front of the Mansion House, & we saw beautifully. I was so amused recognising all my partners looking so comic & stiff!! You see they had to give ‘Eyeeeeees – right’ for the Lord Mayor. But the awful thing was not a soul cheered. There were millions & millions of people absolutely silent. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Dreadful")]), _vm._v(" feeling. I longed to say ‘Cheer – damn you’ or words to that effect – it was ghastly. But they always get a wonderful reception in the West End, so that might make up. The only time they cheered was for the Prince of Wales, and at the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" end of the procession a Black Maria rumbled along. You should have heard the roars of laughter & cheers – Oh the Cockney sense of humour! They simply doubled up with mirth! After 2 hours of silence this really tickled them! It was too funny going home! We had an electric brougham, & they thought we were some kind of Royalty, & I bowed smilingly, & it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" fun. (New hat.) And going across Berkeley Square we passed three American officers, I bowed beautifully to them with my best smile, & they saluted! To change the subject. Alas! The letter is from a far far worse person than Mr Reynolds or Mr Parker! Do guess. I never had such a shock in my life when I got it. It began by my Christian name & ‘please forgive but what the heart feels, the tongue must speak or the hand write!!’ Darling I loff you – will you be mine – sort of idea – isn’t it orful? When shall I see you? Soon, pleeeeese "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday night undated [6 April 1919] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How goes life with you? The usual beginning! I haven’t seen you for ages – at least it seems like ages to me – I haven’t written that letter to Mr Bagshawe"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn88",
      "id": "fn_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – ‘My dear Vivian, thank you a thousand times – I’ll come by the next boat – till then! Thine E.’ – do you think that would do? Ha Ha!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, last night I gave a play party! We dined at the Ritz & went to ‘Joybells’ – George Robey"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn89",
      "id": "fn_89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" priceless. We must go – It was Neva, Emma Thynne & me, Mike, Captain Keenan & Charlie Settrington. I am writing in bed and am beginning to be sleepy. As a matter of fact I have taken a lot of exercise today! I went out for a joy ride with Charles – (as above). We went down to Walton & had lunch – then went to Box Hill, & went for a long walk – it was a delicious day, quite hot, & there is a most "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("glorious")]), _vm._v(" view for miles & miles. Then we tootled along, & had tea at an extraordinary place, where the waiter winked, & said he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("also")]), _vm._v(" came from London! Then we went back to London, & I had a second tea with Katie. He’s a dear is Chawles, & honestly, just a friend. One’s family always thinks a man must be violently in love with one, which is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" annoying if one is friends. Because there is nothing more pleasant than being friends, & the whole enjoyment would go at once, wouldn’t it, if anything flirtatious came into it? It’s a funny thing, but quite true!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If you have nothing to do one Sunday or Sat – I should go down there, & climb Box Hill – the view is worth it. I should think the bus would go to Dorking for that. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye old darling and do write soon, from your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘You weren’t supposed to go out actually without somebody. I was never allowed to go to a ball unless I went to dinner with somebody, you know, first. An eye was kept. As for being asked out to lunch by a young gentleman, absolutely impossible. Funny how things have changed …")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘But of course it made it frightfully exciting. I remember once creeping out of the house in St James’s Square round the corner into Duke Street and going off to lunch with a very nice young gentleman in one of those horrible little low cars. You know, you whizzed off and had lunch at some pub down Portsmouth Road, came back again. You know you felt so wicked. We were so innocent.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 17 April 1919 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Medusa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter which I was more than pleased to receive – ah!! It’s really simply years since I last saw you – I don’t count Althorp, that was merely a glimpse. Wasn’t it awful? I do hate weddings! I was so annoyed at being drawn into conversation just when I was talking to you and when I came down again you’d gone. And with you all the sunshine (Colonial touch). Little Elizabeth [Elphinstone] is here and I had to chide her! She said to me – ‘Peter I know I am going to enjoy myself – Peter, I’m enjoying myself like the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("devil")]), _vm._v("’. So I said, ‘darling you must not say such things’, ‘but Papa says it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("always")]), _vm._v("’ she said. What can you say? She is such a darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("No – no more drives to Box Hill with Chawles – he probably loathes me by now, people usually do when they get to know me! But it was great fun, & he’s really very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve got a very sore arm from being inoculated! It’s all swollen up and looks ’orrid.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I haven’t answered Baggy yet. Isn’t it awful? Oh dear!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How are you old darling? Very well I hope. I simply can’t write as Mike, Jock & David are having a comic argument in Hertfordshire! Forgive dull letter. Goodbye old darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday undated [31 August 1919] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your angelic letter. I have been very unhappy over poor Charlie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn90",
      "id": "fn_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – he is my only "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("real")]), _vm._v(" friend, & one feels one can never have another like him. He was a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("real")]), _vm._v(" friend, I wasn’t shy of him, and he was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" delightful. It’s a dreadful thing, and his family simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adored")]), _vm._v(" him. He was quite unique, and always said what he thought, and altogether it’s terrible. I think I must have been fonder of him than I realized, because now there seems a kind of a blank – if you understand what I mean? Captain Glasses, Bruces etc are nothing, Charlie was the only one I could just talk naturally to – he was a darling, and I miss him very much. I liked him specially because he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" tried to flirt, or make love or anything like that – which always spoils friendships. Even that day we spent down at Box Hill. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again a thousand times for your letter, Very loving Elizabeth")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("DUCHESS OF YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘If she weren’t late, she would be perfect’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ING")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EORGE")]), _vm._v(" V")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE LONG WAR OVER")]), _vm._v(", people tried to resume their lives despite the immense losses that had been suffered. The grand houses of the land closed their convalescent wards and gradually returned to family and social life. Elizabeth enjoyed her first Royal Ascot in summer 1919 and she was busy ‘in a dissipated way’, as she put it, with many dinners and dances throughout the year."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-1",
      "id": "par-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In early 1920 she joined a house party with the Salisburys at Hatfield House. She remained friends of the family for life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("July 1920 was fateful for her. She was presented to the King and Queen, and on 8 July Albert, Duke of York, saw her across a crowded room at the RAF Ball and invited her to dance. He was reported to have said later that he fell in love with her that night, even if he did not know it at the time. For her the dance was at first less important.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Prince Albert was a sensitive young man who had always been overshadowed by his glamorous elder brother David, the Prince of Wales. Knock-kneed and left-handed, he suffered from serious digestive problems, fear of his father, a stammer and a temper. But he was also devout, sporting, kind and courageous – as he showed when serving on his ship, HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Collingwood,")]), _vm._v(" in the Battle of Jutland in 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By the end of the First World War, George V was concerned at the spread of revolution throughout Europe and was anxious to strengthen the ties between Crown and people. He created the Order of the British Empire to open up the Honours system to the mass of people, changed the Royal Family’s dynastic name from Saxe-Coburg and Gotha to Windsor and encouraged his children to look for spouses at home rather than principally amongst foreign royal families.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In August 1920, only weeks after the RAF Ball, Prince Albert, who had just been created Duke of York, invited himself to Glamis. Elizabeth was nervous, she told Beryl. But the weekend went wonderfully; they played games, sang around the piano, went for walks and laughed a lot. The Prince was entranced by the happiness of all the family and friends whirling around Elizabeth, the free spirit at the centre of the house party. The contrast with the formality of his own family life was intoxicating, and the weekend appears to have persuaded him that Elizabeth was the only woman for him. For her part, she wrote to Beryl that the Prince’s visit had ‘kept us pretty busy! He was very nice, tho’, and much improved in every way.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-2",
      "id": "par-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For more than two years Prince Albert paid devoted court to her. She was far from certain – the prospect of exchanging her carefree life, her friends and family for the golden cage of the Royal Family was not enticing to her. Some of the letters they exchanged throughout this long courtship were painful, showing his unrequited love and her concern, expressed always in the kindest way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally, on the night of Sunday 14 January 1923, after a weekend together with her family at St Paul’s Walden, she accepted him.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIZABETH’S ENTRY INTO")]), _vm._v(" the Royal Family and into public life was an immediate success. King George V, remote and stern with his own children, was at once captivated by her. Queen Mary told her son, ‘You ask what Papa and I think of Elizabeth, well we are simply enchanted with her & think her too dear & attractive for words & you have made a wonderful choice.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-3",
      "id": "par-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Duke thought so too and a few days after their engagement he wrote to her, ‘My own little darling one … This is my first letter to you since you made me such a very happy person that Sunday at St Paul’s Walden & you don’t know what a wonderful difference it has made to me darling, in all ways. I think I must have always loved you darling but could never make you realize it without telling you actually that I did & thank God I told you at the right moment.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-4",
      "id": "par-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The weeks before the wedding at Westminster Abbey on 26 April 1923 became more and more hectic for her. The demands of her new family were considerable. So were those of the public. Newspapers were less voracious than they later became, but they were still insistent by the standards of the day and she found their attentions tiring. But the crowds were thrilled by her and she discovered she could respond to them with ease and with pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The adjustments she needed to make are reflected in her letters. When one of her closest friends, D’Arcy Osborne, wrote to ask how he should address her after she became Duchess of York, she replied, ‘I really don’t know! It might be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anything")]), _vm._v(" – you might try “All Hail, Duchess”, that is an Alice in Wonderland sort of Duchess, or just “Greetings” or “What Ho, Duchess” or “Say, Dutch” – in fact you can please yourself, as it will certainly please me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-5",
      "id": "par-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The night before the wedding she spent at her parents’ house, 17 Bruton Street in Mayfair. ‘Felt terribly moved when I said goodnight to the darling boys & mother. I adore them,’ she wrote in her diary."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-6",
      "id": "par-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wedding address was given by the Most Rev. Cosmo Lang, Archbishop of York, who said, ‘You will have a great ambition to make this one life now given to you something rich and true and beautiful.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-7",
      "id": "par-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("7")])]), _vm._v(" Elizabeth Bowes Lyon left the Abbey as the Duchess of York, the fourth lady in the land. At the end of the day, from her honeymoon home, she telegraphed her mother, ‘Arrived safely deliciously peaceful here hope you are not all too tired love Elizabeth.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-8",
      "id": "par-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OR THE NEXT FOURTEEN YEARS")]), _vm._v(" the Duchess of York became an essential member of the Royal Family, in private and in public. Within the family she was an emollient presence, soothing relations between the King’s children and their father. He was far more indulgent of her than he was of them. As a small example, the King was a stickler for punctuality, but that was not one of the Duchess’s most obvious characteristics. On one occasion early in her marriage she arrived two minutes late for lunch. After she had apologized to him, he replied, ‘You are not late, my dear, I think we must have sat down two minutes early.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-9",
      "id": "par-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of the crucial roles of the monarchy is in the voluntary, charitable world – members of the family have long been associated with different charities, which enormously increases their visibility and fundraising capacity. Quickly the Duchess demonstrated her gift for raising funds and she built up her own long list of charities and other organizations, including regiments of which she was appointed Colonel-in-Chief by the King. She supported them all her life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In July 1924 the Duke and Duchess made a difficult and important official visit to the most troubled part of the United Kingdom, Northern Ireland, riven with tensions between Catholics and Protestants. The trip went well, with the Duchess demonstrating her extraordinary ability to make contact with people. The Duke wrote to his father that she had been marvellous and people loved her. ‘I am very lucky indeed to have her to help me as she knows exactly what to do & say to all the people we meet.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-10",
      "id": "par-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Visits to Scotland were no longer the purely pleasurable family holidays, surrounded with friends, that summers at Glamis had been. Now she had duties, both public and private – and had to spend a good deal of time with the King and Queen at Balmoral. The atmosphere there was formal and other guests were rarely young or enchanting. The Duke and Duchess were always relieved when they could leave for the more convivial atmosphere of Glamis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In December 1924 they set off on a great adventure, a tour of East Africa. This visit had been recommended to them by Winston Churchill, who had told the Duchess at a dinner, ‘You ought to go and have a look at the world. I should go to East Africa. It’s got a great future.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-11",
      "id": "par-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("11")])]), _vm._v(" They left in December 1924; their families were nervous for them. The King warned them not to run unnecessary risks ‘either from the climate or wild beasts’;"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-12",
      "id": "par-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("12")])]), _vm._v(" Queen Mary wrote, ‘God bless you both, my precious children.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-13",
      "id": "par-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("13")])]), _vm._v(" Lady Strathmore hated farewells and so her daughter promised not to come and say goodbye, writing, ‘you won’t worry about me will you darling, as I will take great care of myself in every way, I promise you.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-14",
      "id": "par-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their journey through Kenya, Uganda and the Sudan was a revelation. The Duchess wrote to her mother that their first safari was ‘simply wonderful. The country is quite unlike anything I expected and it is beautiful.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-15",
      "id": "par-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("15")])]), _vm._v(" To D’Arcy Osborne she wrote, ‘I rise at 4.30 (I can hear you say “My God”) & go walking with my spouse and the white hunter who is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("charming")]), _vm._v(" man with an imagination, an accent and a sense of humour. He is exactly what I imagine the Scarlet Pimpernel to be, very slow & sleepy & long, and if he wasn’t so brown he would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("rather")]), _vm._v(" good looking.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-16",
      "id": "par-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later another hunter, Roy Salmon, wrote home of the Duchess, ‘She is awfully pleasant to look at & topping manners. He speaks very slowly but has practically no stammer as a rule though occasionally he does.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-17",
      "id": "par-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("17")])]), _vm._v(" He had no doubt that theirs was ‘a love match’. They each adored the adventure and the release it gave them from the constraints, public and private, of life at home. Soon after they arrived back in England in April 1925 she wrote to D’Arcy Osborne, ‘I am bubbling inside with Africa.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-18",
      "id": "par-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("18")])]), _vm._v(" Many years later she described the journey as ‘Wonderful. Best bit of one’s life.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-19",
      "id": "par-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the morning of 21 April 1926 the Duke and Duchess’s first child was born at 17 Bruton Street. They called her Elizabeth Alexandra Mary. Her birth caused great joy in the family and excitement throughout the land; one newspaper, the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daily Graphic,")]), _vm._v(" wrote that the family’s happiness was shared by the nation and added, ‘The possibility that in the little stranger to Bruton Street there may be a future Queen of Great Britain (perhaps even a second and resplendent Queen Elizabeth) is sufficiently intriguing; but let us not burden the bright hour of its arrival with speculation of its Royal destiny.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Princess was born at a moment of great industrial unrest, which some feared might tip Britain towards revolution. Both the King and the Duke were concerned by the danger of a general strike called by the Trades Union Congress. Dire consequences of social breakdown were forecast. In the event, the strike caused much less disruption than was feared and after only nine days the TUC called it off. The King was much relieved and thought that ‘our old country can well be proud of itself.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-20",
      "id": "par-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("20")])]), _vm._v(" His official biographer, Harold Nicolson, later wrote that people of all sorts saw it as a common tragedy, not a purely class tragedy."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-21",
      "id": "par-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The strike and its cancellation did nothing to alleviate the terrible economic crisis affecting much of the industrialized world through the 1920s and 1930s, but perhaps it showed that Britain could deal with industrial discontent reasonably and thus avoid the totalitarian solutions which were beginning to seem attractive to many across continental Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That summer was a happy one for the family. For the Duchess, the only shadow over her delight in her new daughter was the prospect of a long trip to open the new federal Parliament in Australia in early 1927. The Duke was concerned about that but also about whether his stammer would ruin the many public speeches that he would have to make during the tour. In October 1926 the Duchess persuaded him to visit an Australian speech therapist called Lionel Logue, now practising in Harley Street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Logue recorded his first impression of the Duke as ‘a slim, quiet man, with tired eyes and all the outward symptoms of the man upon whom habitual speech defect had begun to set the sign. When he left at five o’clock, you could see that there was hope once more in his heart.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-22",
      "id": "par-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("22")])]), _vm._v(" In the next few weeks the Duke went many times to Logue, often with the Duchess, and the Australian’s treatment had a superb effect upon his self-confidence; his fear of the trip diminished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Duchess’s dread of it, by contrast, grew, as she contemplated parting from her baby. ‘She is growing so big and is as sharp as a needle, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" well. She sleeps beautifully and has always got a smile ready.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-23",
      "id": "par-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("23")])]), _vm._v(" As the day of departure, 6 January 1927, loomed she became ‘more and more miserable’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-24",
      "id": "par-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("24")])]), _vm._v(" That morning, when the nanny brought the baby Princess down to say goodbye, the Duchess was emotional and so she ‘drank some champagne and tried not to weep’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-25",
      "id": "par-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The trip – the first time the Duke had been asked by his father to represent him on an imperial mission – was gruelling and long but the young couple learned a lot and the voyage was a personal success for both of them. They were impressed by the apparent strength of the Empire and the loyalty of its citizens to the Crown. Their travels gave the Duke confidence in his ability to confront the world and it showed the Duchess that she could support her husband in his public as well as his private life, abroad as well as at home. On their return to Britain, the Duke and Duchess, with Princess Elizabeth in her mother’s arms, appeared on the balcony at Buckingham Palace, cheered by ecstatic crowds in the Mall. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Times")]), _vm._v(" reported, ‘Twice the Duchess, her face radiant with smiles, brought the Princess forward.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Both families were delighted to have their children back after a successful tour, and the Duke and Duchess were overjoyed to be with their daughter once more. The Duke told Lionel Logue that he could now talk to his father without any problem. And the King wrote to Queen Mary saying how pleased he was to have his second son back. He had spoken to him several times and found him ‘most sensible, very different from David’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-26",
      "id": "par-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("26")])]), _vm._v(" The Prince of Wales was charming and charismatic, but the King considered him to be so careless of his responsibilities that he would not allow him access to confidential information. The King was also dismayed that, unlike the Duke of York, the Prince of Wales had shown no signs of wanting to marry and start a family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On 21 August 1930, the Yorks’ second daughter, whom they named Margaret Rose, was born at Glamis. The Duchess soon realized that she had a character very different from that of her elder sister. She wrote to Cosmo Lang, now Archbishop of Canterbury, ‘She has got large blue eyes and a will of iron, which is all the equipment that a lady needs!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-27",
      "id": "par-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Through the 1920s and early 1930s the international economic crisis became chronic. Business failures abounded and unemployment grew almost everywhere. As the Depression bit deeper, charities and other organizations needed more and more help with fundraising. The Duchess’s role in the life of the country grew ever more significant as she took on more and more charities, regiments and other public duties. She found it tragic that so many men would never work again and, calling herself an ‘anti-feminist’, she thought that women should give up jobs so that men could work.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In 1935, despite all that hardship, the people of Britain greeted King George V’s Silver Jubilee with warm enthusiasm. The King and Queen Mary drew huge and happy crowds wherever they went, and so did the Yorks. But over all the celebrations hung still the domestic scourge of unemployment and the international shadow of Europe’s dictators.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Duchess was ill that Christmas with one of her frequent attacks of influenza. She and the Duke stayed at their home, Royal Lodge in Windsor Great Park. Their children were at Sandringham with their grandparents and the Duchess wrote to them often. To Princess Elizabeth she wrote, ‘Mind you answer very nicely when you are asked questions, even though they may be silly ones!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-28",
      "id": "par-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was King George V’s last Christmas. Already weak, his condition worsened through the next few weeks, and on 21 January 1936 he died. It was the beginning of a terrible year for the monarchy and for the Yorks in particular.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Prince of Wales acceded to the throne, taking the title Edward VIII. But it quickly became clear to those around him that he had little enthusiasm for the task. He was entirely preoccupied by the effect that his father’s death would have on his relationship with Wallis Simpson, a divorced American woman with whom he was in love. During the course of that year, Mrs Simpson acquired her second divorce and the King informed his Prime Minister, Stanley Baldwin, that he intended to marry her. When Baldwin took soundings at home and throughout the Empire, it became evident that Mrs Simpson would be widely unacceptable as Queen and he so informed the King.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edward VIII eventually decided to abdicate in favour of his brother Bertie; on 11 December 1936 he did so. To their horror the Duke and Duchess of York suddenly and unexpectedly became King and Queen. He took the name George VI. She wrote to her brother-in-law, the departing King, ‘We are all overcome with misery and can only pray that you will find happiness in your new life.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-29",
      "id": "par-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In their own new lives much was demanded of them. They had to rescue the monarchy from crisis, and convince the British people that George VI would be an effective monarch. It was not easy; Edward VIII had been popular in the country, and there were rumours that the new King’s stammer and shyness indicated his inability to reign. But by the force of their own personalities the King and Queen dispelled the doubts. To the Archbishop of Canterbury the Queen wrote that she could hardly believe the challenge they faced but ‘the curious thing is that we are not afraid.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-30",
      "id": "par-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [9 January 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How are you? Did you get the photograph alright? I have come back today from Hatfield"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn91",
      "id": "fn_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" after a most wonderful party. It really was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" fun, & I enjoyed it so much. The people there were the Cranbornes,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn92",
      "id": "fn_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Monica Grenfell,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn93",
      "id": "fn_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Helen Cecil,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn94",
      "id": "fn_94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Mollie Cecil,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn95",
      "id": "fn_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" Bay Smith & me, Mr Arthur Penn, Lord Apsley,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn96",
      "id": "fn_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" Bruce [Ogilvy], Bobby Somerset,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn97",
      "id": "fn_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")]), _vm._v(" Mr Rex Benson, Count de Grünne, Walter Dalkeith,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn98",
      "id": "fn_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("††")])]), _vm._v(" & Mr Francis Manners."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn99",
      "id": "fn_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡‡")])]), _vm._v(" One day we played tennis in the real tennis house, which was most amusing. Two afternoons we played hockey violently, which was great fun. On Tuesday evening we danced, and ended up by a terrific game of follow-my-leader right round the house, which is immense, under the dining room table & even across the roof!! On Wednesday we went to a dance given by the Aclands, but only stayed till 12, as the Hertford Ball was the next night. I met an extraordinary American at it, and the awful thing was I couldn’t remember his name, & he asked me if I knew it. I guessed Johnson, but it turned out to be Williams. I never can remember names! The Hertford Ball last night was heavenly – bed 4 a.m. this morning!! I had on my new white frock. Several people admired it, which pleased me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("immensely")]), _vm._v("!! Walter drove me here this morning in his car, & I have never been in such danger before! Unluckily we passed all the Brands who are his cousins, shooting, & he got thrilled & waved at them, & each time we swerved wildly into the ditch, & out again. We crashed into the gate here, & I wonder that I am alive. He has hardly ever driven before!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Salisburys are a most delightful family, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" David [Cecil]."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn100",
      "id": "fn_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" He is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" clever, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("most")]), _vm._v(" entertaining. Quite vague like they all are. You must be getting dreadfully bored at hearing all this. Have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" been to any good dances? Do write and tell me. I received a letter from an Australian, also a book of views of NZ from another a box of chocs from Bruce & Capt Glass, but that is all amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope I am coming to London next week & shall see you. David is up at Glamis & Mother is returning tonight. Goodbye old pip, much love from your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 June 1920 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write you a last letter from this darling house, as we leave it for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" next week."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn101",
      "id": "fn_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I can’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("bear")]), _vm._v(" it – it is too dreadful. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" so disappointed you couldn’t come last Thursday – it was all my fault I know – & after all D & P never came & there was only Katie & another girl. I wish you could have come – I waited anxiously by the front door but you never came. Oh alas perfidious one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I suppose you are on your holiday now, I do hope you are really very happy. We are in an "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("awful")]), _vm._v(" state here, moving everything, packing up, & thoroughly upset in every way. The terrible thing is, that we simply can’t get another house, & so we are warehousing the furniture, & trying to find a small house just to live in for a month or so. I’m so depressed old darling, I love every corner of this house. All the funny things that have happened; the Australian dances, our schoolroom where I used to flatten my nose against the window & make eyes at the Beautiful One – (& "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" to Fatty) the stairs we used to race up, the spot where Capt Glass"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn102",
      "id": "fn_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" proposed, the room I got Mr Bagshawe’s letter in saying ‘will you marry meh?’, the place you looked over the banisters when your brother returned suddenly from France – our dinner when all the food was on the floor with Wellsie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn103",
      "id": "fn_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & Lavinia, our heavenly repast of roast chicken after the first time we saw Henry ("), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" it him or was he not there?), the glass Uncle Freddy rubbed when he came to tea, oh & thousands of others. Do you remember them all? This house has more old associations than nearly anywhere. I will write & let you know directly we get another house.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going to stay with Nina Balfour for Ascot next week, but I am not particularly looking forward to it! It rather frightens me. I do hope you are really enjoying yourself, do write & tell me how you are & what you are doing. Did you see that ghastly picture of me in the Sketch? Oh!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Must stop, I have been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" busy lately, & I had to write & tell you the last news.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 13 July 1920 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("90 Eaton Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("S.W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been trying to write to you for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ages")]), _vm._v(", but you can’t imagine the busy time I’ve been having lately. Mostly gaiety I’m afraid! First of all, thank you very very much for your letter. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so glad you have got another month [of holiday], I’m sure you needed it badly, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope it will do you a lot of good. We have taken this house for a few months furnished, & it is very ugly but quite comfortable. I miss St J. Square terribly, & very nearly as much, I miss the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("locality")]), _vm._v(". Isn’t it funny? But the traffic & people are so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("deadly")]), _vm._v(" here, & one can’t pop round to Mr Harris [chemist in St James’s Street] or Mr Bottom [newsagent at 32A Duke Street] or anything nice like that.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went down to Henley – stayed with the Hambledens"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn104",
      "id": "fn_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" at Greenlands for it. It pelted the whole time, but it was quite fun. Then on Sunday we motored up to London with Geordie Haddington,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn105",
      "id": "fn_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & Mother & I went up to Carberry that night for the King & Queen’s visit to Holyrood.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May & Sidney had a large party, all over 60, including the Duchess of Roxburgh & also Montrose, Lord Mar & Kellie, Lord Balfour, & a few other rather Royal people! We dined with the K. & Queen at Holyrood on the Monday. It was really quite fun. I was taken in by the Lord Justice General! & had the Admiral Commanding at Rosyth on the other side!! They were very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("On Tuesday I was formally presented, & on Wednesday there was a garden party. We came down on Wednesday night! On Thursday [8 July] I went to the R.A.F. Ball at the Ritz. It was really most amusing, & there were some "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("priceless")]), _vm._v(" people there. All the heroes of the Air too. I danced with Prince Albert who I hadn’t known before, he is quite a nice youth. Then on Friday & Sat. the Eton v. Harrow. That was really "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" fun. I loved it, & it was so nice having David back. He returned to Eton yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie is still in Malta and can’t get home. I believe she is very well though. Mother and I are going to ‘Mr Pim’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn106",
      "id": "fn_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" this evening. Have you seen him? By the way, ‘At the Villa Rose’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn107",
      "id": "fn_107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" sounds rather melodramatic! We must go. Do write again and tell me how you are and if enjoying yourself goodly. Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday undated [14 September 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am now completely exhausted from our Forfar ball party. It was really great fun, & we were about 20 altogether, & I’ve never done so much before in my life! We dressed up, & ragged about, & now that the hard tennis court is finished, we played all day. The people were Katie Hamilton, Doris Gordon Lennox,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn108",
      "id": "fn_108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Bettine Malcolm,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn109",
      "id": "fn_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Katharine McEwen,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn110",
      "id": "fn_110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" Diamond Hardinge,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn111",
      "id": "fn_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" Grisell Cochrane Baillie,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn112",
      "id": "fn_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")]), _vm._v(" Hilda Blackburn"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn113",
      "id": "fn_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("††")])]), _vm._v(" & us. Also Lord Doune, James Stuart,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn114",
      "id": "fn_114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡‡")])]), _vm._v(" Lord Gage,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn115",
      "id": "fn_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Victor Cochrane Baillie, Jock McEwen,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn116",
      "id": "fn_116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Sir Richard Leighton,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn117",
      "id": "fn_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Prince Paul of Serbia"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn118",
      "id": "fn_118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" & David & Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The most awful thing happened. Victor proposed to me the night we all dressed up! He looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" awful with great black smudges all over his face! I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("did")]), _vm._v(" hate it! Don’t tell anybody.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Still a few people here, must fly & dress for dinner. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Much love, & again a thousand thanks")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘People were always popping the question. I remember somebody proposed to me at a fancy-dress ball at Glamis, and I remember his face was covered with black paint. He was sitting next to me and proposed and I remember saying “No, thank you very much.” And when one turned them down, he’d say, “Oh, I thought you wouldn’t.” So that was all very nice and lighthearted, really, I think. Occasionally there was a very serious one. He used to go away to America or something, you know.’")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("These last remarks referred to James Stuart.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday undated [23 September 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How is life treating you? I haven’t heard from you for ages, do write soon. I don’t believe either, that I’ve seen you for about 4 or 5 months! I hope you are feeling quite well again. I am writing in bed as I’ve got rather a cold, & am now utterly exhausted after 3 weeks of entertaining people! Last Saturday Prince Albert came to stay & that kept us pretty busy! He was very nice tho’, & very much improved in every way."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn119",
      "id": "fn_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Princess Mary was staying at Airlie to review Girl Guides – she dined here on Saturday, and we danced afterwards till 12. Lady Airlie, Dit, & her Lady in Waiting, Lady Joan Mulholland came too. The people staying here, were Katie, Doris Gordon Lennox, Helen Cecil, Venetia James, Lord Carnegie, Lord Doune, Tom Bevan & James Stuart besides our family.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Albert proposed himself & seemed to enjoy it all! Princess Mary came to Chapel on Sunday & afterwards I showed her & the Duke round the Castle, & terrified them with ghost stories! We also played ridiculous games of hide and seek, they really are babies. She didn’t leave till 6.30, & then we all played General Post and Flags etc till dinner time – I had played tennis all morning, so you can imagine how tired I was!! We sang all evening – & it was all quite fun. Poor P. Mary really did enjoy herself – she is most awfully nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("So you see we have been very busy lately, & are at last going to have a little peace!! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop, do write soon. Have you been to any dances since your return?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday undated [?November 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("90 Eaton Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Why")]), _vm._v(" did’st thou not come this evening Medusa?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As a matter of fact our "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Bert")]), _vm._v(" stayed till 7, talking 100 to 20, or even 200 to a dozen.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just off to a smart dance, & I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("know")]), _vm._v(" I shan’t know a soul, & will be miserable. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" see you some time – when on earth can it be? I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish he hadn’t come this evening, but I simply couldn’t stop him, & I am longing to see you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday undated [13 December 1920] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Albert")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I am looking forward very much to Mrs Ronnie Greville’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn120",
      "id": "fn_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" party – though the thought of it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terrifies")]), _vm._v(" me! I haven’t been to a proper dinner party for months and months, and have quite forgotten how to behave! I expect it will be great fun though. Have you been very gay? Dancing every night I expect –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Only a short note, as Wednesday is so soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am Sir, Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 December 1920 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Albert")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for the lovely little box, which I simply love.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" so nice of you to think of giving it to me, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" many thanks. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pretty, and will help to ornament my sitting room in Bruton Street next year. I was so sorry about the dance on Tuesday, but my mother has really been very ill, and I couldn’t leave her.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She is a little better now, which is a great relief. Did you enjoy Lady Evelyn’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn121",
      "id": "fn_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" dance last week? I loved it, tho’ I enjoyed ‘your party’ at Mrs Greville’s even more. I feel I shall not be going to another one for months, which is dreadfully sad. I lead such a deadly existence here, that there is simply nothing to tell you – oh except that I have just fallen into a pond! The only event which happened for weeks!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will have a very merry Xmas, & I send you all my very best wishes for 1921. I hope it will be a very happy year for you. Thank you again a thousand times for the darling little box – I do love it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am Sir,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 January 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Albert")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter, which I received on return from my ‘round of gaieties’! I am so sorry to hear that you have been ill, and hope you are really feeling better.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am a complete wreck still, as on Friday night I went to bed at "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("6 o’clock")]), _vm._v(" – an unearthly hour, after the Southdown Ball which was great fun. My brain refuses to work – hence a dull letter! About luncheon on the 17th. It would be delightful if you could come – the only thing is, would you mind having it alone? Not alone by yourself I don’t mean (it sounds so funny that, as if you would have it in one room, and me in another!!). But you see my mother has been very ill, and she & I are really only having a sort of picnic down here by ourselves, and I am afraid you would be bored to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("tears")]), _vm._v(". It would be delightful if you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("sure")]), _vm._v(" you wouldn’t mind not having a large luncheon party? Please do say if you think you might!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" a small house, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" ghosts like at Glamis!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There is a signpost just before you reach a village called Codicote, beyond Hitchin, with St Pauls Walden on it, and then you keep to the right all the way, till you come to a tumbledown old gate on the left. Then you go up a bumpy road full of holes, and eventually reach an even more tumbledown old house, and a tumbledown little person waiting on the doorstep – which will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ME")]), _vm._v("!!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But do come if you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" don’t mind having luncheon with my mother and me, or would you rather put it off till we come to London? "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Whichever")]), _vm._v(" you like best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am Sir,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely, Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 February 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write one line to say how "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")]), _vm._v(" sorry I am about yesterday. It makes me miserable to think of it – you have been so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" nice about it all – please do forgive me. Also "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" don’t worry about it – I do understand so well what you feel, and sympathise so much, & I hate to think I am the cause of it. I honestly can’t explain to you how terribly sorry I am –, it worries me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much to think you may be unhappy – I do hope you won’t be. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Anyway")]), _vm._v(" we can be good friends can’t we? Please do look on me as one. I shall "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" say anything about our talks I promise you – and nobody need ever know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thought I must just write this short letter to try & tell you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("how")]), _vm._v(" sorry I am.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Prince had invited himself to lunch with Elizabeth for a second time at St Paul’s Walden Bury on 27 February. Evidently he had proposed to her but she had turned him down.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 March 1921 to Jock Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Jock")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your letter which I loved. I will speak to Bragger about the cricket pitch, and being a young man of remarkable perseverance I feel something may come out of it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It sounds too delicious at St Jean, it has also been too lovely here ever since you left, but today the weather broke up – alas!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did not take what you might call a violent fancy to Sir P[hilip]. Sassoon;"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn122",
      "id": "fn_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" he was merely rather amusing to talk to, and I like talking to people who have got quite different points of view to the usual run of men. Perhaps not very "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("elevating")]), _vm._v(" ones, (points of view) but très moderne (French).")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now I have a momentous piece of news for you. Over the page now! Ha ha.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("No, it isn’t what you thought it was going to be – so Ha Ha again. It is, that I was IN MY BATH, by TEN MINUTES TO NINE this morning. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Can you beat it?")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thank you in advance for your kind congratulations. Merci, and likewise danke schön.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The tennis lawn is a vision of beauty – green velvety turf – I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("don’t")]), _vm._v(" think. But it really is rather good now, but you bet it rains all summer. I have just been immersed in the ‘Saturday Evening Post’, and consequently start all my sentences with ‘Say, listen’! And very nice too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Wasn’t it nice Gee"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn123",
      "id": "fn_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" getting in at East Woolwich, and Ramsay MacDonald"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn124",
      "id": "fn_124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" failing? I was really pleased. We are going up to Glamis for Easter I believe, which falls fairly soon – I suppose you will still be abroad. Do you approve of the idea of me becoming a royalty? What ho!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to the accompaniment of the squeaking of rats, melodious and soothing to a degree; and the patter of their little feet in the walls calm my troubled brain – the little darlings. Bless them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ah Jock! How seldom we remember the vast debt we owe to the rat – his winsome winning ways, and always fresh humour which helps us so in the daily battle of Life. Ah! how small the world is; As Virgil says ‘Tempus fugit,’ or as Homer aptly has it – ‘Nil desperandum non lapsus linguae’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn125",
      "id": "fn_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, so long Bro, guess I’m off to pound the pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving Buffy"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn126",
      "id": "fn_126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 April 1921 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I haven’t heard from you for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("years")]), _vm._v(" fickle Beast. I am longing to hear, so take up your pen oh Medusa, & forthwith set down on paper all your doings & thoughts for the last month. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bad times my dear M, but I love the calm way the British people take it all! Nothing but talks of Revolution & Ruin,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn127",
      "id": "fn_127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" & yet everybody moons along in the same old way, except that the ‘Boys’ join anything they can.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike has joined something, and goes to Hertford tomorrow. Very bored, but I suppose he’s right. I do hope all that won’t be needed, & that something will be arranged. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father dashed off to Glamis yesterday to raise volunteers – he & Barson flew off with great celerity!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother & I have been here since Xmas now – isn’t it extraordinary? I am longing for ‘17’ [Bruton Street] to be finished, and then you must instantly come & see it. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can’t")]), _vm._v(" write a decent letter. I feel just like I used to on those hot days during lesson time, when I used to lie on the bed upstairs – do you remember? And those delicious suppers of chicken, green peas & strawbugs, when we used to cheer up considerably! Good old days – I feel much older now, I suppose I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" a few years older!! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Write")]), _vm._v(" From your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Curse strikes.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday undated [18 May 1921] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Bicton")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("East Budleigh")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Devonshire")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for your letter I was wondering what had become of you! The party here has been great fun, and I am leaving today. We played tennis & lazed about, & occasionally did a few official Prince of Wales things and had great fun."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn128",
      "id": "fn_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ] The Prince was away all day working hard, & only got back at tea-time – he does have a hellish life – that’s the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" word for it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It has been the most perfect weather here. I am going on to Dawlish to see my aunt [Violet Cavendish-Bentinck], & returning to London tomorrow – & then to Paris when Lord Hardinge"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn129",
      "id": "fn_129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" makes up his mighty mind to go back! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday 28 May 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("British Embassy")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Paris")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your letter has only just reached me here, and I telegraphed a reply which I hope you will understand! It is so nice of you to ask me to play tennis, and I would have adored it, but I am rather far away unfortunately, in the land of ‘ou la la wee wee’! So far the only French I’ve had to use "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" ‘oui oui’ or ‘non non’, both quite useful. I am having great fun here and last night escaped from the Embassy, and went out to dine with Paul of Serbia; & Walter & Mollie [Dalkeith],"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn130",
      "id": "fn_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who were spending two nights in Paris. It was such fun, and delicious seeing Mollie again – also it felt very odd being chaperoned by her! She & Walter were both very flourishing, and they left this morning which was very sad. We danced at Ciro’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn131",
      "id": "fn_131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" until it shut, and then went on and danced at another place where Leonora & Maurice"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn132",
      "id": "fn_132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" were dancing; and chucked little balls at everybody!! It was all so funny.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going to stay here quite another week I think, as London is so dull now, and this is amusing. Are you going to Ascot? I know you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" it!! I am going from Bisham, but don’t think I can stand more than two days of it – probably Tuesday & Thursday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do wish I could have come tomorrow, and again many thanks for asking me,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 June 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("British Embassy")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Paris")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter – I am so sorry to have been such ages answering – I was trying to find out about the Sunday 19th. My sister will not be down in Surrey that week-end, which rather knocks the ‘strawberry feed’ on the head! I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you have made other plans by now – it is unfortunate, that Sunday is no good, and I really "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" sorry to have been so long letting you know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There was a tremendous ball here last night, and I am in the last stages of exhaustion!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("They dance the Tango a great deal out here – rather an amusing dance I think. I danced it with a Russian called Constantine Somebody the other evening – I never found out his other name! It was so funny, one is suddenly hurled into the air, & then bounced on the floor till one is gaga, ooh la la! Very painful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I expect I shall see you at Ascot some time – do you think there will be any dances in London? I hope there will be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v. sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday undated [18 July 1921] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("6 Upper Brook Street"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn133",
      "id": "fn_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I would love to play tennis on Thursday, tho’ I find I am getting worse & worse! I am sure you will all be far too good for me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thought you were coming to tea tomorrow, and will continue to expect you unless I hear to the contrary. Is that alright?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("After you left the Grahams’ dance the other evening, my French friend got fearfully excited when they played ‘Mon Homme’, and threw me into the air, uttering short sharp cries! I think he was mad!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 August 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for writing to me on my birthday – it was very nice of you to remember it. I love the book too, and they really are very amusing some of the verses, aren’t they?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Welbeck"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn134",
      "id": "fn_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" was great fun – an immense party of about 36 people, and we played tennis violently all day, & danced violently all night, so I’m now even more of a wreck than I was! They had a band from London in the house, and the party was very nice, so it was very amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you been enjoying Cowes? It was as if it might be such fun, and I hope you are feeling quite well again now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your Boys Camp was a great success wasn’t it? I hope so anyway, as it is such an excellent idea, and a wonderful thing for the boys.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you seen the Bisham photographs? Nina has just sent me a terrible one of myself sitting between you and Arthur [Penn]! I am simpering in the most awful way – I do hope it’s only the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is rather cold up here, and the tennis court has been ruined – isn’t it sad. ‘ou la la oui oui’, and likewise ‘ci-ci’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes, this summer has been great fun, and I’m so glad you enjoyed it, and that we are such friends after what happened. It was very hectic, & I feel tired out, don’t you? You are coming on Sept. 24th, n’est-ce pas?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 October 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your delightful letter I got this morning. It was so nice of you to write like that about mother, and I can’t tell you how touched I was.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The operation itself was very successful,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn135",
      "id": "fn_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and the doctors are quite satisfied, but she has been terribly ill these last two days, and it has all been too awful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("However, she had a very good night last night, and I really think she is a little tiny bit better today. The only real worry is her intense weakness, but I am so grateful that the operation was successful, and have great hopes that she will improve today. Of course it was a terrible handicap her already being so weak when it was done.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m afraid this is a very depressed letter, but you know, it is such a relief to write about it, & does one so much good, that I hope you don’t mind.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m afraid I must have made a lugubrious hostess last week, but I enjoyed having everybody here, and I only hope that it wasn’t too depressing for you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shouldn’t worry about your shooting, it was just bad luck that you happened to be ‘off’, and I’m sure next time you will be back in your old form. It must be infuriating when one is a good shot, to have off days like that, but I bet you will be shooting like a book the next time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will have fun riding, and find that you like your new horses – aren’t you longing for the hunting to start?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Shall I write a little later on, to let you know how my mother is? You are very sympathetic about it all – worry "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" awful isn’t it? I am really much happier today tho’, and I will write you a more cheerful letter soon & tell you how she gets on.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again for your letter, it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a help to have the sympathy of one’s friends on these occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 October 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks for your letter – do you know my mother is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" better today, isn’t it wonderful? The doctors are quite satisfied, and I feel she makes good progress now. It has been a ghastly week, and now the relief is so intense, that I don’t know what to do!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She is still of course terribly weak, but everything is going well, and I’m so pleased. It was nice of you to take so much interest.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What is London like at this time of year? Do you go to dozens of fast little parties, or just do nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The heat sounds too depressing – it is cold, rainy, windy, foggy, misty, & everything that is beastly here – but "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" don’t care! I’m so happy at the moment that nothing matters.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m not really in a fit state to write a letter – it can only be pure drivel, so I hope you won’t mind. The grim and doleful Gomm is standing by me waiting for the letters. His baleful eye is fixed furiously on me, and I am beginning to feel quite nervous. The post ought to be going he says, so I must finish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother will get well now I’m sure, & many thanks for your letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t lead too fast a life in London, & above all don’t have anything to do with ‘FASTY’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn136",
      "id": "fn_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – she’s dangerous."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn137",
      "id": "fn_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 December 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was just starting to write to you for your birthday, when I read in the Morning Post that it was on Wednesday. I am so annoyed, as I thought it was tomorrow, and now it is over, and I shall have to wish you many happy returns of the day before yesterday. It was very stupid of me, as I remembered your birthday several days ago, & had it firmly fixed in my mind that it was Dec: 17th! Anyway, I send you lots of good wishes, and a very happy and successful 26th year. This is an impossible place to buy presents in, otherwise I should have bought a large and magnificent offering. The only thing one "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" buy are bull’s eyes – very sticky, and they won’t travel!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All best wishes,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [December 1921] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a line to wish you a happy Xmas, and a wonderful New Year, full of everything delicious & joyful. I am not quite sure where you are, but will send this to York Cottage."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn138",
      "id": "fn_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Please forgive pencil, but I am writing in bed with a chill or flu or something.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your delightful present has "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("just")]), _vm._v(" arrived as I write!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I simply cannot thank you enough, it is the most darling little clock, and I simply love it. Thank you a million times – you should not give me such a lovely present. It really is too pretty for words, and besides being pretty is useful too. I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("enchanted")]), _vm._v(" with it. Also that is an excellent photograph of you – I wish I had got something to send you too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All good wishes, & good luck")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday undated [8 March 1922] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so terribly sorry about what happened yesterday, & feel it is all my fault, as I ought to have known. You are one of my best & most faithful friends, & have always been so nice to me – that it makes it doubly worse. I am too miserable about it, & blame myself more than I can say. If you ever feel you want a talk about things in general – I hope you will come & see me, as I understand you know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do wish this hadn’t happened.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duke of York had proposed to her for the second time. In his reply on the same day he asked her not to be miserable – ‘I was entirely in the wrong to bring up the question in the way I did without giving you any warning as to my intentions … I am so so sorry.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn139",
      "id": "fn_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday undated [12 March 1922] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your very nice letter – it relieved my mind tremendously in a way, and I do hope you are not worrying about it all any more.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must return to Glamis tomorrow, and am hoping very much to get my mother south before so very long, so we shall not meet for several weeks I expect. Please do try & forget about this, as I hate to think that you worry over it – things are hard for you anyway, and I can’t bear to think they are any harder through me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I couldn’t manage to go to Brixworth, as I was originally going tonight. I hope you had a good hunt. Au revoir – till I don’t know when.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 16 March, the Duke of York wrote a ‘very difficult’ letter. ‘I feel I must tell you that I have always cared for you and had the hope that you would one day care for me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn140",
      "id": "fn_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday 18 March 1922 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. You write the nicest letters of anyone I know, and the one I got this morning was just as charming. Yes, I think it has been difficult for both of us, but especially for you, and thank you so much for being so nice about it. I do hope we can go on being friends, as it would be too sad if a happening like this should come between our friendship, and I don’t see why it should, do you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall always be glad to see you if you ever feel like dropping in to tea, & having a talk. As I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" understand you know, and when people are as good friends as you and I are – there is always a lot to talk about. I wish I could put into words what I feel about it all, & I think it is wonderful of you to have gone on caring – oh "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("why")]), _vm._v(" didn’t I guess. How silly I’ve been, and, as you say in your letter, of course I shall look on you as more than an ordinary friend.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I found my mother much better, and I do hope to come south at the beginning of May. I had already told her before you wrote, but nobody else in the world, & never shall.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What are you going to do now? Shall you be in London – I wish I wasn’t up here – it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" dull.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 26 March Prince Albert replied, ‘Thank you so much for your charming letter which has cheered me up a great deal. You wrote too nicely to me, & I do feel now that you are not angry with me for what happened.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn141",
      "id": "fn_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In early May Queen Mary wrote to Lady Strathmore saying that she and the King were ‘much disappointed that the little “romance” has come to an end as we should so much have liked the connection with your family’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn142",
      "id": "fn_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 October 1922 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you ten million times for sending me all those gramophone records, which arrived in record time (oh! a joke, accident I promise). I can’t tell you how much I have enjoyed playing them. When one is in the country far away from everything, it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" delicious getting new records. Thank you so much, it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" angelic of you to take the trouble to get them for me. I enclose some notes of enormous value, but I don’t know quite how much I really owe you. I hope two crackly sovereigns is enough? Thank you also so much for the excellent photograph, it is a very good one I think, and I am so pleased to have it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am listening to ‘Stumbling’ as I write, it is so good, I love it, and also ‘Limehouse Blues’ and ‘I’m Simply Mad about Harry’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We all went into Perth races on Saturday to see Joe Airlie win his race – he did it quite easily, as one man fell off & lost his horse, & the other never got over the first jump! There were only three of them. Diamond"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn143",
      "id": "fn_143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is here now, I think she looks "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" ill poor thing. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope your trip to Rumania will go off well, and that it will all be a great success."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn144",
      "id": "fn_144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("James looks very thin, doesn’t he? I suppose it is pretty dirty work too – he looks covered in oil & grease."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn145",
      "id": "fn_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks again for your photograph, which I have stuck up in my room, & the best of luck on your trip abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday [26] October 1922 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn146",
      "id": "fn_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so sorry to hear that you had to have chloroform, & do hope that you are really feeling better. It must be too horrible being operated upon, even though it’s a small one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You seem to have spent rather a pleasant autumn – I spent the time entirely at Glamis, entertaining a series of guests, some were nice and some were NOT. Some were funny; one person who amused me was a gentleman called Mr James K. Hackett, the American actor. I don’t know quite why he came. I [have] never seen a man drink so much – little drops all day long, that’s the road to ruin – ah well. I am coming to London the week after next I think, so perhaps you will come and have a small drink (to help you on the downward path) on your way home from work. I am here now as a matter of fact, but only for a day or so, & I’ve got to go to a ball at Wilton, which rather terrifies me, as I hear the party numbers 48. Isn’t it AWFUL?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel so sorry for some people we know, don’t you? Perhaps you don’t know who I mean, but I feel sorry for the poor man. How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" you know who I mean?!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [1922] to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must tell you that I have come across a most mysterious stone, which must be full of magic power I think. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("PINK")]), _vm._v(", with one white circle and nearly round. The appearance is arresting, being a very pure pink, & most fairy like. I found it in a pinewood – Scotch firs you know are full of sorcery, usually of a rather sad and sinister kind, and I could not resist telling you about it. I don’t think anyone else "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("believes")]), _vm._v(" in Magic Stones, do you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are very well, & not too overworked. The East must have been keeping you busy I expect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely, Elizabeth Lyon.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [1922] to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is just to tell you that I have to go away on Monday, so perhaps you had better not come to visit us on Tuesday. I did not go away today on a visit, as I have a slightly sore throat. I do believe I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("need")]), _vm._v(" that MAGIC STONE. Life has not been quite so smooth since I gave it to you, and if you have not felt any very violent benefit from it so far, perhaps you would very kindly return it. There is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" hurry, but I have a FEELING ("), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" know) that I must take it north with me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you have enjoyed Thursday and Friday. I remember you told me about the little boy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS If you are not busy this weekend, do come here some time – or perhaps you are going away? I think I am staying with my mother. I am not going North for a week so no hurry about the Stone.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 January 1923 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just come back from seeing Lady Airlie and talked it all over with her. She is most discreet, and I don’t think she will say a word. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is so angelic of you to allow me plenty of time to think it over – I really do need it, as it takes so long to ponder these things, & this is so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" important for us both. If in the end I come to the conclusion that it will be alright, well & good, but Prince Bertie, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("if")]), _vm._v(" I feel that I can’t (& I will not marry you unless I am quite certain, for your own sake) then I shall go away and try not to see you again. I feel there are only those two alternatives – either it will all come right, which I hope it will, or the other. I do hope you understand my feelings – I am more than grateful to you for not hurrying me, and I am determined not to spoil your life by just drifting on like this. You are so thoughtful for me always – oh I do want to do what is right for you. I have thought of nothing else all today – last night seems like a dream. Was it?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It seems so now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Perhaps you had better not say anything just yet to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anybody")]), _vm._v(" – what do you think? Do as you think best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I never thanked you last night for your delightful party. I really enjoyed it very much, & many thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just been persuaded to go down to the Lewes Hunt Ball tomorrow night, & shall return here on Saturday. Then I shall go down to St Paul’s Walden the same day. I really am terribly sorry about Pitsford, I would have so loved it, but somehow I feel I was right not to come with you today.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir till next Thursday,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Mabell Airlie acted as a confidante for Prince Albert and Elizabeth and a go-between for Queen Mary with the Strathmores. On 3 January 1923 the Prince and Elizabeth danced together at Claridge’s and it seems he again declared his wish to marry her. Many years later Eric Anderson asked her,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘When it came to the serious proposal for you, did you take advice from anybody or did you know at once?’ She replied, ‘It went on for a year or two. You know you are not sure about anything and then one of my brothers said to me, “Look here. You know you must either say yes or no. It’s not fair.” I think he was right. Because one is rather inclined to dither along if somebody’s fond of you, you know. I suppose when one is young and busy and things. No, he was quite right.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 4 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.15. Letters from Doris, Mary Thynne & Ruby Smith. Talked to P.B. on the telephone. Said I could not go to Pitsford. Dressed by 12.15. Rushed off to try on my blue tweed. Walked home. George Gage came to lunch. [ … ] Ava"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn147",
      "id": "fn_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came, & we went to tea with the MacRaes. Very amusing. David & Stephen Tennant"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn148",
      "id": "fn_148",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" there. Ava & I took taxi to Victoria. I went to see Lady Airlie – talked a long time & explained everything. She was so nice. I ma tsom dexelprep. Home 7. Wrote some letters. George bullied me into saying that I’ll go down tomorrow for Ball. Dinner 8.30. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Elizabeth used mirror writing in her diaries when she wanted to conceal her thoughts.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 5 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Up by 12. Feel rather tired. Ma gnikniht oot hcum. I hsiw I wenk. Mother lunched with Nina. Catherine & I took the 3.20 to Lewes. George [Gage] met us there, & Imogen & Ivo Grenfell came by the same train. The Westmacotts & Chips"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn149",
      "id": "fn_149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" came a little later, bringing evening papers saying that I was engaged to the Prince of Wales – not mentioning my name, but quite obvious enough. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Too")]), _vm._v(" stupid & unfounded. Two Miss Gages & one fiancé. Dinner 8.15. Sat between George & Ivo. We went to the Lewes Hunt Ball. Great fun. Danced with some very nice old friends – John Bevan, Tom Bevan, Ian Melville, Mr Wethered, besides our party. Danced till nearly 4! Home 4.30. Ate biscuits & sherry. Bed 5.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 6 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Breakfast 10.15. I took the 11.17 to London. [ … ] James & the Daimler to meet me. Home 1. Mother not feeling very well. Letter from B. At 3 Mother, Father & I motored down to St P. W. Home 4.15. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Sunday 7 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Breakfast in bed. Up 11.30. Dr Thomas came to see Jock who has a bad cold. Read prayers with Father & Mother. Did not go out, horrid day. Read & knitted & talked. Dinner 8.30. Played the Grammy. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday undated [8 January 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so sorry to have been such ages sending you back your handkerchief, which was most useful. Thank you so much for lending it to me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you also so very much for your angelic letter which I got on Saturday – it was such a nice one. Do you know, last Wednesday evening seems just like a dream to me now. I think the great thing is to be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("with")]), _vm._v(" the person, or it all seems too unreal – do you feel that at all?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I get back from Longleat"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn150",
      "id": "fn_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" on Thursday, are you coming to tea on that day? I shall be in Bruton Street anyway, so if you are in London do look in. I do hope the Pytchley Ball was fun, and also Emma [Thynne]’s ball at Castle Ashby – did you enjoy them?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Did you see any of the papers on Friday? Some of them said I was engaged to the Prince of Wales – one or two of them mentioning my name and a few my photograph. It’s too extraordinary, why can’t they leave one alone? And in this case, it was so utterly absurd. I’m so sleepy, I must go to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for your letter,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("God Bless you,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 8 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Breakfast 10.15. [ … ] Sheaf of cuttings about my rumoured engagement to the Prince of Wales. Too silly. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 11 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Doris came to lunch with me [in London]. [ … ] Talked till 3.30. [ … ] Prince Bertie came to tea – we talked till 7.30. I am yrev deirrow oot. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 12 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Felt "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" tired. Up by 11. Doris came round & talked till 12.30. [ … ] I sat before the fire in a stupor till 1.30. Dashed off & was photographed for Vogue. Home again – telephoned for father to Prince Bertie – he was out, so left a message to bring guns. [ … ] Prince Bertie called for me at 6 & we motored down to St Paul’s Walden. Arrived 7.30. Dinner 8.30. At 11 Fenella & I went to a dance given by the Martin Smiths. Danced with John Bevan, Mr Fane, Mr Gibbs, Christopher Barclay etc. Good supper. Home 1.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 13 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Breakie 10.30. Talked to Prince Bertie, & went for tiring walk before lunch. Mr Beck to lunch. I felt a bit tired. Went & sawed wood with father in Michael’s Hope. Prince Bertie sawed "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hard")]), _vm._v("! Talked after tea for hours – dediced ot tiaw a elttil – epoh I ma not gnivaheb yl[d]ab. Dinner 8.30. Fenella had gone to London. Talked till ¼ to 12. Bed 12.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Sunday 14 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Breakie 10.30. Sat & talked till 12.30, & then went for a walk in the enchanted wood. Long walk after lunch & long talks after tea & dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Late on the evening of Sunday 14 January 1923 Elizabeth accepted Prince Albert. Her mother described it to her daughter May thus: ‘He came down to St. P.W. suddenly on "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Friday")]), _vm._v(", & proposed continuously until Sunday night, when she said Yes at 11.30!! My head is completely bewildered, as all those days E was hesitating and miserable, but now she is absolutely happy – and he is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("radiant.")]), _vm._v("’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn151",
      "id": "fn_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In similar vein, on 17 January Lady Strathmore wrote to her daughter-in-law Lady Christian, widow of Fergus, who was now remarried to Captain William Martin:")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("‘He has wanted to marry Elizth for nearly 3 years, & she had refused him quite steadfastly, but lately I noticed that she liked dancing & talking to him more than anyone else – so when he came suddenly to St Paul’s Walden last week I felt pretty certain she wd say yes.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("‘She is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" happy & he is radiant – & we are (at last) quite happy about it – I like him immensely.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("‘I don’t know what I shall do, Christian, when she goes – I cannot tell you what she has been to me – never once a cross word in her whole life & such a sympathetic & loving help to me.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn152",
      "id": "fn_152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The following day the Prince set off to Sandringham to tell his parents. King George V recorded in his diary that ‘we gladly gave our consent’. Queen Mary wrote, ‘We are delighted and he looks beaming.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn153",
      "id": "fn_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The King and Queen invited Elizabeth and her parents to stay with them at Sandringham the following weekend.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 15 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8. Slept rather badly. Breakie 9. At ¼ to 10 P.B. motored me up to London. Dropped me at Bruton Street. Then I went to the dentist. Called on Fenella – told her news, & had a cocktail. Home 1. B. called for me & we lunched at Chesterfield House with Princess Mary & Lord Lascelles. The Prince of Wales came round to see me there. B. went off to Sandringham, & the P. of W dropped me home. Found mother. Wrote "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lots")]), _vm._v(" of letters. Went to see Nina & told her. Also Lady Airlie. Jock came in. Wrote lots more letters. The telephone rang the whole evening – hundreds of reporters clamouring! Last day of peace I suppose! Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 January 1923 to Arthur Penn")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Arthur,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Arthur, I must tell you, I am going to marry Prince Bertie – I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope you like him – I feel terrified now I’ve done it – in fact nobody is more surprised than me. Arthur, you have been one of my best friends for years – "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("please")]), _vm._v(" "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" don’t cast me off as one now, will you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you are pleased about this – I felt I must tell you")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 16 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8.30. The papers announce my engagement this morning. Great headlines & lots of rot! Up by 11. Telegrams poured in all day, letters & reporters tumbling over each other. Saw Aunt Maudie."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn154",
      "id": "fn_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Bertie came to lunch. There were hundreds of photographers & a crowd when we came out. Awful! Went to Buckingham Palace & chose the ring. The Prince of Wales came in for some time, & sent for some rings from Boucheron! Had tea with Bertie – then he brought me home. More telegrams, & saw two Scotch reporters & [Victor] Gordon-Lennox. Quite exhausted! Bertie dined – Father came up. Talked till 12 – & were photographed – not a success! Bed 1.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 January 1923 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Sir,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your very kind letter, which Bertie gave me. I am so grateful to Your Majesty for welcoming me so kindly as a future member of your family and I only hope that I shall be able to help Bertie in all his many duties, and in many other ways also.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall look forward so much to coming to Sandringham on Saturday, and with many more thanks for your kindness,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain, Your Majesty’s humble and obedient servant,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 January 1923 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Madam,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must thank you so much for your most kind letter, welcoming me as your future daughter in law. I do hope I shall make Bertie very happy, as he so deserves to be, and my greatest wish is to be a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("real")]), _vm._v(" daughter to your Majesty.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall look forward intensely to my visit to Sandringham on Saturday, and I do hope you will think I shall make Bertie a good wife, we are both so happy, and it is all wonderful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain, Your Majesty’s humble & obedient servant,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday 17 January 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for your charming letter. It was so nice of you to write. You must come round and ‘’ave one’ soon. You have no idea how tiring it is being engaged! I am quite gaga already, & can only clutch my magic stone and hope for the best. Good ’ealth, Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Wednesday 17 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke 8.30. Great pile of letters, & papers still very full of it! Betty Cator"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn155",
      "id": "fn_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came to see me. So nice. Simply inundated by awful reporters & photographers. Too appalling. Bertie went off hunting today. Telegrams from Paul in Serbia, Mr Brown in Australia, Doubledays in America etc. Very busy writing. Louis Greig"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn156",
      "id": "fn_156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" brought a secretary round to help me. Doris came at 3.30. We crept out for a walk in the fog! Talked hard – she is so pleased. She left 5. Diamond came in, also Christopher [Glenconner] for a few minutes. Lots more letters & telegrams. Bertie came to dinner. Rosie arrived up for tea. We talked till 12! Bed 12.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 January 1923 to Arthur Penn")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear dear Arthur,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You wrote me such an angelic letter – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("far")]), _vm._v(" the nicest I’ve had yet. Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" so much, I really loved it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("am")]), _vm._v(" so glad you are pleased, Arthur. It was all so surprising and I am very pleased with being engaged! Except for this awful publicity. How beastly the papers are – nothing but lies! am completely exhausted, but I don’t think this can last much longer. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Do")]), _vm._v(" come in one evening soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 19 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 10! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Lots")]), _vm._v(" of letters. Up by 11.30. Miss Chard [temporary secretary] came, & we got through dozens. Bertie to lunch. Afterwards, he & I motored down to Richmond,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn157",
      "id": "fn_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" where we went for a walk & looked at the garden of White Lodge. Then we called on Mrs Greig & had tea with her. Home again at six. More letters! Wrote several. Bertie gave me my engagement ring today, it is lovely. He came to dinner & we talked till nearly 12! Bed 12.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21 January 1923 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("York Cottage")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did not have time to let you know I was engaged, before it was announced in the paper. I longed to tell you, but did not know where you were. It was all such a hurry – I got engaged on Sunday – Bertie dashed off here on Monday, & it came out Monday night. So I could not even let the family know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve had a ghastly time this week with reporters & photographers curse them, but hope they will very soon get tired of us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We came down here yesterday, & it has been a bit of an ordeal meeting all the relations. They have all been so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" kind & charming, but I’m feeling "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("utterly")]), _vm._v(" exhausted. We go back to London tomorrow, I dread the pile of letters.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh, my dearest M – I’ve heard from Ernest [Pearce] & Norman Jepson"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn158",
      "id": "fn_158",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" already – such "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" letters. I was so pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so happy, & most surprised, as I never thought I’d marry him!!! You must come back in time for the wedding tho’ that won’t be just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so tired already – I think I shall probably die "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("long")]), _vm._v(" before I get married! How delighted the papers would be – after the ROMANCE the TRAGEDY! What ho.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Best love, I have got at least 500 letters to write.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("25 January 1923 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A thousand thanks for your angelic letter. I am most awfully happy my dear M – it is all wonderful except this publicity still – it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ghastly")]), _vm._v("!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Look here, "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" come back soon & take over control of my presents, will you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I should be so grateful, & will make somebody or other (not me!) pay you an IMMENSE salary. Do, if you are coming home soon. If you don’t, I shall have to get a stranger. I would love to see your ugly face about. Your loving E.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I’ve had to have a secretary lent to me! I’m completely exhausted already.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [25 January 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just writing you a very little letter, which I hope you will get on Friday or Saturday. There won’t be anything in it at all, except to say that I shall be thinking about you when you get this, & hoping that everything will go wonderfully well. I am quite sure it will. Also, I might add that I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" love you Bertie, & feel certain that I shall "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("more")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("more")]), _vm._v(". I shall miss you terribly. You are such an Angel to me. Goodbye till Sunday – may it come quickly")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your always and forever loving E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 February 1923 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("York Cottage")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Of course you must not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dream")]), _vm._v(" of coming home just to do presents! I thought you said you were coming almost at once in your last letter – that’s why I wrote! I can "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("easily")]), _vm._v(" do them, and May loves doing them too – so that’s alright. Also nobody may send me anything. I was regretting very much that I haven’t cultivated some very RICH people! All my friends are poor. We’ve had a delicious and restful week down here, & return to hard work in London tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is a bit of a strain staying with one’s future in laws, whoever they are. Mine have all been too angelic to me I must say. Let me know when you are coming home.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh, Ernest wrote a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wonderful")]), _vm._v(" letter and sent messages to you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You must meet my fiancé soon. I hope you’ll like him. He is a darling really – & very shy!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" don’t come home. I only suggested it because I thought you were anyway coming.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 13 February 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Up by 11.30. Mother & I went off to have my throat done."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn159",
      "id": "fn_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Called at Upper Brook St & asked after Sidney. Operation went off well. Home 1. Bertie came at 3. Then the Queen & her brother Cambridge [Adolphus, Marquess of Cambridge] came. They looked at the presents, & the Queen stayed till 4.30. Lady Mary Trefusis called for her. Colonel & Mrs Erskine to tea. Bertie went to the House of Lords, & then came back. At 8.15 he, the Prince of Wales, & Prince George called for me, & we four dined at Claridge’s. Very gay dinner. Then we went to 9 o’clock revue – very amusing. Giles & Anne"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn160",
      "id": "fn_160",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" joined us there – also Bruce [Ogilvy]. We talked in the Manager’s room! The others went to a ball (charity) & we four supped & danced at the Berkeley. Great fun. Bed 1.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [February 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Bertie darling, I am so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(" disappointed at not being able to come with you today. I think I must have got a chill of sorts, as I feel like death with a terrific headache. I did so want to come with you today, it would have been heavenly – a day in the country with you. I tried to get up, but I would have been a miserable companion for you darling I know, so I shall probably stay in bed, & I may feel alright tonight. I do hope you will have a delicious day, don’t worry about me. I do sometimes catch chills like this worse luck, & I shall think of you in the country. I am so disappointed Bertie you angel,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very and always loving E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday undated [13 March 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wish")]), _vm._v(" you were here – it is really too marvellous, and I know it would do you good too. When I arrived this morning the sun was just rising over the Sidlaw hills, and made the snow on the Grampians look pink & heavenly. It was wonderful to be able to see about twenty miles instead of down one London street! It would be more delicious if you were here too. I hate to think of you in horrible London all by yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My cold is worse today, but I expect it will very soon go here – I only hope you won’t catch it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" Glamis.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, while I remember it, will it be approved do you think if I ask Betty Cator to be my bridesmaid? She is such a darling, I would like to have her.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t worry about White Lodge & furniture. I am quite certain we shall make it enchanting – you & I; so please don’t fuss yourself little darling. You are such an angel to me always, and I hate to think of you worrying about anything. ‘Keep calm and don’t be bullied – rest if you can’ is my advice!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Forgive this scrawl, I want to catch the early post – au revoir till I write again, & be good darling,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your always loving Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I miss you very much. Do you miss me?")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday undated [14 March 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Bertie darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are well & happy – I am thank you – I haven’t heard from you yet, but the evening post comes late. I am writing this to catch the night mail, & David Arthur the odd man ("), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" odd) is waiting to what he calls ‘pop up’ on his bicycle & post it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Another marvellous day – blue sky & sun & a little cold.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just going off to see if there are any duck on the pond, & Peter will chaperone me – it is light so late now, which is heavenly. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My guides have got a present for me, & are giving it tomorrow – isn’t it delicious of them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was photographed when out today by a low friend of Daddee’s. Most annoying, otherwise everybody has left me in peace which is very tactful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All the people here hope you’ll be good to me! I hope so too!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye darling – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("why")]), _vm._v(" aren’t you here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Till Saturday,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 19 March 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Breakie 10. [ … ] Bertie came round, & we went & looked at furniture at Harris & also went to Carrington. [ … ] Then mother & I went to Handley Seymour"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn161",
      "id": "fn_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & looked at hundreds of lovely clothes. Chose my wedding dress.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday undated [31 March 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darlingest Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was enchanted to get your delicious letter this morning – thank you so much. A.F.A.G, those "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("are")]), _vm._v(" your initials aren’t they? I wonder what you do all day? I read in the paper today that you walked to Frogmore"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn162",
      "id": "fn_162",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & had tea. Having never seen Frogmore, I imagine it as a large white Tomb full of frogs! I can’t think why, but that is the impression it gives me – isn’t it silly?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David and I walked down to church in the little Tin Chapel, but no bird got in this time to amuse us. We stayed an hour and a quarter, & by then Mr Whitehouse had only just finished the service on the First Word, and we became rather depressed & left! At that rate the service would last 6 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father arrived today bringing darling Peter & Barson – it is delicious having them back again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, do you know you have got a most changeable face? It is too odd, sometimes you look a completely different person, always nice though, but I must not flatter you because then your head will swell, & you will have to buy new hats. That would be very sad, wouldn’t it? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wish")]), _vm._v(" you were here. Why haven’t you got a small aeroplane, then you could fly over here for an hour or two, get thoroughly hurt as usual, & return to Windsor, a scratched and bruised but let us hope a happy wreck.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What rot this is, & I have got about forty letters to write, curse it. Well, s’long Bertie, don’t forget your Honey Lamb will you? Darling B, you are an Angel. Your as ever loving E")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS For Gawd’s sake don’t leave my letters lying about")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 5 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[At Windsor] Woke at 8. Had breakie in bed. Up by 10. Bertie went out riding at 11.30. I talked to the Prince of Wales for a bit. After lunch the King showed me his room & played some gramophone records. Then the Queen took me & Bertie all round the house – marvellous things. At 4 B & I went out to tea with the King & Queen to Sir Harry Legge. Very nice man. Home 6.30. Talked. The P. of W & Prince George left this morning. Dinner 8.30. Lord A. Innes-Ker & Lord —— to dine. Much chaff. Bed 12.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 April 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" much for the two books. I really can’t tell you how much I love them, and I wish I could thank you sufficiently. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" of you and I could see at once that they were a thought-out present, which gives me infinitely more pleasure than eight ropes of pearls from a new oil Lord. They are divinely bound and I am going to take them up with me to read in bed now, which I hope you won’t mind. Thank you a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("thousand")]), _vm._v(" times, it really is a marvellous present, and just what I like. I haven’t found any magic stones lately – have you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is nearly midnight and the only time I get for writing. There are fifty people I must write to, but I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("had")]), _vm._v(" to thank you first, because I love your present. I wish you would come in one evening if you can, & drink a cocktail & exchange a few ideas on MAGIC and POLITICS and SPIRITUALISM and RELIGION, and GEORGE ROBEY and AMERICANS and all the terribly interesting things in this world. If you will ring me up, I am always here after tea. Also I want to ask you about a story you told me once, in the hot sun at Bicton – I remember it because it sent a cold shiver from my head way down to my heels.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are well, and that thrilling things happen to you. And "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("thank you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 24 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] Terribly busy. Bertie to lunch – he & I went to the Palace, & attended a servants’ party. Had tea with the Queen & King. [ … ] Bertie & I dined with James at Claridge’s. He is engaged to Rachel!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn163",
      "id": "fn_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" The party was him, Bertie, Mike, David, Arthur, Francis & Freddy, me, Rachel, Katie, Betty, Mary Thynne, Mary Cavendish & Hermione."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn164",
      "id": "fn_164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" We dined [in] a private room – then went to Hippodrome then to the Berkeley & danced. I was in good form! Went home, & talked to Bertie. Then talked to Mike for ages. Bed 3.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Wednesday 25 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 10 feeling very ill! Miss Poignand came in. I talked on the telephone, & did a million things before lunch. Betty Cator came in. Bertie to lunch – he & I went off at 3.30 to B.P. Large crowd as usual! Mrs Lindsay Carnegie presented an address from Forfarshire – in B’s room. Then we went downstairs, & attended an afternoon party. Shook hands with hundreds of people. Very tired. Had tea with the King & Queen & Duke of Connaught"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn165",
      "id": "fn_165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" & [the] Lascelles."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn166",
      "id": "fn_166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Mother too. She & I got home 6. Very tired. Bruce came in – also Katie – Jock to dinner. Felt terribly moved when I said good-night to the darling boys [Mike and David] & mother. I adore them. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 26 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8.30. Up by 10. Put on my wedding dress, aided by Suzanne & Catherine. It looked lovely. All the family went off early, also mother. Miss Chard came & talked to me. At 11.12 the carriage came, & father & I started off for the Abbey. Lots of people in B St., & crowds in the streets. Did not feel very nervous. Bertie smiled at me when I got up to him – & it all went off well. We had a long drive home to B.P. Crowds very kind. We were photographed, & also went out on the balcony. Then luncheon. Sat between Bertie & the King. After lunch talked & cut cake etc. Went to change about 3.40. Mother & Anne"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn167",
      "id": "fn_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came – then May & Rosie, Mike & David & father. Awful saying goodbye. B & I drove off at 4.15 & had a special to Bookham. Very tired & happy. Bed 12.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duke of York was married to Elizabeth Bowes Lyon on 26 April 1923 at Westminster Abbey. The ceremony was followed by a wedding breakfast at Buckingham Palace, after which the couple left for their honeymoon at Polesden Lacey, the Surrey home of Mrs Ronald Greville.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [27 April 1923] to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Polesden Lacey")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Dorking")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you weren’t too terribly tired yesterday. I felt so worried about you, & after all these last three months you must be exhausted. I could not say anything to you about how utterly miserable I was at leaving you & Mike & David & father. I could not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" have said it to you – but you know I love you more than anybody in the world, mother, and you do know it, don’t you? Bertie adores you too, & he is being too marvellous to me, & so thoughtful. He really is a darling – I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" you all like him.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I stayed in bed all this morning to rest & read the papers, and am just going down to lunch in my "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("old")]), _vm._v(" blue tweed! Poor Catherine is miserable because I won’t wear anything new – I hate new things!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" house, & the food is too marvellous, & it seems too funny not to be dashing about! I think the wedding went off alright, don’t you? Do write, angel, from your very, very loving Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do tell Mike & David that Billy Merson"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn168",
      "id": "fn_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" sent us a telegram last night from the Hippodrome.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 June 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Richmond Park")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" nice of you to write, and I have quite given up whooping."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn169",
      "id": "fn_169",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" As to asking after my health, I am afraid I talked so hard, that you probably would not have been able to ask, even if you’d thought of it?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You must come down here one day if you have time. When it is hot in London (& people always "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("look")]), _vm._v(" so nasty then, which I hate don’t you?) it is quite cool & delicious here. So sometime you must throw the Eastern question firmly aside, turn your most magic stone three times from East to West, & start for Richmond.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As to what to call me – I really don’t know! It might be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anything")]), _vm._v(" – you might try ‘All Hail, Duchess’, that is an Alice in Wonderland sort of Duchess, or just ‘Greetings’ or ‘What Ho, Duchess’ or ‘Say, Dutch’ – in fact you can please yourself, as it will certainly please me. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 September 1923 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Invermark"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn170",
      "id": "fn_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Edzell")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I want to thank you so very very much for my delightful fortnight at Balmoral, and for having asked us there. It was the greatest fun, and I enjoyed every moment of it, and we were both very sad at leaving on Friday. Everybody was so kind and nice to me, and I was so happy with you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("After two "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lovely")]), _vm._v(" days on Saturday & Sunday, it is pouring with rain today! However, they have bravely gone out stalking, but I am afraid it does not look very hopeful. Even though I am the wife, daughter and sister of ‘guns’, I fail to see what pleasure there can be in walking about all day in an icy wind and driving rain!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for my wonderful visit to Balmoral,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, your very loving daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [27 September 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Somewhere in England (on train from Darlington)")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Darlington")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve just had luncheon and also my pencil has broken. So you probably won’t be able to read this at all! I wish you were here, but I’m glad for you to be out on the ‘mower’ [moor] instead of in this stuffy beastly train. The waiter said ‘May I have the pleasure of serving you’ each time before he gave me any food, which made me long to laugh. I think we ought to train Seton [Steward at White Lodge] to say it too, don’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There was the usual crowd of slightly hysterical females at Darlington, who murmured ‘Isn’t she sweet’, gazing fondly at Catherine. I think they thought Hay [the Yorks’ detective] was you. The train is full of odd people. I hope you’ll have a good journey to Glamis, little darling. I send you some kisses and a couple of hugs. I shall miss you horribly till Sunday")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours forever and always E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("This note was scribbled in blue pencil on the inside of the dust jacket of P. G. Wodehouse’s novel")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Psmith in the City.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wodehouse was one of the Duchess’s favourite authors throughout her life. Asked by Eric Anderson who had given her most pleasure as a writer, she replied,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘P.G. I suppose … I had older brothers who were at Eton, and of course at Oxford and I think P.G. was all the rage. I think I read them all … If you are feeling very tired or depressed, one page of P.G. and you feel better. You laugh and you’re interested.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 October 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is too delicious of you to send me two books for the journey to Belgrade."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn171",
      "id": "fn_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" It really "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is")]), _vm._v(" nice of you to think of it, and I am very grateful, as the prospect of three days in the train shocks me to a degree, & your books will make all the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so glad you don’t mind returning to London as much as you thought you would. Do you ever go to a musical comedy? I think there is nothing to beat them, & the worse, the better. I go occasionally to see the Astaires"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn172",
      "id": "fn_172",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" dance in ‘Stop Flirting’. Have you seen them – they are delicious, I think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("About Isabel [a young American friend of D’Arcy]. Is a bell necessary on a bicycle. That’s one point against her poor girl. Now let me see –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Against.           For.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("1. Her name.    Sense of humour.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("2. American.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("3. Eight millions.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("4. Indifferent features.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("5. No parents.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes, I think you ought to marry her. The sense of humour balances everything. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop now, and turn over the clocks, wind up the piano, & generally prepare for Adventure in the Balkans. I feel it is going to be rather an ordeal, but amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again so much for the books,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21[22] October [1923] to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Palais Royal")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Belgrade")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a hurried line to tell you that we had a very good journey out here, & found a large party, all family. Everything is very funny here, just like a musical comedy! Everything is very unpunctual, & very pompous! Yesterday was a very long day, & tiring, today is Paul’s wedding. I will tell you all about it later, as there is only a few minutes now. Alexander’s wife is ill, so her mother, the Queen of Roumania"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn173",
      "id": "fn_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has taken the lead in everything, and enjoyed herself wildly! She is very nice though, & they all speak English always. The King of Roumania is too absurd, we get on so well, & he honestly is a pure Bateman."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn174",
      "id": "fn_174",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Alexander gave me a lovely little watch & his order, which spoils all my clothes, as it’s blue & white.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It has been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("boiling")]), _vm._v(", "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("80")]), _vm._v(" degrees today & shining sun.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will be coming to London soon darling, so au revoir, & please forgive this short scribble,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 October [1923] to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("million")]), _vm._v(" times for ringing up last night. We had an awful crossing, but luckily I didn’t feel sick. Catherine was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("VERY")]), _vm._v(" sick!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Serbian visit was terribly funny. They all walk about all day in musical comedy uniforms. I will try & tell you a little about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We arrived at Zagreb at about 9 o’clock last Saturday, where we hitched our carriage onto Alexander’s train which he had sent for us. It was once the Austrian Emperor’s, & very rattly! There were several footmen dressed in beautiful liveries of pale blue, with trousers that went into spats, do you know the sort, and huge silver buttons. We travelled the whole day, through a completely flat plain, all cultivated, but no roads at all. We got to Belgrade at 7.30, where Alexander met us, and his sister, as his wife was ill. The band played God Save The King "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" quickly over & over again, & we got into tiny blue Victorias with white horses & rushed off to the Palace. The whole family were there, the King & Queen of Roumania, their eldest son & his wife, the other daughter who is Queen of Greece, Ileana, & all Paul’s fiancée’s family. They are all so nice, & very English.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The next day, the christening was at 11, & Bertie was simply terrified at having to carry the baby about! However, it went off very well, and the singing was too lovely. Afterwards, there was a tremendous luncheon party of about 300. At about 4, Bertie & I & Paul & Olga drove out & looked at Belgrade, & then went & had tea with the Roumanians on their yacht in the Danube. They nearly all lived there, as there is so little room in the Palace. There was a family dinner, & then a concert & reception after. I got so tired, that Bertie & I crept away.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The next day, was Paul’s wedding. Olga looked lovely I thought, & it went off very well, and Paul is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" happy. He was enchanted at having us there, & otherwise he had no real friends. A large luncheon, & then I went off to see a hospital for children run by a Scotch woman doctor. It is the "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("only one")]), _vm._v(" in all Serbia, and does marvellous work. Then I went down to the Danube, & joined Bertie on the Glowworm which is a British monitor, & then we went off to the Legation & met the British Colony. Very small, & all Scotch! Then home, & I rested, whilst Bertie went down to see Paul off. After dinner, we departed – I drove down to the station with Alexander, and it was very funny, as we did not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" go! You see the train went very early the next morning, so we thought it would be less trouble to sleep in our own ‘wagon lits’ carriage, & just get hitched on to the train very early when we were asleep. So we went through all the usual pomp, & a guard of honour, looking "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("exactly")]), _vm._v(" like the male chorus of a revue, & a band, & rows of ladies with bouquets, & kisses all round, & then we steamed triumphantly out of the station, for about 20 yards, where we stopped all night! It was so funny, because it was all a sham, & they all knew it too!! You have no idea how odd they are, & so nice!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel rather tired now, but am having a good rest. I got on very well with them all, especially the King of Roumania, who is the silliest & kindest old idiot – also Alexander, who is very shy. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you are coming south soon, you must be longing to see your polo ponies.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, Angel, lots of love to Father, from your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 8 January 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] At 7.30 drove up to St James’s. Picked up David [the Prince of Wales], & dined at Claridge’s. [Prince] George came too. Then we went to the Hippodrome & then on to the Winter Garden where we went to see George Grossmith & Leslie Henson [in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Beauty Prize")]), _vm._v("]. Then back to York House [the residence of the Prince of Wales], & then to the Midnight Follies,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn175",
      "id": "fn_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" where we joined the Nortons & dance. Home 3!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 14 January 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("After dinner went through papers. Apparently na lufwa wor tuoba eht thgindim seillof. Bed 10.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 January 1924 [misdated 1923] to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Old House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Guilsborough"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn176",
      "id": "fn_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Commander Greig tells me that you are angry with us for having been seen at the Midnight Follies. I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" sorry about this, as I hate to think of you being annoyed with us, or worried in any way.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We went to have some supper before our drive back to Richmond, and it really is a most respectable place. I promise you we would not go anywhere that we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ought not")]), _vm._v(" to, and this place is supposed to be quite all right for supper after the theatre. I thought I would just write you a short note to tell you about it, & hope you will not mind, as I know how terribly busy you are right now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is very kind of you to ask us to luncheon tomorrow, and I only hope I shall not be under the influence of a drug!! As whilst you are opening Parliament, I shall be opening my jaw to the dentist, and he told me he was going to inject some ‘dope’ into my face, so I hope you will not mind if I am rather odd. The effect on one, is that of having received a stunning blow to the head!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope your cough is better, & that the little yellow Chinaman"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn177",
      "id": "fn_177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is bringing the luck he is supposed to.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Your affectionate daughter in law,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Unlike his own children, the Duchess found it easy to communicate with the King. She later recalled,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I was the first to marry into the family and I think the King rather enjoyed having somebody new and young. We got on; he was always very kind to me and I was very fond of him. He was a bit gruff, the old sailor, but essentially kind underneath, but alas he had rather Victorian ways. He didn’t always get on with his children, especially his sons. It was more difficult for them. What was really rather sad was just at the end before he died, he was beginning to melt and he was having fun with them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 March 1924 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been meaning for ages to write to you. First to thank you so much for your last delightful letter, & secondly, just to please myself by putting down anything that comes into my head! I have had flu and tonsillitis & am still in bed. It’s disgraceful really, as I’ve been in bed nearly ten days, but I am so tired. I have put off four engagements next week, so I consider that I am free for a fortnight.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall have to sit quietly here for a bit – would you ever have time to come & see me?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am bubbling with talk at the moment, & would love to hear from you about the new regime at the FO [Foreign Office]. I am extremely anti-Labour. They are so far apart from fairies and owls and bluebells & Americans & all the things I like. If they agree with me, I know they are pretending – in fact I believe everything is a pretence to them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have got a dear little Scotch nurse whom I sent for from Dundee. She is deliciously enthusiastic about everything, & adored Hampton Court when I sent her there yesterday. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("How")]), _vm._v(" I love the little things of life. Thank God for two doctors consulting over one – also for puppies playing, & a good joke – anything can be amusing if it’s not too pathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("22 March 1924 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" write & thank you for the flowers, because I love them so. They are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" lovely, & it was so nice of you to bunch me – there is nothing I like more than being given flowers, & so I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" say thank you. It is nice of you to say that it was not altruism that made you send them – that would have been so sad! ‘The sacrifice of self in the interests of others’ is what my dictionary says.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am ‘up’ now, & planning a terrible summer. It is going to be so busy – the more you do, the more people expect you to do. One ‘stunt’ intrigues me. Mr [John D.] Rockefeller apparently has given one & a quarter millions towards ‘medical research’, & there is going to be a large dinner party in a huge room in May, with dozens of round tables. At each table a host or hostess who will entertain RICH SNOBS, & extract money in vast quantities from said RICH SNOBS. I hope to have a table. What fun it will be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I would love to see your modelling – shall I pay you a visit one evening (anon) & inspect? I would love to. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("could not")]), _vm._v(" recuperate in company with Mrs [Grace] Vanderbilt. She stuns me at every turn. I like Gracie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn178",
      "id": "fn_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" tho’. But then I like so many things – Gracie, fairy stories, fat butlers, porters, the smell of tangerines, suave Orientals, a good tune, lovely colours, French accents, puppies, bath salts, & a million more.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I dislike very few things, but I dislike those heartily. Tactlessness annoys me – also rudeness, & inability to understand, also crass stupidity, & people who are pleased with themselves. Also spiders, caterpillars, slugs, frogs, toads, loud voices & nasty coughs. And a few more including Mr Noel Buxton."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn179",
      "id": "fn_179",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I must stop and fondle my dogs. Yours sincerely, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I think the Labour Party is narrow minded and snobbish.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 26 April 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8. Breakie in bed. This is the first anniversary of our wedding! I went up to London to see Mother & Mike. Talked for an hour and then rushed home. Lunch at 1. Colonel Wigram"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn180",
      "id": "fn_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came – at 2.15 we went off to Wembley, & saw the Cup Final. The King couldn’t go, so we went. Enormous crowd. Sat between the Duke of Devonshire & Ramsay MacDonald [the Prime Minister]. The latter talked a lot. He & Ishbel go to Windsor today. Newcastle scored two goals in the last 5 minutes. Terrific excitement. Bertie gave the cup & medals. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 3 June 1924 Trooping the Colour")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] Went to B.P. & drove to the Horse Guards with Mama. Bertie rode with the King. It was a very beautiful sight as usual. Went back to B.P. & watched from the Balcony. [ … ] Lunched B.P. Large family gathering. Slipped away 2.45. Went down to Home for Incurables"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn181",
      "id": "fn_181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Putney, & opened their Sale & went round the place. [ … ] [After dinner] we had a small party. About 70. Great fun, & band good. The Astaires came. Stopped dancing 3.15. Bed 4.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 2 October 1924 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have finished ‘Sant Flavio’, the book that you kindly said I might borrow from the library, and am sending it back to Bertie, who will replace it in its little nest. I enjoyed it so much, and got quite excited over it, and thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for allowing me to take it away.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You will be pleased to hear that the stocking is getting on well – the heel is almost finished, and altho’ it is rather lumpy, it is really very pretty. When I have finished this pair, I will make a beautiful pair for you, and if I work as fast as I do at present, I shall hope to have them finished in ten years or so. I am afraid that mine will never be as pretty as your pale grey and white ones, that I admired so the other day!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I enjoyed my fortnight very much indeed at Balmoral, & thank you a thousand times for having me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The political situation seems very wobbly from the papers – I hope you will not have more worries soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your affec: daughter in law, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 1 November 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Went to see David [the Prince of Wales] who got back yesterday from America. Very well. Then back to White Lodge. [ … ] Read etc & helped Bertie with a speech. After dinner same.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 December 1924 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("From 60 bis Avenue d’Iéna, Paris, XVI, en route to Africa")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is very very nice of you to give me a belt, which I wanted "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(". It is so funny, but it was the one thing I forgot, and I was enchanted when I received it today. Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was on the point of writing & making a date with you several times lately, but in the end I was so terribly busy that I saw nobody at all. There were all sorts of things that I wanted to speak with you about, & now I must put it off till April which is annoying.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling slightly mingled in my feelings about going to Africa, as I hate discomfort, and am so afraid that I shall not like the heat, or that mosquitoes will bite my eyelids & the tip of my nose, or that I shall not be able to have baths often enough, or that I shall hate the people. On the other hand, I think it is good for one to go away & see a little LIFE, and then think how pleased I shall be to get home again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do write me a letter or two from the Foreign Office (I like the paper) & if you ask at White Lodge, they will give my address, or I believe we shall be staying in Nairobi with the Governor for some time – anyway for letters.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What fun Paris is. Yesterday we went to Versailles and walked in the gardens, which looked so lovely & forlorn & empty, & in the evening went to the Casino de Paris, where for the first time in my life I saw ladies with "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" little on, & somehow it was not in the least indecent. Then we went to a dance hall full of doped Russians & Argentines, & then to a tiny place where we drank off a coffin, surrounded by skeletons & exchanging very vulgar badinage with a man carrying a huge Bone. Then to a Russian place where I enjoyed myself "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much being very fast, & throwing balls at rather a nice American, & then to a tiny place with several Negroes with delicious voices who sang & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("sang")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now I’m just off to Africa, so au revoir & a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("thousand")]), _vm._v(" thanks for the belt.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 1 December 1924 the Duke and Duchess set off for Paris, the first leg of a journey to East Africa which had been inspired by a conversation the Duchess had had with Winston Churchill at dinner on 27 June 1924. Many years later, Queen Elizabeth recalled this moment:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Winston was extraordinary. I remember sitting next to him at dinner just after we were married & he said, “Now look here, you’re a young couple. You ought to go and have a look at the world. I should go to East Africa,” he said. “It’s got a great future, that country.” So we did. We went off. We spent about five months. We walked in Kenya and Uganda, right down to the Nile. We went up the Nile into Sudan. And I have always been grateful to him, you know, because I don’t think we would have thought of going. It was wonderful. Best bit of one’s life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 11 December 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Got up at 6.30 to see the Suez Canal. All desert on each side, & quite interesting. At about 8, we passed the Wryneck"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn182",
      "id": "fn_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who took us over to Belfast last July! They turned out & cheered us. It was quite a homesick feeling! Stayed at Suez for an hour or so, and then sailed. It is getting warmer quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 12 December 1924 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("SS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mulbera")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My darling Sweet,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We get to Port Sudan tomorrow, so I will just send you a little line. We reached Port Said on Wed. evening, and found the Barham (a Battleship) there, & dined on board which was amusing. All that night we went through the Suez Canal, & I got up at 6.30 yesterday morning to see it. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" quite narrow with desert on either side, & the most marvellous light early. Just like "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" pictures of Egypt!! Then we got to Suez, & yesterday went through the Gulf of Suez, with Egypt on one side & Palestine I suppose on the other – quite narrow – about ten miles. Quite early yesterday morning we passed the destroyer Wryneck in the Canal. She took us over to Ireland in July, and it was so funny passing her like that in quite another part of the world! They all turned out & cheered us, & it was all so friendly! Today we have been through the Red Sea, & though it is hot enough to wear thin clothes, there is always a little breeze & plenty of electric fans. The evenings are too lovely, with a huge moon. I am not sure whether you will get this letter very long before Xmas, so I will wish you a very merry one darling, and don’t worry about us, because we are simply "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("surrounded")]), _vm._v(" with doctors & people to look after us! We just lie about on chairs & are very peaceful. Au revoir Angel,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 16 December 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Still pretty hot. We arrived at Aden at about 3.30. The Governor came on board, General Scott,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn183",
      "id": "fn_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and we went ashore with him. Large crowds everywhere & most picturesque. We had tea at his house & met the Sultan of the Hedjaz – very beautifully dressed. Also staying there was Miss Ellis, the girl who saw her mother murdered, & was abducted by Afghans."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn184",
      "id": "fn_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" At about 4.30 we drove back, & went to the Crater – the old town, & saw the Tanks – very interesting. Then went to see the Air Force – very nice people. Then round by the golf course, with lots of cheering, & had a drink at the Club, & a dance too. Talked to lots of people. Then dined with the Gov. Very merry little dinner & had great fun. Back to ship at 9.45. Tired!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday 29 December 1924 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("From camp")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We arrived at the camp two days ago, and it is simply wonderful. The country is quite unlike anything I expected, and it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("beautiful")]), _vm._v(". We took two days motoring here, and the camp is in the middle of a huge plain"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn185",
      "id": "fn_185",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" exactly like an English Park, and on every side there are mountains. We have got very nice little huts, and each a black servant. Mine is so good, that I infinitely prefer him to Catherine! There are two professional white hunters, Major Anderson & a Mr Ayre – also the doctor – very nice, Colonel Llewellyn who runs the camp, and Captain Something who is always called K.P. and who is a sort of extra white hunter. He is one of the Governor’s ADCs. There are masses of lions, who growl all night, but they don’t appear much. I am feeling frightfully well; we get up at 6 & one wakes "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("at once")]), _vm._v(", and go to bed soon after 8. The climate is marvellous – the sun is hot in the morning, but it’s quite cool all the time. I am wearing flannel trousers & a jumper & sun hat.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This morning I went out to try & shoot something with Col. Llewellyn, and we dashed after some oryx (very pretty) but couldn’t get near them. It is all great fun and no hardship at all. The flowers coming here were too "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wonderful")]), _vm._v(". I saw great masses of Morning Glory & thought of you, also arum lilies, orchids, carpets of bright blue forget me nots, and wonderfully coloured daisies – big ones like marguerites.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tuesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This morning we got up at 4 and went out to try & get a lion. It was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" thrilling. They had left a rhino & a zebra out, & as it was getting light we crept up behind bushes & found two lions growling over the zebra. Before we saw them we heard the most blood curdling growls and grumbles, and all felt petrified with fear! We all shot together, but it was still too dark to see properly, and they were off like a streak of lightning. Then later on in the day Bertie & I & Major Anderson saw three lionesses and a big lion all lying out in the sun like big cats. They looked very bored when they saw us and stretched & yawned and went quietly into some bush. They are beautiful things and very difficult to get near. I saw about 12 giraffes too the other day – quite close. They are too funny. I enclose a little scribble of what I can see out of the door of my hut as I write. It is very bad, but might give you an idea of the country – it is an undulating plain with little trees right away to the hills – that is Mount Kenya, the peak.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, angel, your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Bertie has just got a lion and 2 buffaloes.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("13 January 1925 to the Prince of Wales")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("[From Siolo Camp, while the Duke of York was away on safari]")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I know now your feelings of relief and freedom when you get away from England on your own – away from all the petty little annoyances and restrictions that drive one crazy. It’s marvellous, isn’t it? I hate to think that you may have a real bad time in S. Africa, and it is terrible to think also that we shall all be nearly a year older before we meet again. At least, I already feel about two years older since December, having aged considerably on board the ship coming out, but I am losing it out here again, and now feel ready for anything.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s a good life here, and you have no idea what it has done for Bertie. He is a different being, quite calm and losing all his nerviness – never turns a hair when he is being charged by a lion, and enjoying every moment of safari life. He was charged by an infuriated lioness with cubs the other day, and she was very close before she died – you sure do get some sort of excitement every day.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have shot 2 oryx (one quite good), 2 Grant’s Gazelle and had a shot at a lion, and am loving it! Don’t tell your sweet Father that I am shooting, but I hope to get something a bit bigger soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is extraordinary how "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" brave one becomes when one is hundreds of miles from anywhere – every day I marvel at my courage, because I really am a loathsome little coward. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hate the thought of coming home – no, I love coming home, but I hate being always under the eye of a narrow minded autocrat, and it will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("awful")]), _vm._v(" with the two human members of the family away. Dear David, I hope your affairs are going well, and that neither your heart or your staff are giving you cause to worry. Those two seem to give you most trouble in life, and also of course you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very very")]), _vm._v(" naughty, but delicious. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There are four wild men here who take us out hunting – one is a villainous young American from Texas – rather amusing, one a sleepy looking man of some English nationality, who is really the most wide awake charmer, & others; it’s great fun, and I don’t look "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" bad in my trousers and shirt. It makes me look very "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("small")]), _vm._v(" which annoys me, but as thank God there are no tall women here, I don’t really mind. God bless you David, & best love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 January 1925 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("From Kenya")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so pleased to get your letter when I got back to camp last night; it brought a little whiff of wet black London and it also made me laugh, which I like. I am becoming very middle class out here, but am terribly happy and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adore")]), _vm._v(" this life. It really is marvellous, and I find that I have taken wildly to shooting. I shot a rhinoceros the other evening, and when I tried to have my photograph taken standing sternly with one foot on the beast, I found this was quite impossible, and had to be taken ignominiously peering over its back. However I shall give you one, as I know you would appreciate it. I rise at 4.30 (I can hear you say my God) & go walking around with my spouse and the white hunter [Pat Ayre], who is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("charming")]), _vm._v(" man with an imagination, an accent & a sense of humour. He is exactly like what I imagine the Scarlet Pimpernel to be, very slow & sleepy & long, and if he wasn’t so brown he would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("rather")]), _vm._v(" good looking. He is English South African and talks American. Everyone talks American here and so do I. We usually hunt till ten or eleven, and then join the camp which has moved after us like magic, & drink and sleep till about 3.30, when we sally forth once again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so pleased, because I can walk "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("miles")]), _vm._v(" here. I should say we walk at least twelve or more per day and mule the rest. I have been very lucky & seen quite a number of lions, and we hunt them wildly which is lots of fun. The game is amazing, & it is such fun to watch them. Rhino are very funny, very fussy like old gentlemen, & very busy all the time, quite ridiculous, in fact. Giraffes I adore – they are utterly prehistoric and very gentle. Also they move like a slow motion movie.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I never "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("knew")]), _vm._v(" that I could like this sort of life so much – out all day long, and one never knows the day of the week. I feel it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be good for one. England seems so small & full & petty and unhappy in contrast to Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The country up here is all plains & hills, mostly covered with bush – all thorn trees and simply huge. The flowers are delicious – this morning we went to try & find a lion which had been grumbling away quite close and failing to find him, I collected seeds & dug up roots, which both shocked and amazed our gun bearers! Yesterday we had stopped by a river to have breakfast when we heard shrill screams, and found a pretty little American lady stuck in her car in the middle of it. We hauled her out, & it turned out to be Mr & Mrs Martin Johnson,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn186",
      "id": "fn_186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who are doing the most marvellous cinema films of animals, hundreds of miles further north. They were coming down for mails, and we spent the day together, as they hadn’t seen anyone for months. He took a movie of us, and close ups of me, which will be ghastly. I will show you when I get home. They are charming and have certainly got the most wonderful photographs of elephant & rhino & leopards that you could imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope you aren’t bored to death with all this – everything is out of proportion now, and I really am getting "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" common. I say ‘Ta awfully’, instead of ‘thank you’, & WORSE. There is also a doctor with the camp, a man called Capt. Caldwell who runs it and Lavinia Annaly. We are all "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pally (!), and talk gaily on the most intimate subjects. Goodbye and may I come & see your modelling when I get back? I have never yet seen your house & would love to.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [March 1925] to Rose Leveson-Gower")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nasir")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn187",
      "id": "fn_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sudan")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Rosie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your letter which arrived a day or two ago. We are now going down the Nile, having arrived in the Sudan about five days ago, and it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" delicious. We had a marvellous time in Uganda, and I adored the shooting. It was very hard work as we used to walk about twenty miles a day – at least Bertie & I & the hunter did, and it was the greatest fun. I shot two buffalo there, and several of the buck, and one day I spent walking amongst elephants. It was simply wonderful, and made one feel such a worm looking at those "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("enormous")]), _vm._v(" creatures. One could watch for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hours")]), _vm._v(" – they are too amusing, and frightfully dangerous, but the man we were with is a great elephant hunter, and we walked about amongst the herds quite easily. We saw the source of the Nile at Jinja on Lake Victoria Nyanza, & then we went right down Lake Albert & went up the White Nile there till we got to Nimule which is the border of Uganda & the Sudan. There we were met by Captain Brocklehurst"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn188",
      "id": "fn_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & we came 90 miles by car, & joined this boat at Rejaf. It is very hot indeed here – in fact the first real heat that we’ve had – 100 in the dining place, and about 120 outside.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Uganda I thought lovely in parts – especially the Ruwenzori mountains – the ones called the Mountains of the Moon, & the Semliki Valley which we walked down. That is about 50 or 60 miles wide, or even 100, with the Congo hills on one side & the Uganda on the other, with Ruwenzori at the top. The birds here are very marvellous – every sort & colour & shape, and the duck & geese are innumerable. [ … ] The early mornings & evenings are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" lovely, just like Scotland – tho’ this is far more African than anything I’ve seen yet. We stayed a day or two with the Francis Scotts [in] Kenya – it was rather amusing finding quite an English atmosphere suddenly like that.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well Rosie darling, I hope you are not going to desert Park Street altogether for that foul Chatham – you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("mustn’t")]), _vm._v(". [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is a very comfortable boat, & it is rather nice to have a real bath & wc, after having neither for about 6 weeks – tho’ personally I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" a tent, and will you believe it – I get up with the greatest ease at 5! In fact I am always called at 6, even on ordinary days!! Jock would laugh. Some ridiculous things happen out here – our boys are very funny – the other day Lavinia wanted me & asked my boy where I was – & all he said was ‘Memsahib Bumbum’ pointing at the w.c. What he thought he meant I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("don’t")]), _vm._v(" know. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lavinia is being very nice & a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("fearful")]), _vm._v(" flirt – she is very modern & I feel quite old fashioned! I wonder if Wisp has shot down here at all? I am longing to show you my heads – how bored you’ll all be with them. Goodbye, darling, from your very loving, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 March 1925 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nasir")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sudan")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I got three delightful letters from you by the last mail, and they made me laugh so much – especially about old Gilbey & Lord Wodehouse! How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadful")]), _vm._v(" about Leslie Blackburn – I sent Aunt Conta"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn189",
      "id": "fn_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" a cable at once – I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" feel sorry for them all. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have had a very peaceful time going down the Nile on this very comfortable boat, and shooting a little here and there. It is certainly very hot, the temp. is 104 inside here! So what it must be outside I don’t know!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The birds are very wonderful here – marvellous colours, & lovely crested cranes & storks & every sort of duck & geese. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Very")]), _vm._v(" few flowers as it is the dry season, but I believe they are good. As a matter of fact we’ve missed the flowers everywhere, except in Kenya.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Captain Brocklehurst is being "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice. He has got charming manners, no temper so far! and has really been very pleasant, & I like him very much. The other man, Major Walsh, is also very nice, about 38, a pre-war soldier & very simple nice man. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wonder if the clothes have changed at all?! [ … ] I hear that James & Rachel are quite friendly towards each other now, which is excellent! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("One is called at 6 always here, and gets up almost at once, & breakfast about 7.30. It really is too hot later, and the sun rises punctually at 6 & goes down at 6 in the evening, when it is nice & cool and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lovely")]), _vm._v(" stars.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We saw a very good native dance yesterday evening at a place called Kodok"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn190",
      "id": "fn_190",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" done by Shilluks. They have a little leopard skin round their waists & huge bracelets & painted faces, & sing very well – rather like a violoncello, & the dances are most amusing. They act all the time, & have lion-hunts & sham battles. Further south where we’ve come from the people are Dinka’s, & wear nothing whatever. They have huge herds of cattle which they live for. A man would rather lose three wives than one cow! They live off nothing but curdled milk & blood – it must be very sustaining! They are very wild but quite friendly. The Uganda people are very civilised round the capital, rather "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" civilised, and the wilder ones in the North look far far healthier & better with nothing on & no religion.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The missions only teach them religion poor things, & don’t trouble about making them work or keeping themselves clean, so consequently nobody will hire a Christian, as they are always dirty & dishonest. Isn’t it a pity? The Roman Catholics aren’t so bad, I believe they do teach them a few occupations.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, au revoir Angel, perhaps I shall get home before this!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 6 April 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Got up in my blue crepe de chine, & said goodbye to my dear & hideous trousers. Arrived at Kosti at 10.30 – flags etc. Joined the train, & puffed off to Makwar, having bidden Capt. Flett"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn191",
      "id": "fn_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" a fond farewell. Very hot. Got to Makwar at 4, & went to see the Great Dam. Lots of engineers & DCs [District Commissioners] & Governors. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 9 April 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[In the evening the Duke and Duchess took the train to Port Sudan, accompanied by Brocklehurst and Walsh.] They sent a lot of soldiers, as somebody had put a bullet through the dining saloon the night before when they thought we were on the train! Dinner 8. Bed 10.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 10 April 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 6.30, no shots at the train yet! [ … ] We are all very sad it is all over – it has been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("marvellous")]), _vm._v(". [ … ] We got out & stood outside the train just before the sun went down, & the Red Sea Hills looked very grim. [ … ] Arrived Port Sudan at 9.30. Met by Tebbits & went straight out to the Maloja"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn192",
      "id": "fn_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – 21,000 miles from Australia. Said goodbye & sailed at once. Goodbye Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 May 1925 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have suddenly thought that I would like to talk to you on the telephone! Will you ring me up one morning when you are feeling like telephoning. I am awake from 8 o’clock onwards. Somehow, when I ring somebody up myself it takes all the pleasure away from it, so if you would grapple with your instrument one morning, I’d be very glad to converse for, say, two minutes. Then perhaps we could make a date for a more magical conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I loved your magic book. The witch was delicious, and I read it on the Nile and it seemed quite possible there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just had tonsillitis and haven’t been out for over a week so I have been lucky – perhaps you are still away? In that case you are still luckier. I am bubbling inside with Africa, but I promise you I’ll keep it there, & won’t tell you stories when I see you. [ … ] What about the Peace of Europe? I feel that E. P. Oppenheim"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn193",
      "id": "fn_193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" would solve any little difficulties at once. Have you read his last book?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 9 May 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 7.30. Breakfast 8.30. Bertie went off to Wembley at 11.15 very downhearted. I got up & listened to his speech on the wireless. It was marvellously clear & no hesitations. I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" relieved.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It all went off very well, & he got back at 1.30. At 3.30 we went off to S.P.W. for a night. May & Andrew"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn194",
      "id": "fn_194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" were there, also Jock & Neva & Anne, David, Mother & Father. Looked at the Rockery after tea, & had a cocktail party. Bed 10.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt-bot"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("This was the speech which was shown at the beginning of the film")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("The King’s Speech")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("(2010, directed by Tom Hooper). The Duke was portrayed as being practically unable to speak because of his stammer. He had indeed been nervous in advance, and wrote to his father on 4 May,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn195",
      "id": "fn_195",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" five days before the speech was to be made:")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("My dearest Papa")])]), _vm._v(" "), _c('p', {
    staticClass: "lt1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("I am enclosing a copy of my speech to you next Saturday, which I hope you will think is short enough. Several portions have been removed including the thanks to different people. I do hope I shall do it well but I shall be very frightened as you have never heard me speak & the loud speakers are apt to put me off as well. So I hope you will understand that I am bound to be more nervous than I usually am.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Best love to you [ … ]")])]), _vm._v(" "), _c('p', {
    staticClass: "lti1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Your very devoted son")])]), _vm._v(" "), _c('p', {
    staticClass: "lti1-bot"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Bertie")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Family reactions to the speech were mixed. The Duchess’s diary showed that she was pleased and so was the Duke. In a letter of 27 May 1925 to the Prince of Wales, who was abroad, the Duke himself wrote: ‘At Wembley the opening of the B.E.E. went off very well, & thank God my speech was a success. In fact I thought it easily the best I have ever done. And in front of Papa too. I was only nervous in the legs & not in my mouth or throat. It was an ordeal but I came out of it all right. I spent several sleepless nights before it though as you may imagine. Papa seemed pleased which was kind of him.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn196",
      "id": "fn_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King George V may in fact have been less enthusiastic. In a letter to Prince George (future Duke of Kent) dated 10 May 1925 he wrote: ‘Bertie got through his speech all right, but there were some rather long pauses.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn197",
      "id": "fn_197",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 September 1925 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your letter arrived this morning, and I simply loved getting it. The posts are very queer here, so I don’t know when you will get this.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, at this moment the gramophone is playing into my ear, Andrew is talking to me, & Jean is reading aloud, so I really don’t know if this will read sense! I am so glad your Aberdeen thing went off alright – my flower show only took an hour, fighting my way round through silly hysterical old ladies, so that wasn’t too bad. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May is really much better and is able to do quite a lot. Today we are going to lunch with Arthur Balfour"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn198",
      "id": "fn_198",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" which bores me very much, as I really don’t care for going to see people in the country, do you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling much better now, tho’ the sight of wine simply turns me up! Isn’t it extraordinary? It will be a tragedy if I never recover my drinking powers."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn199",
      "id": "fn_199",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that the atmosphere at Balmoral is good. Tell Lord Esher"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn200",
      "id": "fn_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" that I am sorry to miss him! He is rather horrid, but rather amusing too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I miss you frightfully, and am looking forward "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so so much")]), _vm._v(" to next week. Only to seeing "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" tho’, nothing to do with Balmoral! It must be dreadfully cold up there – don’t catch a cold darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do write again, I love to get a letter from you, bless you darling, and stick up for yourself, remember that you are an elderly married man, & don’t let anyone patronise you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("So long sweet, your very very loving "), _c('span', {
    staticClass: "epub-strike"
  }, [_vm._v("Bertie")]), _vm._v(" "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("bother")]), _vm._v("! I mean Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 October 1925 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was very disappointed at being unable to come to Sandringham last Saturday, and I stayed here quietly and rested, which helped the stupid neuralgia a great deal. The long day at Norwich would have been unwise too I feel.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think that Bertie has written & told you of our idea of taking Curzon House for the next few months? It is rather an attractive old house, and we can all squeeze in, which will make things much more convenient. I am sure you will think this a good idea, as after October it gets very foggy and lonely in the Park here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tomorrow we hope to see the Tattoo, as it rained the last time we tried to go, and I am longing to see it. It is really very sad to think that in two days that wonderful Exhibition"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn201",
      "id": "fn_201",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" will be no more, and the fairylike buildings empty and forlorn – I do hope they will be suitably occupied soon, & not allowed to go forever.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am really feeling very well; except for headaches, and probably soon they will go. Bertie & I are so pleased and excited about it all, & talk endlessly on the subject, which is perhaps a little previous!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("8 January 1926 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Curzon House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Curzon Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mrs Beevers,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn202",
      "id": "fn_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so very glad that you are able to come to me in April, and shall feel very safe and happy in your hands I know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My mother wants me to have a tonic of sorts, as I get rather tired (& irritable I fear!) and she thinks you would know of something. If you do, would you very kindly send it here?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If not, just let me know, and I’ll ask the doctor for something.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("13 March 1926 to Lady Helen Graham")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn203",
      "id": "fn_203",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Curzon House")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I can’t tell you how delighted I am that you will take on the job of lady in waiting. It will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" so nice for me, and I do hope that you will like it. [ … ] There is no hurry "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("at all")]), _vm._v(" about it; perhaps you will come & see me when you come to London, & we can arrange things. Engagements are made so far ahead nowadays, that you will be able to make your plans quite easily, and I really need very little – just a few letters to answer, & protection from certain determined old snobs!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I really am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pleased that you have accepted, & now that I am writing to you, I would like to say how "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(" sorry I was about your father’s death. It is such a terrible break-up, I do feel so terribly sorry for you all, & send you my real sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours affec:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 April 1926 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The baby clothes have all arrived, and they really are quite exquisite. I do not feel that I can ever thank you enough for giving me such a lovely present, but at any rate, it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much appreciated. The day frocks are too angelic, and the little sheets I examine all day! I do thank you so very much; you are far too kind and give me such divine things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just sitting here waiting now, though I don’t think it will make an appearance for another two or three weeks. It is very dull, but I haven’t got very long to wait now, and Bertie is being angelic, and so understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I expect Windsor must be looking delicious, and I hope you are having a rest after your more than strenuous winter, and all its anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, and again a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("thousand")]), _vm._v(" thanks from your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Princess Elizabeth was born at home in Bruton Street on 21 April 1926. The next day the Duke of York wrote to his mother, saying, ‘You don’t know what a tremendous joy it is to Elizabeth & me to have our little girl. We always wanted a child to make our happiness complete, & now that it has at last happened, it seems so wonderful & strange.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn204",
      "id": "fn_204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 August 1926 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so dreadfully ashamed, but I have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("just")]), _vm._v(" found a letter I wrote last week in my blotter, about plans, and so I have hurriedly sent you a telegram. I can’t tell you how sorry I am, as you must have thought me so odd not writing. [ … ] I hope it’s alright coming on Wednesday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, and I, the baby, Alah"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn205",
      "id": "fn_205",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & nurserymaid, Catherine & Osborn!!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn206",
      "id": "fn_206",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Isn’t it a terrible party?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I simply can’t tell you how much I am looking forward to a peaceful time at Glamis. I haven’t really been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("properly")]), _vm._v(" in the country since last September, & I am longing for the country. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother, Bertie’s brother David is longing to come to Glamis for a night or two at the end of September, only he doesn’t want to be a nuisance he says. I told him the Forfar Ball was on then, & he would love to come unless he’s in the way. Do tell me when I come up. He is so frightfully modest, & is terrified of pushing in where he’s not wanted. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling, I am longing for Wednesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 October 1926 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for the darling little boots & the little shoes which are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("perfect")]), _vm._v(". She wears both pink & blue, so either colour would do if you were thinking of making another pair. I am longing for you to see her – she is growing so big and is as sharp as a needle, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She sleeps beautifully, and has always got a smile ready. You won’t recognize her!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am very well, and had a delicious long rest up here which I loved. I hope I shall see you in London – do come in when you can. We shall get to Bruton St on the 11th, and we shall be very busy preparing for this horrible trip.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for the boots & shoes. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" so kind of you Nannie B.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours affect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I’ve just finished another Pilch [knitted baby garment]!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I shall send you some kodaks in a few days of the baby.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 October 1926 to Major R. H. Walsh"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn207",
      "id": "fn_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Walshie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I am so glad that you were not bored at the tennis. I thought you simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" have been. I loathe it myself! Did you enjoy your leave? I was so sorry that we saw so little of you. Next year will be more normal I hope, though by next June I shall be old & worn & grey after our Australasian tour. You must prepare for a cynical & hardened old woman of the world by the time I’ve finished with the Aussies. [ … ] I’ll bring my gramophone and my ’275 [hunting rifle], & we’ll vary the Charleston with a little letting off at crocs & other four-legged animals.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Forgive this awful writing, I’ve been pretty busy, and I’ve found such a good new cocktail. Not strong enough for you I’m afraid, but you must sample it next summer. And after all you can always have two. Or three. Or four.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I saw Brock [Brocklehurst] in Scotland – he seemed in excellent form. A little prone to talking of death, but then one is used to that of course, & takes little notice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Did you fall in love this summer? Sorry, that’s very rude – forget it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was nice of you to write, do so again soon please, & tell me local news. I love hearing, it reminds me of that wonderful time nearly two years ago now – how I’d love to go shooting Boooshbuck once again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 October 1926 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Norfolk")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your two last letters. I am so sorry that poor Father has got a cold, and I do hope he is better now. I wonder when you will be coming south? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We leave here tomorrow, & return to B.[ruton] Street. I honestly don’t know what we would have done without it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The baby is very well, and now spends the whole day taking her shoes off & sucking her toes! She is going to be very wicked, and she is very quick I think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("It is a million")]), _vm._v(" times better here than at York Cottage."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn208",
      "id": "fn_208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Plenty of room, and a much better atmosphere. [ … ] I never had a moment to write in London – I was flying from Piccadilly to W. Lodge & back! Lord Lee is going to take it [White Lodge], so that’s all right."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn209",
      "id": "fn_209",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The house is getting on slowly. I am going to spend my Marland Oil"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn210",
      "id": "fn_210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" (when it goes up) in doing several things to make it prettier. Two pilasters on either side of Bertie’s fireplace, proper pillars in the hall, a new overdoor in my bedroom, etc etc which are small things but I hope will improve the house. Luckily Mr Parvin the head man of the decorators has got "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good taste, & one can trust him not to do anything dreadful. Goodby darling, "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" come to Bruton St when you want, as your room is empty and also Father’s downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In January 1927 the Duke and Duchess set off on a long imperial tour focused on Australia and New Zealand. This had been agreed in the summer of 1926 and the Duchess had been dreading it because it meant that they would be parted from their daughter for at least six months.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Their other concern, shared by the King and Stanley Bruce,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn211",
      "id": "fn_211",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" the Prime Minister of Australia, was whether the Duke’s stammer would prevent him delivering all the speeches that a formal tour required. Fortunately, help was at hand. In October 1926, encouraged by the Duchess, the Duke began consultations with Lionel Logue, the Australian speech therapist. Logue had an extraordinary gift and over the next few weeks his treatment, which involved breathing and other exercises, helped the Duke as nothing had before. The Duke wrote to thank him: ‘I am full of confidence for this trip now.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn212",
      "id": "fn_212",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 6 January 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 7.15. Up by 8.30. Feel very miserable at leaving the baby. Went up & played with her & she was so sweet. Luckily she doesn’t realize anything. [Dr] Still came for a minute, & I explained about the baby. Mother came in at 10 for a short time. I had on a grey lamb coat with fox collar & grey everything else. I drank some champagne & tried not to weep.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Said goodbye to the baby & Alah downstairs, & left at 10.40. Large crowd, also near Victoria. Long leave taking & at last the special train left. David, Harry & George"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn213",
      "id": "fn_213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came down to see us off. Huge crowds at Portsmouth, & the Renown"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn214",
      "id": "fn_214",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" looked lovely. Lord Cavan"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn215",
      "id": "fn_215",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" was on board. We left at 1.40, & soon got into bad weather!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 January 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall have an opportunity to post some letters tomorrow, so just a little line to tell you our sparse news.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have settled down very comfortably, and after a horrible night & day, the weather seems better – today was very pleasant and quite warm. We had a very nice Church this morning, but that has been our only diversion so far. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Captain is very nice, and they all take great trouble to make us happy. I felt very much leaving on Thursday, and the baby was so sweet playing with the buttons on Bertie’s uniform that it quite broke me up! David & George & Harry were all angelic, and cheered us up for a bit. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, ever your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 January 1927 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I believe a post goes tomorrow, so I thought I’d drop you a line, tho’ there is very little to say. We had one very rough day on Friday, and it got better yesterday and was really very pleasant and warm. This evening it is a little rougher, and we may not be able to land at Las Palmas tomorrow which I don’t mind as there is nothing to see there! We cannot get closer than 2 miles of the island, & as the Atlantic has a very big swell which doesn’t notice in a big ship, one cannot get a boat close enough to get into.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are very comfortable, and the food is excellent. Today was lovely with a warm sun.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tortor"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn216",
      "id": "fn_216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is very nice, and I only see Joan Cavan at meals as she mostly stays down with poor Lord Cavan."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn217",
      "id": "fn_217",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You will go and see the baby, won’t you darling, and when she is at BP, just ring Alah up, & either run in and see her (same door as we used Wed. night) or tell A to bring her to you. You will never see the King or Queen, as they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" use that door & are quite separate. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, au revoir darling, I will write again fairly soon, and give my love to Father and everybody.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 11 January 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] Just before dinner heard that Diamond"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn218",
      "id": "fn_218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" had died this morning. A blessed relief, but it seems so sad. She has suffered so much.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 5 February 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke very early, as we slept out. Not a breath of air. Read & talked to Bertie etc. Sat out & read & slept a little on the triple gun deck. After tea played some deck tennis. Felt depressed – I miss the baby all the time, & am always wondering what she is doing. After dinner four of the midshipmen came up & danced. Courtney very good Tango & Charleston. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 February 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Nukuhiva, Marquesas Isles")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have spent a very pleasant two days here in this lovely Island, and quite regret leaving today. After nearly a fortnight at sea, it was delicious to be able to stretch our legs again. We went on expeditions and fished and bathed. It is very hot indeed and my cabin is 95 deg:, but the evenings are fairly cool which is a help.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The natives danced for us last night, and it was really most remarkable, and very interesting. They are brown and the men quite nice-looking, but very diseased and are rapidly dying out. Instead of being strong healthy cannibals with strange religions and no clothes, they are now weakly half hearted Roman Catholics with European clothes. It seems all wrong, but that is what happens.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We lead a very pleasant life in the ship – we dance sometimes after dinner on the quarter deck, and the officers are all good, and especially the midshipmen who dance quite beautifully. Tortor is being a great success and such a help – I only hope that she will stand N.Z. and Australia well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is very difficult to write in this heat, so will you please forgive rather a stupid letter. There is so little as yet to tell you, as in all these five weeks we have only stopped at Las Palmas, Jamaica, Panama & Nukuhiva. Panama was very interesting indeed, and the Americans do run it in an amazingly efficient way. They really were very nice to us, and did not make themselves at all a nuisance. I don’t know what their Press said though, and that is far the worst part of them. We feel so terribly cut off from home, and have heard no news beyond the usual wireless Bulletin, which only mentions China and football results.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you like having the baby, and that she continues to be well and happy, and no colds. They do put a baby back so much, and I was always very particular that people with colds should not go near her. [ … ] I miss her quite terribly and the five weeks we have been away seem like five months.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I promised my father that she should go to him later on, and I thought that April would be a good time, and it will do her a great deal of good to be in the country for a bit, and especially when it gets warmer.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I will write again a little later, and hope to have more to tell you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are well, and no horrid colds or influenza for you or Papa. With my very best love to you & Papa, I am darling Mama, your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("8 March 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Government House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Wellington")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are just finishing our visit to Wellington, and this evening we return to the Renown for the night, starting tomorrow on the tour of South Island.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The fortnight in the North Island seems to have been a success, though rather tiring and everybody has been very nice to us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The marvellous loyalty of the people of N.Z. is quite amazing, and any mention of ‘the King and Queen’, ‘the Mother Country’, ‘The Empire’ or ‘Home’ or any other expression brings out such very genuine and whole hearted cheers that it gives one quite a lump in the throat. The children are so well looked after here – so different to England, in that they come first in "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("everything")]), _vm._v(". They are taught to be loyal to the Crown before anything, and then they are taught to be well & healthy & clean. Everywhere that we have been, we have been intensely struck by the appearance of the children. Apparently the teachers are very good, and they have to take most stupendous oaths of loyalty to the Crown before they are allowed to teach. Considering that it is the Crown that keeps the Empire together, I think it is a pity they are not more particular about teachers at home.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rotorua was most interesting. I expect we saw much the same things that you did in 1901. I must say I hated walking round the geysers, although I was so interested, thinking that every moment we would all disappear through a thin crust into the unknown!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We both rather dread Australia, as politics there seem to govern everything, but I am sure it will be all right when we are once in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are enjoying the baby, and that she is not too advanced for her age. I miss her more and more, but am happy to think that she is being so well looked after.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday I opened a Hospital for babies & mothers here, run by Sir Truby King,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn219",
      "id": "fn_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who has done a most amazing work in lowering the death rate for babies. I hope that it will really spread in England, though of course his ideas will have to be adapted to suit conditions in England.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I find that clothes are a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" problem here, especially when we are joggled about for days in motor cars, and the luggage is always going ahead or following after!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Already I long sometimes for a really quiet few days, and by the time we get home, we shall be pining for solitude.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must fly to a Garden Party.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("with very best love darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess had another attack of tonsillitis and remained in Auckland while the Duke went to South Island. She then rejoined the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Renown")]), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v(", which went to pick him up on their way to Australia.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 15 March 1927 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Wellington")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have just arrived here, and I am feeling very lonely and wishing I was with you, and that I could help you a little bit. It is so much easier for two than one, and anyway when you tackle the Mayor, I can tackle the Mayoress!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think you are marvellous the way you keep it up, and so does everybody else. I only hope you won’t be too terribly ‘done in’, and that you will get three fine days going to Australia. It is much too short, and quite ridiculous to think that any human can do about eight weeks at a stretch.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("On studying the Aust. Programme it’s really not so bad in a way, as there are several ‘free’ mornings evenings etc, & here we’ve only had 2 Sundays!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Darling when you are feeling very depressed and tired, remember what wonderful work you are doing. They all loved you in N. Island, and quite rightly. All the sentimental twaddle they write about me is obviously absurd – they always like a bit of romance, & the baby too helps the women to get silly – horribly silly.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am using your cabin today as it’s cooler, and am sitting in bed & feeling very depressed – I always do from 4 to bedtime when I’m ill!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The poor old Town Clerk of Nelson fell into the sea yesterday when he went to ‘receive’ the ship. Batters"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn220",
      "id": "fn_220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" clutched his behind just as the waves closed over it, & plucked him out. It was very rough.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Everybody was so kind in Nelson. The baker sent me bread, the bookseller books, the ladies cakes & flowers, the fruiterer pears and grapes, Lady Rhodes also bunched me, and all I wanted really was a nice comforting kiss from "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(". I never dreamt that I would be such a failure, but no doubt women are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" made for the life we were leading, or men either if it comes to that. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I do pray that you will get through this nightmare of a programme and I shall "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("only")]), _vm._v(" look forward to the moment when I shall see you again. I send you all my love and hundreds of kisses & several hugs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 March 1927 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Wellington")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("N.Z.")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was angelic of you to write. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is a lovely country, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anything")]), _vm._v(" grows. The climate really is divine, & quite hot. The children are marvellous – so strong & healthy & good looking the NZ children are. Not like your puny, pale, small delicate & hideous children. Poor May, what a trial it must be to you. I often wonder if you hear all the nasty things that people say about them. ‘What lugubrious kids’ I heard an elderly Peer exclaim, ‘Have they melancholia?’ I heard another time some nasty whispers about ‘miserable little things – beaten all day & nothing to eat – can you wonder they’re skeletons’. However – don’t worry, dear May, I expect they’ll grow out of it. I am so looking forward to June 27th. Shall you be in London? Oh do be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I saw Mr Parker here!!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn221",
      "id": "fn_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I danced with him. He proposed to me during the war, but I don’t believe I ever answered him. It’s too late now I suppose. Well, au revoir May old pip, Give my love & kiss to Sidney & the darlings.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 April 1927 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Tamrookum")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Beaudesert")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Queensland")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am afraid I haven’t written for ages, but there really hasn’t been time, and soon you will see us before a letter can reach you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have come here for Sunday to stay with a Mrs Collins. It is most lovely country, and this is a comfortable one storey house. It is a large station – mostly cattle, & Bertie has been out all day mustering cattle and enjoying himself. The climate is marvellous – very hot sun and cool breezes, and we have both enjoyed ourselves up here in Queensland. The people are so nice & friendly, & the distances are so vast that it keeps them simple.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling so well, and hope to keep so. I do hope you have got the baby now, as I know you will enjoy her. I am so looking forward to June. The tour is going very well, and all the Scotch people are very glad to see me!! They are so nice & sentimental about each other.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have seen Mr Dent, Mr McKillop, Nobby, Mr Brown & many others – also Emilie, Frank, & Cyril Cato!!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn222",
      "id": "fn_222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Frank looks exactly the same.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Though we are working very hard, & find some of it very boring, I have managed to keep well, & I really believe that it is all being a success. All the Governments are Labour, and the N.S.W. one is composed of very Red people. However, I got on very well with them, & the acting Premier here comes from Longforgan, so we get on like a house on fire. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I am longing to see you & the baby, from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 April 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("nearing Melbourne")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am afraid I have not written for a long time, but we have been so terribly busy, that letters are extremely difficult to write.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Everything seems to be going well. I think this sort of tour is far too strenuous for a woman, and I do get terribly tired – of course wireless, cars and the Press complicate things enormously, and one is expected to do the impossible, with never a moment’s rest.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("For instance in Tasmania, when you & Papa stayed at Hobart, we had to go off to Launceston their other town – merely because there is keen hatred & jealousy between the two towns, and if we had not gone there, the whole Island would have been furious. The jealousy in Australia is terrible – of course they are young, but it makes everything so ‘suburban’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Politics are very bad in N.S.W. The Premier who is cordially loathed by all classes, never appeared, except when we landed, & I expect he will very soon be thrown out.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Most of the Ministers are disgruntled Englishmen with a grievance, and none of the better class Australian will touch politics. It seems a great pity, but perhaps a sense of responsibility will grow in time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We had a most delightful time in Queensland with wonderful weather. The people were so nice and friendly, even though they are called the Bolshie State. Everywhere they talk of yours and Papa’s visit, and this loyalty is amazing. The children are so healthy to look at, but very spoilt, and completely without discipline – I don’t believe they have any home life to speak of.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please forgive me for setting out my opinions in this manner. They are probably completely wrong, but just what I think personally, and only after a glance really.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It will be delightful to get home and have some real peace, after these months of crowds and publicity. I shall be so excited at seeing the baby that I don’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dare")]), _vm._v(" think about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie has been wonderful, and is far less shy & more sure of himself. I expect this Tour will mean a great deal to him. Do you remember you told me at Sandringham what a help such experience would be to him?"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn223",
      "id": "fn_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You have been so kind to the baby, and I do hope she will go on being so well & merry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With so much love, ever darling Mama, your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("They embarked in the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Renown")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("on the voyage home on 23 May. Three days later a fire broke out in the engine room which could have destroyed and sunk the ship. Years later Queen Elizabeth recalled:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘The nearest ship was a thousand miles away. Totally empty sea. So we had to prepare to leave. The deck got quite hot and I couldn’t think of anything to take in the boat except a bottle of Malvern Water and my [book of] prayers. I couldn’t leave them behind.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 June 1927 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("In the Red Sea")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have not written to you before, as I know that Bertie writes regularly & tells you our news, but I thought I must write a little line to say how much we are looking forward to seeing you and Mama again. It seems such a long time since we left you in January, and I cannot believe that we are really getting home at last – older, and I hope wiser!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will not think me looking old and ugly, but a week in the Red Sea in June does not help the complexion to look its best! It has been very hot, and my cabin (sleeping) had been 105, which is most uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We had a bad time in the Bight, and I got washed out of bed at 3 A.M. by a huge sea which crashed suddenly over the ship, & had to spend an hour drying my hair at the radiator! I could not help laughing, but it was very annoying too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I see that dear ‘Rose Marie’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn224",
      "id": "fn_224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is finished, but that another good play is on with Edith Day"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn225",
      "id": "fn_225",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" – I fear the music won’t be as pretty, because the ‘Rose Marie’ tunes were quite out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I also read in the papers that Lily Elsie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn226",
      "id": "fn_226",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" has returned to the stage – I wonder if she is as pretty as she used to be. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mr Bruce [Prime Minister of Australia] was charming, & quite undaunted by having to deal with four "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" Labour State Governments. N. S. Wales has got the most revolting set of politicians that one could imagine – they are like men out of a nightmare, & seem to be well on the way to ruining the State.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am looking forward more than I can say to the baby & a good rest. I have missed her all day & every day, but am so grateful to you & Mama for having been so kind to her. It will be wonderful to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your affec: daughter in law,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("22 September 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to thank you so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for my delightful time at Balmoral. As usual it was the greatest fun, and I loved every moment of our visit. I was so sad at leaving both you & Papa as invalids on Monday, & am so glad to hear in Alah’s letter today that Papa was able to go out.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Our visit to Glasgow went off very well I think – especially as it rained without ceasing from morning to night! I could have spent hours at the Exhibition,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn227",
      "id": "fn_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" it was so well arranged & so interesting, but as usual time was short, & we had to hurry round.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I visited a child welfare centre in Govan on Tuesday, & had a marvellous reception from every shade of socialist, crimson, red & pink!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so looking forward to coming back next week, it will be delightful to see you again, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("trust")]), _vm._v(" that you will be able to dance by then, & that Miss Gordon has done good with the electric treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I miss the baby horribly, but am so glad that you are enjoying her (how swelled headed I am about her).")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & so many thanks for such a heavenly fortnight at Balmoral.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 April 1928 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Le Zoute")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are having the most wonderful weather here, and are enjoying ourselves very much indeed. This is a most delightful place, and the air is marvellous, and we both feel very well & extremely healthy! We play golf every day, and do a little sightseeing also which has been very interesting. Yesterday, after church, we went to Ypres, and spent a very interesting few hours seeing some of the Flanders battle area. We went up to Hill 60 which is kept as it was in the War, saw the Menin Gate"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn228",
      "id": "fn_228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" which is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" fine – really magnificent, also Zonnebek & a lot of the famous villages of the War. It was very tragic in a way, and perfectly amazing in the way that the Belgians have effaced almost every sign of the War. Instead of a sea of mud & shell holes, thousands of new houses, thriving farms and prosperity everywhere. They are great workers & very willing ones. Also great money makers – even the little children try to sell ‘souvenirs’ that they have picked up – bayonets, bullets & cap-badges etc – which is rather dreadful really! We also went to Bruges, and saw the pictures and buildings, & Zeebrugge, where we went on the Mole, & went through the War Museum, which is one of the best & most interesting that I have seen.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The War is very near here, because of course the Germans occupied all this country for years & how they hate them in these parts.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are staying here as Lord & Lady Inverness, and everybody has been most kind, & allowed us to go everywhere incognito. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & please forgive this hurried letter – we do so much there seems to be no time! Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("13 July 1928 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been meaning to write to you ever since you left,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn229",
      "id": "fn_229",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and I feel very badly about it, especially as I enjoyed your two letters enormously. You gave me such a vivid picture of your life – I can imagine it all quite well, & am so glad that it is pleasant. To have a pleasing place to live in makes the whole difference, a house, I mean & I am so glad for your sake that you have found something that you like.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It amused me to hear that your sense of drama took you through any awkward moments of official entertaining! It sometimes helps me when I am faced with difficulties in that line. What a lot of our life we spend in acting. I expect that it is very lucky really, otherwise one would hardly ever be decently polite.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been very busy these last two months, and am looking forward "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" intensely to Glamis at the beginning of August. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("know")]), _vm._v(" that I am happiest in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Would you like some books or have you got a great many? Have you read,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A Lost Lady,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Uncle Tom Pudd,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The White Wallet (a soulful collection of poetry)."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn230",
      "id": "fn_230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If not, I will send them & some others, but I expect that you are well supplied.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Last night I dined with Venetia James, & a large dinner party of elderly couples, all Lords and Ladies, except one Baronet and his wife. All gossipy & a little dangerous, & with very little beauty. Then I left early & went to a cinema party given by the Mountbattens"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn231",
      "id": "fn_231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" at Brook House.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What a contrast. Lovely ladies with no very definite ideas in life beyond looking beautiful & having at least one young man; the King of Spain, making love to them, & altogether a very modern gathering.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think that it is good to have some real butterflies flying about. They do very little harm, & they certainly decorate a room very well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("In the afternoon we went to Stoke Newington E[ast], a supposedly very Red part of London, where we were greeted by huge & frenzied crowds. How lucky that the throne is not included in their political views. I really do think that their politics makes very little difference to their loyalty. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have met Osbert Sitwell"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn232",
      "id": "fn_232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" lately, and I find him charming. He was a little restrained, but I believe that when he unbends, he can be most amusing. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Life in London is always exactly the same, except that I miss you coming in for a talk & a drink of an evening. There is a chance that I may meet the McEwens at Lumley this weekend. I do hope so. I must quickly stop, & write to the Bishop of London, Lady Grey of Falloden & Sir Oliver Lodge before I go out. They have each sent me books written by themselves! The first an account of his journey round the world, the second a book of poetry, & the third a book on spiritualism. I shall write exactly the same letter to each.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that all goes well with you, & that the sun will shine on you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I like the Godolphin")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 December 1928 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you both a thousand times for sending us that lovely cup. It was so kind of you to think of us, and we were delighted to have it. I am sending you a little tiny present, which I do hope you haven’t already got one of. It’s a pair of gardening scissors, & they are supposed to hold the flower when ‘plucked’, & thereby saving much labour!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are still here, but hope very much to get away after Xmas for a day or two. All this long anxiety is very wearing to mind & body!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Darling May, will you forgive me if I say something to you? It’s very interfering of me, but Bertie who has suffered so horribly himself, is terribly anxious that Andrew’s stammer should not get worse and he did not think that he was any better when he came to lunch here. It would be so horrid for the darling little boy if it became too much of a habit to get out of, and I expect "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("now")]), _vm._v(", that it’s only that he is always thinking a few words ahead!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that you don’t mind me saying this – it’s only because I love you all that I dare, & one gets so used to it, that one hardly notices a little stammer like he has got.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Would reading aloud help at all do you think? It’s really not serious enough to notice much, but now’s the time to stop it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What a letter! Do forgive me old sport, and deal a few kisses round the family not forgetting Sidney & yourself")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 14 March 1929 the Duke and Duchess travelled to Oslo, via Berlin and Sweden, for the wedding of Crown Prince Olav of Norway to Princess Märtha of Sweden.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("15 March 1929 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("British Embassy")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Berlin")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We arrived in Berlin early this morning, and came straight here to bathe & breakfast. Afterwards, we spent 2½ hours seeing over the Schloss, which was most interesting & rather sad. Especially the Kaiser’s own rooms which they showed us, which of course have none of his own furniture left in them. Incidentally, in his dressing room which was filled with paintings & pictures, we found a charming picture of Frederick Duke of York by [John] Hoppner. I coveted it very much!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then after luncheon here, we went out to Potsdam, & saw Sans Souci & its gardens & the Neues Palais. It is rather sad seeing all places public, but they are in such good order – gleaming furniture etc. I was especially taken with the many little Watteaus at Sans Souci.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then, just to see a little of modern Germany, we had tea at a tea & dance place in Berlin. It was most amusing. I am writing this before dinner, & then we resume our journey to Oslo later this evening. The Rumbolds"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn233",
      "id": "fn_233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" have been most kind, and I have enjoyed my day here, tho’ rather a tiring one as we have seen a lot in it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that Lilibet is well, and I am sure that she is enjoying Bognor very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 March 1929 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Hotel Kramer")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Malmö")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you know where I am? I don’t really, & can’t find an atlas. We arrived here this morning from Berlin, & found that our train which arrived here at 10 am, did not leave until 9.30 pm. So we came to this hotel and I can’t tell you how comfortable it is. Exquisitely clean, with magnificent bathrooms, & excellent food, and if I can ever discover where we are, I think that I shall come back some day.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Governor of the Province arrived after lunch, & arranged a little sightseeing. Firstly we went to see a castle built in 1540, quite untouched, of delicious little pink bricks. It belongs to an old Baroness who is 70 years old today and we arrived with dozens of other guests all bearing flowers & clicking their heels. A birthday party! & such a deliciously old fashioned atmosphere of compliments and clicks, & tea handed in boiling hot rooms by Rectors of neighbouring Universities. I enjoyed it so much, and they all talked such good English.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then we went to a town called Lund and looked at a Cathedral etc which was most exhausting.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot think of more of a contrast than you in effete Portugal and me in more than efficient Sweden. So well educated & every cottage with electric light and telephone. We are going to Oslo for a wedding but our train, which started in such a businesslike way from Calais, every second being of importance, has now deteriorated into a kind of Oriental timeless affair, & I feel that we may be days before we reach our destination. We ought to be at a reception at the French Embassy there tonight. Instead of which we are sitting in a spotless room furnished with chairs of a hardness that I cannot describe. The other 3 members of our party are reading E. Wallace."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn234",
      "id": "fn_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I am writing to you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am delighted to hear that you are coming home soon, & I hope also to get home, but I really don’t know whether we shall. I feel quite prepared to take weeks over the return journey. Are you an unperturbed traveller? I am always very calm and rather annoying, & I point out things I see out of the window, which is unforgivable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We must dine soon, my pen rushes along these little lines leaving sad drivel for you to read I fear.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21 August 1929 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Ballater")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so very kind of you to send me that letter by Harry, and I can’t tell you how delighted I was to receive it. I am sure that we are going to love being here,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn235",
      "id": "fn_235",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" in fact I already feel that I have lived here most of my life. The garden is too lovely, real masses of flowers, and the burn makes a lovely rushing noise, very soothing at night!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie & I went down to Balmoral on Monday, and the garden is looking perfect. There are some very good beds of pansies outside the ballroom which are most effective. Everybody is so sad that you & Mama are not coming up this year,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn236",
      "id": "fn_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" in fact old Arthur Grant"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn237",
      "id": "fn_237",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" was most emphatic that the air would really make you feel well again. But I must admit that the air, though like wine, is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" cold; and there has been no sun yet. In fact it is colder than I have ever had it when I stayed at Balmoral, but I expect that it will warm up soon. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is so kind of you to let us come here Papa, and we are so happy in this heavenly place, and I only wish that you could be up in Scotland too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But I am sure that the bracing air of Norfolk will soon make you feel better. It is too awful to think of the long & dreary time of illness that you have had, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that you will soon begin to feel really well again. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes, aren’t the Wee Frees"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn238",
      "id": "fn_238",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" silly old things, we thought that it was such a holy little occupation for Sunday!! They are dwindling fast poor things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love, dearest Papa, ever your")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 November 1929 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for sending me your book. It is so kind of you to have thought of me, and I have enjoyed reading it more than I can say. I am appalled at the horrible end of Edgar Poe – this seems a trivial thing to mention, but I had no idea that his death was so sordid."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn239",
      "id": "fn_239",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Elections are so horrible, & bring the worst out in everybody, so perhaps it was an appropriate death. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that we may meet again some time, perhaps in the house of your dedicatee"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn240",
      "id": "fn_240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" (if there is such a word). If not in her house, I hope that you will visit us here. I am longing to know whether you have")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A) Arranged that the Foundling Hospital"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn241",
      "id": "fn_241",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" become an 18th Century Museum")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("B) Managed to delay the erection of that menace to good health & good pictures in Battersea. That would indeed be good news, but I fear the worst."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn242",
      "id": "fn_242",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again so many thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 November 1929 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have started so many letters to you since August, & each one has died a horrid death by fire or hatred. The reason is this. August and September were so wonderful in Scotland, that one rose eagerly at 8 am and came home at sundown, weary and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(" contented, and letters were almost impossible to write. The sun blazed all day (a Scottish blaze, not your Portuguese haze) and I felt so well at the end of the Autumn that I kept on saying to myself, ‘My goodness, how well I feel.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But I have often thought about you, & wondered whether you will be coming home for leave soon. We shall be delighted to see you when you do come and there will be a great deal to talk about, what with one thing and another. It is very foggy, and dark and cold here now, and I am just going off to Naseby"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn243",
      "id": "fn_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" for a few days in the Midlands. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Let me see, what news is there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Queen of Spain"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn244",
      "id": "fn_244",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is here and luncheon parties and dinner parties are given for her by all the snobs in London. And she is so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("extremely")]), _vm._v(" nice too, and very brave.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you read A High Wind in Jamaica and do you like it? Also The Man Within; the latter irritated me very much at moments."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn245",
      "id": "fn_245",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Labour government is spending a lot of money. I have spent too much money.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your latest letter. I feel very ashamed of my long silence, and fear that this letter will really hardly be worth receiving. I have been doing a lot of stunting lately, but am going to have a blank week now – it is really very boring at times. One wonders how much good it all does. I think that half the good of a long slaving day in Birmingham or Manchester is undone by a few paragraphs in the Daily Sketch or Mirror describing my very frequent new dresses and my alterations to this house. Already this year I have done up my sitting room five times, and the number of dresses trimmed with diamonds would keep ten families going for ten years. It is very annoying isn’t it? However, we must take the rough with the smooth & keep the old flag flying. Hooray.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With kindly & Christian thoughts to ALL, I remain yours sincerely, if a trifle sourly, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In December 1929 the Duchess realized she was expecting another baby.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 December 1929 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to ask whether you can come to me in August! [ … ] I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope that you are not engaged, because then it would be too dreadful. Also Simson"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn246",
      "id": "fn_246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" said perhaps it would be better to be ready at the end of July in "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("case")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have not told a soul yet, because people find out all too soon, and that makes life miserable, so would you please keep it quiet too, as long as you can? I hope to keep it a secret for a good bit yet.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("if")]), _vm._v(" you are engaged in August, you must ruthlessly chuck the poor woman. No, I don’t really mean that, but I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope that you will be free, as I couldn’t bear it if you could not come to me. I do hope that you are well, and that the Weymouth baby"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn247",
      "id": "fn_247",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is better. You must have had a terrible time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall be back in London on Friday.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 February 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Naseby Hall")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Northampton")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your most kind and sympathetic letter. It has been a great blow to us all, as Jock was a very dear brother,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn248",
      "id": "fn_248",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" and we shall miss him so much. He was so clever, and wise too, and one could always depend on the very best of advice if one ever wanted it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("He had been very ill with pneumonia, and on the Wednesday before he died was really much better, & the doctors were very pleased. Then suddenly came another abscess on the lung, and he died on Friday morning, as by then he was too weak to operate. Nobody expected such a thing, and I can hardly believe that it has really happened.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your letter was so understanding and comforting darling Mama, and I thank you with Papa and yourself from my heart for your sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Always your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I have just returned here from St Paul’s Walden where I went for the funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 March 1930 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Naseby Hall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so pleased to receive your letter this morning, especially as you can have no idea how deeply depressing every aspect of life has been here, for months, and your letter was so deliciously and refreshingly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cheerful")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am delighted that you are so happy in Rome, and you certainly deserve to be, after your exile in Lisbon."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn249",
      "id": "fn_249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" It all sounds quite perfect, I am sure that one must be surrounded with Beauty to be really happy, and you seem to be wallowing in it (if one may use such an unsuitable expression). I am glad to hear that you have escaped a wild Marchesa up till now, but in your present state of mind I much fear that shortly I shall hear rumours of an ENTANGLEMENT.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This morning I had two letters of interest. One from yourself, and one from Mr Thornton Wilder"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn250",
      "id": "fn_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" sending me his last book ‘The Woman of Andros’. In his letter he writes, ‘This one was to have been, alas, a book in praise of Christianity. It was to have shown the frustration of some finer pagan minds, and their wistfulness, as they groped by intuition towards the handful of maxims that was soon to modify home-life, education, the theory of the state, and most of all, man’s courage in regard to himself,’ and several more pages.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" one answer letters like that? I love authors sending one their books, but how difficult to thank them. Please "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" write a book. What "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" one say? Dear Mr Wilder, Thank you so much for your most delightful book. How interesting the story of the frustration of those pagan minds and their wistfulness as they groped by intuition towards the handful of maxims etc etc –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you not dislike intensely the word wistful? I do. At least, I have never thought about it before, but having written it twice on this page, I now loathe it with a great loathing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think that next year we must come to Rome incognito, and enjoy ourselves. I am sure that it must be very bad to stay too long in this country, and think only of Lord Beaverbrook,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn251",
      "id": "fn_251",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and parrot disease, and debts (one’s own) and the kitchenmaids going, and whether one should offer up a prayer for the Boiled Bishops of Russia.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you will get your apartment on the top of a palazzo. It sounds perfect in every way – in fact most delectable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The toffee that you kindly sent Elizabeth is very much appreciated, and the second tin is now being eaten. It was very nice of you to remember, tho’ I fear that there was not much chance of your forgetting after such a very pointed question!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes it was terrible about Jock, and I can’t tell you how much we all miss him in the family. Though sometimes he was sarcastic & a little difficult to please, he was intensely affectionate, and a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" good friend. If I needed good advice, I always asked Jock, because though it might not be as palatable as one could wish, it was always right. He had a very strong sense of duty you remember & very high ideals, so advice from him was difficult to take but "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t really think that he ever contemplated dying at all, and am certain that if he had, he would have gone to St Paul’s Walden where he wished to be buried, and I think that as usual the doctors were much too late in finding out that he had pneumonia, and then could do nothing. Poor Fenella was absolutely broken up, you know she nursed him for nearly two months at Glamis, and that brings people very close together. I am sure that none of the male parts of my family ought to live in London. They all adore the soil, and Jock was really only happy in the country. It kills people in the end if they are parted from the land. It’s too strong a thing to understand. But one cannot regret for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("him")]), _vm._v(" anyway, and I for one, have got a lot of delightful things to remember about him, which is lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must not ramble on any longer this is already a most disconnected letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The hunting is nearly over, and we return to London in April. I hope that you will continue to be happy & contented in Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much wistfulness,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 April 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are so looking forward to coming to Windsor on Thursday, and we will arrive in time for tea, and bringing Lilibet with us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you will forgive my clothes, which I fear are not at all suitable to Windsor, but dressing properly in the evening is becoming difficult, and so please forgive any great shortcomings!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have had to cancel three old engagements in May & June, so have had to say that I am not doing any more things this summer, which will come out in the papers I suppose. It is a bore, but there was no way out of it, and we thought that the simplest way was to make this short announcement. My "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("instinct")]), _vm._v(" is to hide away in a corner when in this condition, which I know is silly, but I suppose it is a feeling handed down from many generations back. I should really like to live quietly in the country for the last few months, and then reappear afterwards as if nothing had happened! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday undated [June 1930] to Lady Helen Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There is nothing to return to London for, and I strongly advise you to stay away as long as possible! It is too lovely here, and the sun is really hot, & one can be out all day long.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I used to take such joys for granted not so very long ago, but I suppose the approach of middle age makes one appreciate "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("weather")]), _vm._v(" much more, and I do love sitting out in the sun. The smells in the evening are marvellous. Last night it was honeysuckle & very sweet new mown hay – it went to my head and made me feel slightly intoxicated. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affec, E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 July 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so delighted to have the miniature of Bertie, and I thank you a thousand times for sending it. I have so few relics of his childhood, and so am very pleased to have this charming miniature.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are not having horrible weather at Cowes, though it sounds as if all the South of England is windy & wet. Here it has rained a great deal the last week or so, after several months of complete dryness.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The last three weeks seem to have lasted for three months at least, and I am longing for the whole business to be over – the waiting gets on one’s nerves rather, & I find myself becoming slightly irritable I fear! Sir Henry Simson is hovering anxiously about, and the more he hovers the slower it all seems! The next time, I shall make every effort to have a child in London during the winter, as it is much more agreeable for both of us I think, as when one is in the country one misses all the lovely flowers and cadeaux for the baby, & little excitements like that!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must thank you once more darling Mama for sending me the miniature – I really am so enchanted to have it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love to Papa & to yourself,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, always your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 August 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot tell you how enchanted I am with the lovely little clock which arrived on my birthday. It is exactly what I love, and it fits so beautifully with my gilt dressing table things. Thank you so very very much. I am so pleased to have it, and it was so kind of you to send me yet another present.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so sorry to hear that you have had such stormy weather, and I do hope that by now it has improved, as it makes everything so miserable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mr Clynes"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn252",
      "id": "fn_252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has arrived today to stay with kind Lady Airlie who is having him to stay. There are two doctors here, and why they are all so very previous I don’t know, as I certainly do not expect anything to happen before the 10th. I suppose that I shall be given all sorts of horrid drinks, so as not to keep these foolish people waiting. I wish that Mr Clynes had waited until he was sent for, but he would not do that, and here they all are waiting & hovering like vultures! I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("shall")]), _vm._v(" be glad when they are gone.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The little clock is such a joy, and I do think that it was kind of you darling Mama –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love, ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess’s second daughter, Princess Margaret Rose, was born at Glamis on 21 August 1930.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 August 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for the two sweet little boxes, and for your most angelic letter of congratulation. I adore the boxes, and hope that I shall be ordered a pill to take after meals, and I shall keep it in the smallest box & flaunt it about! It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" kind of you to think of my love of cadeaux, and I never expected to get any up here. I am feeling so much better than last time, and I expect that a recovery in the good Scotch air will be much more pleasant than one in London. The baby is nice & round & neat I am glad to say. I do hope you will be pleased with her. I am very anxious to call her Ann Margaret, as I think that Ann of York sounds pretty, & Elizabeth & Ann go so well together. I wonder what you think? Lots of people have suggested Margaret, but it has no family links really on either side, & besides she will always be getting mixed up with Margaret the nurserymaid.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was such a wonderful surprise seeing Bertie yesterday, because I was missing him "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(". I am so glad though that he is having a change with you for a bit, as it is always a very trying time for husbands, and he will be all the better for his visit to Balmoral I am sure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The papers have been so vulgar and stupid as usual, that it made it all the worse for him, and it is all a nerve-racking business at the best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am thrilled to hear that there is a suggestion that you may both come here soon – (I don’t even dare write the day!) and I shall look forward so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much to seeing you, my first visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love and a million thanks for the boxes,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever darling Mama, your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [27 August 1930] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write you one line just to say how much I loved seeing you yesterday, and how much I miss you now. I do hope that everything is settling down at Balmoral, and that the Monarchical temper is improved. I wrote to Mama today, & I suggested Ann – I hope that they will be tactful about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Simson came back this morning to bring me a trout, & to say that he proposes coming here on "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Friday")]), _vm._v(" evening at about 6 to send out the last bulletin. Apparently the daily (& more decent papers) are terribly anxious that the Sunday press should not get it, & I rather agree that it would be better to have it out on Saturday. Do you? But don’t trouble to return or anything, as there is nothing to say, and he only wanted you to know. I did not like to tell him that you were not returning until Sat. and perhaps he is better off out of the way!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye Angel. P.T.O.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is my last piece of paper, & am not supposed to be writing another letter!! A great many kisses, & I hope that Thursday & Friday will pass quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 September 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am sending you up Lilibet, and I must confess that I shall miss her very cheerful companionship very much. But I am sure that she will enjoy her visit enormously, and Bertie will bring her back next Saturday, which is a comfort, as I am always terrified of her travelling by road nowadays. I have asked that I might have a telephone message of safe arrival. This sounds like a fussy mother, but I do think that car travelling is dangerous!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you had a pleasant visit to May, and managed to do all that you wanted to do in Edinburgh. And I wonder so much whether you found any exciting things in the Curiosity shops?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie & I have decided now to call our little daughter ‘Margaret Rose’, instead of M. Ann as Papa does not like Ann. I hope that you will like it. I think that it is very pretty together.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am getting on well, and am having massage which is helping my flabby muscles back wonderfully. I expect that next week I shall start getting up, and that I always think is a bad moment, as one feels so weak out of bed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I see that the Braemar Gathering"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn253",
      "id": "fn_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is next week. What a joy! If Lilibet asks to go too, which she is quite likely to do, I do hope that you won’t take her Mama, as she is really much too little for that sort of thing, and would get very weary standing about in the pavilion.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall miss not seeing lovely Balmoral this year, and we often talk of the happy time we spent at Birkhall last autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Lilibet is unfortunately not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good on a long car journey now, but with plenty of air is fairly all right.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 September 1930 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter which I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pleased to get. I am delighted to think that you were politely received – quite right too, and don’t you stand any rudeness. I am writing this sitting in a chair by the window, and the sun is shining on me! Isn’t that grand? It’s such a lovely day, I do wish you were here duckie. I have thought of a lovely way to exercise you when you get back.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And that is lugging me round the garden in a bath chair. Now what do you think of that? It is one o’clock, and I have had a very busy morning as usual, and this is my first opportunity of writing, so I thought I would continue sitting-up & writing to you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall long for Saturday. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" sweet and sugary letter from Mama, and I am glad that they realise what a sacrifice it is sending Lilibet away. The sun has now gone in and it’s rather cold! I loved Lilibet’s letter and please give her the enclosed from Margaret Rose – she held the pencil for the kisses specially for Lilibet. Will you give it to her & tell her this? Also do read her my letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I will write again soon, and I do hope that your week will be pleasant. I miss you horribly, and get very bored at moments.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Kiss Lil for me, and a great many for yourself darling,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 September 1930 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your most charming letter of congratulation. It was very kind of you to write, and I was so delighted to hear from you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Daughter No. 2 is really very nice, and I am glad to say that she has got large blue eyes and a will of iron, which is all the equipment that a lady needs! And as long as she can disguise her will, & use her eyes, then all will be well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that if you can find time you will christen her for us later on in London? I couldn’t bear to have a child "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" christened by you, and we shall be so grateful if you will do this.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was very disappointed as I was longing to ask you to stop here during your Scottish ‘tour’, & christen her in the Chapel here, but that idea was most firmly stamped on by Lord Stamfordham,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn254",
      "id": "fn_254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who assured us that it was quite impossible for you to do this. I had no idea that the two Churches were so far apart, and I thought that not only would it have been delightful for me, but that it would have given pleasure in Scotland. However, this raised a storm in the vicinity of Balmoral and the King practically told me that you would be appalled at the very idea, so I regretfully said goodbye to that nice peaceful plan!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is such a long time since I have seen you, but I know that my mother has asked you if you can stop here for a meal on your way from here to there, so that if you come I do hope that you will pay me a visit. It would indeed be a pleasure for me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall think of you motoring to Dunecht & other beauty spots this week, & wish that I was there, to talk, but not to drive, for I hate long shut drives – don’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With many thanks for your kind letter, I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [12 September 1930] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do feel so sorry for you with all this disgusting weather – it must be so dull, & such a waste not being able to go out stalking or anything. I should absolutely refuse to go all the way to London for a banquet. I should say that you can’t go dashing up & down, and we might be going south early I suppose. It all depends when I finish with the baby, and anyway I think it sounds about the most unnecessary thing that I’ve ever heard of! Well, you can always write & say that you can’t go.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Isn’t Oct 30th a bit late for the christening – the baby will be 10 weeks old, and still a pagan. But we can talk it over when we meet, as Papa & Mama need not be there. In fact it would be much nicer to have it whilst they are away at Sandringham. I am so looking forward to tomorrow, & mind you come down the Elbow in second, or whatever it is! I hope Lilibet won’t be sick again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s cold & damp still – ugh – I now drink Maggie’s beer for lunch, it makes me feel very heavy in the head, but it does me good too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Margaret Rose put on 8oz this week. Isn’t that grand? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lots of love darling, from your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 October 1930 to Lady Helen Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This seems quite passable in a twaddly way."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn255",
      "id": "fn_255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" [ … ] The only thing that she [Beryl Poignand] might take out is a remark at the bottom of page 7 to the effect that "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" may one day rule this country. That is just too much, and she can easily omit the words, ‘she may one day rule as Queen’. It always irritates me, this assumption that the Prince of Wales will not marry – he is quite young and it is rude to him in a way too. Otherwise it is all quite innocent. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 October 1930 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I can’t tell you how miserable I was at having to leave Glamis. It was so delicious being there with you darling, and I can never never thank you enough for all your angelicness to me & Bertie & Lilibet "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("&")]), _vm._v(" the baby. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is horrible getting back to London, and Lilibet at once got a very bad cold. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The only good thing is that baby is very well, and has put on 8½ oz this week. She is so merry. It must be horrid not having any noisy little creature tramping in for ‘just "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("five")]), _vm._v(" minutes with Granny’. [ … ] I think you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" come down darling & meet David. I think that after all you do for Father he should certainly pay your journey down.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish that I could pop up to Glamis, as I am sure you must be feeling rather dull after such a busy Autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling, I really don’t know what we would all do without you,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 December 1930 to Dr Varley")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Doctor Varley")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to ask you whether you would mind if Doctor Weir"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn256",
      "id": "fn_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came to see the leg whilst you are dressing it this evening."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn257",
      "id": "fn_257",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" My husband is a very nervy person (which I expect you have noticed), & he has great faith in his little homeopathic powders, & Dr Weir is a homeopathic doctor. My husband is so afraid of not keeping fit, and if you don’t mind, I really believe that the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("idea")]), _vm._v(" even of these little doses will make him feel more cheerful! It is not the leg that worries him, it is his fitness. It seems almost a religion nowadays does it not? And if you have no objection to Dr Weir seeing the leg, then he can swallow his little powders down.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am quite ignorant about etiquette, and I hope that it is alright suggesting this? Dr Weir is an old friend of my husband’s, but he has not asked him to come in yet before asking you. If it is alright, my husband thought that he might look on whilst you are looking at the leg, and then he can swallow down his powders with joy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, yours very sincerely, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 January 1931 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Thornby Grange"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn258",
      "id": "fn_258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Northampton")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is too kind of you to send me the 3 pretty little dresses for the baby, and I think the work is very good. I will certainly give them some work, and will start by giving them a dress of Lilibet’s to copy. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had to leave the children behind in London as the baby had a very bad cold & cough, and then Alah & Bobo"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn259",
      "id": "fn_259",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" had it – (a sort of flu) & so all our plans were upset, and I am now hoping very much to get them here this week.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you have been having nice sunny days at Sandringham – Lilibet & I miss our evening ‘hops’ very much, & often wish that we were marching or polka-ing in the ballroom with you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Government seem to be in rather a precarious position over the Trades Disputes Bill, but it looks as if those horrid Liberals are going to keep them in all the same. I wonder if there has ever been a more stupid & spendthrift Government than this one."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn260",
      "id": "fn_260",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wonder when you are going to visit the British Industries Fair this year? It opens about Feb. 16th I believe.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & so many thanks for the little dresses –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 March 1931 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Thornby Grange")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you simply a thousand times for the darling little jumper for Lilibet – it fits her beautifully, and she thinks that the ‘Brownies’ are too lovely.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do think that it is kind of you to think of her, especially when you have been having this horrible flu – I do hope that you are really feeling better – I wish that I had known a little sooner & you might have come down here for a few days’ change. The air is wonderfully bracing, you ought to see the two children! Lilibet is so full of spirits, & as for Margaret Rose – she is simply bounding with energy. I am longing for you to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall be returning to London some time in April I think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Such a lovely little jumper has arrived for the baby – please do thank your kind cousin very very much – she makes such perfect ones. And blue suits the baby so well – when she has her bonnet on with blue ribbons her eyes look like the blue sea.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love dearest Nannie B & many thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 March 1931 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Thornby Grange")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Duff Cooper"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn261",
      "id": "fn_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel that I must write and congratulate you on your most excellent victory over Lords Rothermere"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn262",
      "id": "fn_262",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & Beaverbrook.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("After what you told me at Lady Astor’s party, I have taken a violent interest in your campaign, and was so very pleased at your courage in taking on St George’s.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I dispatched a busload of servants up to London to vote for you – each clutching their Daily Mail, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("and")]), _vm._v(" the middle page of the Daily Telegraph thrust into their unwilling hands by myself!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I subsequently ascertained that they voted for you en masse.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please do not trouble yourself to acknowledge this short letter, it is only to tell you how pleased I am at your victory.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that Lady Diana and yourself are not too exhausted.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I received my papers and longed to use my vote, and also was furious to receive a communication from old Petter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I placed it as obviously as possible in the waste paper basket.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 June 1931 to the Hon. Richard Molyneux"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn263",
      "id": "fn_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Windsor Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("To the Windsor Wets."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn264",
      "id": "fn_264",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Fellow Soakers!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have received with gratification the invitation to become Patroness of your exclusive Club. It is with pride and pleasure that I accept this responsible position, and if the occasion arises, you may rest assured that your Patroness will be with you to the last glass. And so, from half pint to Jeroboam, let us go forward together, always remembering our watchword – ‘Aqua Vitae "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("NON")]), _vm._v(" aqua pura’. With kind regards and many hiccoughs,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours in thirst, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 July 1931 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Here is the cigarette box that I got for you in Paris. I thought that it might do to use in the yacht, and is of rather modern French workmanship. In case you do not notice the design, the little silver things are yachts floating across the lid! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love, dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("ever your very affectionate daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 August 1931 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter from on board the Cunard RMS Aquitania."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn265",
      "id": "fn_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I feel slightly abandoned at addressing you in this very familiar fashion, but dash it all, I have known you now for about twelve years, and as you are one of my few friends, I think that I may venture? Eh? You seemed to think that it was quite OK when I broached the subject at Ciro’s, so I hope that it’s all right. I quite agree with you that we did not discuss things half enough when you were here – I like to thrash every subject out – and next time you MUST take your leave in the winter when life is more peaceful and there is plenty of time for argument and tattle.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do want to know one thing. Did your mind veer at all towards matrimony? I wondered so much one evening, and hoped that you rather liked a certain fair and intelligent young lady. Excuse an old pal butting in, but I would love to see you happy and affianced. However, these things are nobody’s business, and I daresay it never entered your head. You know, I have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" few friends, and there are very few people that I write to like this – so you don’t mind do you? I don’t mean that there are not a lot of people who I don’t love dearly, but I have only a mere half dozen of intimates, so you must put up with this kind of letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Paris was great fun in the end, and Lord Tyrrell"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn266",
      "id": "fn_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I found charming and quite without a soul. Everything seemed to go quite well, and the French were most polite, and we exchanged compliments and kissed hands without ceasing for four days. Old [Marshal] Lyautey"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn267",
      "id": "fn_267",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" was a dear old boy and rather liked me – he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("thought")]), _vm._v(" he liked me, but he really liked my hats, which had sweeping feathers & reminded him of his gay young days."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn268",
      "id": "fn_268",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tomorrow we go to Glamis. I long for Scotland, as we have had a very busy summer & somehow I feel more connected and older this year. I don’t know how to describe it quite, but I am beginning to feel that I am ‘the good old Duchess’ rather – I suppose the younger generation has got used to me. I can’t quite tell you what it is, because I don’t know myself, but I expect you can guess. You usually know what I mean!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye for the moment,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 September 1931 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Having just returned from our inspection of Royal Lodge,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn269",
      "id": "fn_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I hasten to write and tell you our impressions. We thought it the most delightful place, & the garden quite enchanting, also the little wood. Of course, the bedroom accommodation is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" limited for us with our large nursery, but I think that we can manage quite well if Bertie makes one of the ‘reception’ rooms on the ground floor into his dressing room. That means putting in a bathroom, but I think that would be quite easy. It would be wonderful for the children, and I am sure that they would be very happy there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Most of the carpets & beds etc belong to Mrs Fether – but we have got one or two beds over, & I daresay that we can manage.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Everybody seems very depressed here, and very troubled about the future. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My father is thinking of shutting up Glamis, which would be very sad, but I fear that the new super tax makes it almost inevitable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I really feel rather worried about everything Mama. The world is in such a bad way, & we seem to be going from bad to worse here too. Everybody is hard hit by the new taxation, & everybody is feeling very unhappy!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("To change to lighter subjects. We "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("did")]), _vm._v(" so enjoy our time at Balmoral, and we both felt much better after our visit. The air is so bracing, & one got away from the usual melancholy conversation of ‘how can one economize’!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & I will write directly we have worked out the cost of Royal Lodge,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [January 1932] to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("[Written on two Post Office Telegraph forms]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is not by any means the first letter that I have started to you during the last three months, but somehow it has been impossible to write you a letter of any kind. Somehow everything has been crumbling around one, & the written word is so hopelessly inadequate, I have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much to say!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish that you could be back & come & see me & talk & talk & talk. Last time somehow we didn’t talk quite enough, and there were many things that I wanted to discuss. I have so enjoyed your letters & cuttings. Please go on. America thrills me & I love hearing about it from you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please forgive my writing in pencil, but I am in bed with influenza for the second time since Jan 1st, and now today I am feeling better, & somehow, in bed, ordinary writing paper seems so silly, so the telegraph forms just suit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I read Shakespeare all yesterday. Hamlet – every word, & Twelfth Night & the Rape of Lucrece & some sonnets. He does get some lovely sounds – it is like music, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("&")]), _vm._v(" the drama – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("&")]), _vm._v(" the everything! I have suddenly begun to love him. In fact, I am only just beginning to know what I like, which is a sign of great age, & it is very exciting indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote you a long letter at the end of July, which I found in my despatch case the other day – I must show it to you some time, because I wrote in a fever of anxiety & ignorance, & it is rather odd & unhinged to read now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Our visit to Paris was most amusing last summer – we never went to bed until 4.30, and we managed, God knows how, to return compliment for compliment & made many French friends. I thought that the Embassy seemed in rather a bad way – too much petty feeling & plotting. When are you coming home again?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This country seems to have settled down to being poor, & everybody is quite cheerful, but only because it is inevitable to change one’s circumstances. I find a tremendous change in the last year – everything more simple, it is quite fashionable to be sentimental, you may like music – weaker cocktails, less food & a slight very slender streak of patriotism starting again. Rather shamefaced it is, but there, to be encouraged.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I spent most of Oct. Nov. & Dec. in London, and went out a lot – no parties, but little tiny dinners & cinemas & then back to somebody’s house to talk – Oh yes – I forgot to tell you that conversation is becoming the fashion. Isn’t it fun – conversation & beer & eggs instead of Embassy & champagne & twitter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My hand is aching, & I am certain that you won’t be able to read this scribble. You are one of my few real friends, and so I must allow myself the luxury of a Lodore"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn270",
      "id": "fn_270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" of words – how pleasant to have friends. Have you made any new or delightful ones in the U.S.? I quite agree, I should "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" a trip there, but only with a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good press agent, and also, how awful if they loathed one. It would be ghastly to be loathed in America, my Scottish blood would congeal.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you heard of Noël Coward’s play Cavalcade?"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn271",
      "id": "fn_271",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" It is marvellous, I think, as a Pageant & very moving.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you got pleasant people at the Embassy?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that your money troubles won’t become too severe – it must be horribly difficult now, & I do feel for you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you got the photograph alright.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adored")]), _vm._v(" that magazine you sent – Ballyhoo – & laughed a lot, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" send any more funny things that you can.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Hoping to have a few words with you before too long.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 April 1932 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for the two scarves & for the telegram on Lilibet’s birthday. She was so pleased, and so was I, and it was kind of you to think of us both. You must come & have a cup of tea & see the children. Do let me know when you are free – they come back today from Windsor, & any time would suit me – either tea time or after. Of course Margaret Rose sleeps in the morning – she is too wicked for words & most amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am longing to see you again, it is such "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ages")]), _vm._v(" since I last saw you, so do just let me know when you are free to come round.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 June 1932 to the Hon. Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("[Telegram to Major Molyneux, Windsor Castle]")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("CLUB EXPECTS ITS SOLE REPRESENTATIVE TO DO HIS DUTY AND LIVE UP TO THE MOTTO. PATRONESS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 August 1932 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to thank you so very much for the most beautiful screen that you & Mama have given us. I cannot tell you how delighted I am to have such a really wonderful present, and it will look quite perfect at the Royal Lodge. I am so very grateful, and do thank you a thousand times for your great kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am beginning to feel pretty aged, & today I found TWO GREY HAIRS!! I suppose one must expect this at 32, or shall I pay a visit to my hairdresser, & come out a platinum blonde!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that the weather has improved for you, and I was so pleased to see that you had won some races. I felt very sad to think that I had missed some good racing, and last week I lay in bed thinking of Cowes & what I was missing. I do hope that you have enjoyed it, & that it has been a rest from the cares of these troubled times. It must be very rare for you to get away completely dearest Papa. You & Mama have always been so wonderful to me, and it has made such a difference in every way. I was very young & ignorant of the world when I married, & had no idea at all of what I would be plunged into – the pitfalls were many; but Bertie was so good, & you & Mama so kind & forgiving of my mistakes that I shall always feel very grateful to you for your understanding & affection. It means so much to me, & it has helped me tremendously. I do hope that you don’t mind me saying this – it somehow just came as I wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 October 1932 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("First of all, I must tell you that Scotland just around this house, is looking too lovely & beautiful for words of mine to describe. The birches are golden & silver, the river is an angry black & blue, every other tree is scarlet & yellow, & I feel very satisfied every time that I look out of my window. It really is delicious to be able to see so much beauty, & I find it most helpful & calming.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This little house is enchanting. It is very small, & lined with caricatures of the 90s, with extremely comfortable & ugly beds of the late Victorian era, & is badly lit with neo-Edwardian oil lamps, with an ever present smell. I am so happy here. In fact I am certain that I am a most simple creature and am most ill suited to my present calling. I inherit a hermit complex from my Lyon family side, & the older I get, the more exclusive I feel. Do you understand? I wish you could be here more, because you are one of the very few people that I can talk to. There are only about 3 people who I can be intimate with, & I never see them, so I therefore never talk about myself. I daresay that this is a very good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so interested in your letter of August 22nd, & I thank you for it. I am deep in some volumes of a magazine of 1832 just now, & am very comforted to read that almost all our problems now, were just as vital then. The Tories were more Die-hard then, than even your Republican party in the USA, & the Banks needed reorganising, so did the Post Office, & Trade was dead, & in fact everything was much the same a hundred years ago, as will be a hundred years hence.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[The end of this letter is missing.]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 November and 20 December 1932 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("First of all, I thank you very much for sending me your intensely interesting Memorandum to read. Please may I file it with my secret & confidential papers, because it is so thrilling to re-read, & it has given me a feeling of superiority when I meet Americans. It was kind of you to remember to send it, & I am most grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Of course, you know, I have a weakness for nice Americans. I met an old man last night, a lawyer called Post, & I have made a date with him to dine with a dining club belonging to Harvard, & I am to receive from them, some candlesticks with the Bowes arms on them (when I visit the US). Weak, I suppose, but still, what fun!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hate writing to you, because you are one of the few people that I can "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("talk")]), _vm._v(" to, & as I cannot make my pen keep pace with my thoughts, I hope that you will forgive an unintelligible scribble.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling very thwarted at this moment. There is so much to be done in this country, things that I could easily do, but a combination of Press & Precedent make it impossible. And I am quite sure that it is not only useless, but almost dangerous to flout convention. Curse it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a delicious two months in Scotland this autumn, & I am now feeling distinctly mellow & oh so full of conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("When are you returning? I did not talk to you half as much as I wanted to last summer but I was tired, & not myself, through that tiredness. Could you not return before high summer next year, when I have still a little zest left?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Trade seems to be looking up a little in this country, but the shipyards & steel works seem to be dead. I cannot think what we can do with our middle-aged unemployed. Perhaps the young men will now get employment, but I cannot see how the older men can ever work again. It is a tragedy, & unless the land can absorb some work & unless some women will give up their jobs, I fear that a lot of them will be workless all their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Women can be idle quite happily – they can spend "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hours")]), _vm._v(" trying their hair in new ways, & making last year’s black coat, into this year’s jumper, & all this on 3 cups of tea and some buns. But a man must be seriously busy, & eat meat. Therefore, I think it a crime for women to take jobs that men can do as well. I am writing very wildly I am afraid, and could go on for ever with this chitchat, but will spare you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This piece of paper takes, in ink, my wishes for everything of the best for you in 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("D’Arcy Osborne replied, somewhat tongue in cheek, on 26 January, ‘I am sorry to hear that you are suffering from a frustration complex over unemployment & other national affairs. Perhaps one day you will be able to take things in hand and order the women of the country from the plough and the counting house to their proper place, the home … Anyway the winning of the vote symbolised the right to technological and other equality. And I don’t think you’d ever get women to go back to dy[e]ing their hair and their jumpers and living on tea and buns…’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn272",
      "id": "fn_272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 February 1933 to Lady Helen Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote in such a hurry last night, that I quite forgot to thank you for all the trouble you took over the famous speech, which was really the reason for my writing to you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so kind & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("exactly")]), _vm._v(" what I wanted. In fact ‘the trying time is the time to try’ has become quite famous – a leader in the Daily Telegraph, & many earnest salesmen & manufacturers repeating the phrase with sobs of emotion in their very British (or rather Lancashire) throats when I went round the Fair today.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot thank you enough, & if you will write me more good speeches, I will take lessons in delivery & tour the country for Toc H."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn273",
      "id": "fn_273",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affec Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday 31 July 1933 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("HMY "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Victoria & Albert")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn274",
      "id": "fn_274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter which I loved. Bertie & I have been here a week, & are returning to London today, & I shall hope to see you on Saturday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been out three days racing in the ‘Britannia’, & it is the greatest fun in the world. You would love it darling, and I now feel most marvellously well! It is a most delightful way of spending a day, & the weather has been lovely too. Everybody is as old as the hills, but they all behave as if they were seventeen!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so looking forward to Saturday, & Lilibet is getting very excited too, and of course Margaret Rose is also excited!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I must fly, so goodbye for the moment")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I also thought May was looking so young & pretty.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 August 1933 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Great Park")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Windsor")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so sad at having to leave the Yacht yesterday after such a very delightful week, and I cannot tell you how much I enjoyed everything. It was all such fun, and I loved every moment of my visit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so intensely interesting to see Osborne,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn275",
      "id": "fn_275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" after having heard & read so much about it, and I was thrilled with all I saw. Thank you so very much for showing me so many interesting and amusing things on that most delightful Sunday expedition.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was really miserable at having to leave yesterday, but I feel a different person after such an invigorating week, and am so grateful to you & Papa for all your kindness & thought for us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We came down here today for two days’ planning for the garden next autumn, and find the whole place quite dried up & yellow from lack of rain.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It must be great fun having Mary at Cowes, and I wish so much that I had not missed her – we never seem to hit off the same party nowadays & she is one of the most elusive people to meet that can be imagined!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I saw Lord Ebbisham this morning, and the new arrangement of the School of Needlework seems quite satisfactory. The only bother is, that after 15 years the College of Technology takes over the whole building and we have to find new accommodation; but of course we have plenty of time to discuss this, and probably it will be better to have a smaller building nowadays. I was pleased to hear that the shop that I suggested & started has proved a success, & I hope that it will long continue to be one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("When I was at Cowes with you, Papa one day mentioned to me that he had heard that a certain person"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn276",
      "id": "fn_276",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" had been at the Fort"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn277",
      "id": "fn_277",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" when Bertie & I had been there, & he said that he had a very good mind to speak to David about it. I never had a chance to reopen the subject, but I do hope that he won’t do this, as I am sure that David would "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" forgive us for being drawn into anything like that. I do hope that you do not mind my mentioning this Mama, but relations are already a little difficult when naughty ladies are brought in, and up to now we have not met ‘the lady’ at all, & I would like to remain quite outside the whole affair. It really is very difficult sometimes, and I am sure that you & Papa can appreciate the difficulties of the position. I trust that you will forgive me for mentioning the subject, but I know that it would only make things more uncomfortable if David thought that I had been brought into it all. I would have said this to you at Cowes if I had had a chance, but there was always someone else present!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again all my grateful and loving thanks darling Mama for all your kindness and sympathy which I appreciate more than I can "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" say,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 October 1933 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been wondering so much as to how you are feeling, and I do hope that you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" keeping quiet darling, as I am sure that is the only way to get stronger. You must have had more of a shock than you realized after your fall, and with that horrid bronchitis on top, please "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" do be careful and rest. Don’t dream of going to Chapel for instance! And no more work parties! May would adore to do some for you I know, so do make her – it would give her such pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We came down here on Saturday, and Lilibet at once developed a bad cold. She had started Margaret’s, and had a temperature, so is now looking rather white. It so often happens that they come back so well from the country, and at once catch something!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Darling, we did so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adore")]), _vm._v(" our last week at Glamis. It was all so heavenly, and great fun having all the family once again. If only you hadn’t been ill.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that Mikie was able to stay with you after Rosie had gone.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have ordered my lilies. [ … ] I do so badly want some gardening advice. When you come South duckie, I do hope you will have time to pop down & give me some. Do let me know how you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("truthfully")]), _vm._v(", as I long to know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We go back to London tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, goodbye for the moment, and do take great care from your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Are you buzzing about in the Chair? Or is it too much for you?")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [1930–6] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "lt-bot"
  }, [_vm._v("Hints to Bertie in case of anything happening to me.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-new"
  }, [_vm._v("1. Be very careful not to ridicule your children or laugh at them. When they say funny things it is usually quite innocent, and if they are silly or ‘show off’ they should be quietly stopped, & told why afterwards if people are there.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-new"
  }, [_vm._v("2. Always try & talk very quietly to children. Never shout or frighten them, as otherwise you lose their delightful trust in you.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-new"
  }, [_vm._v("3. Remember how your father, by shouting at you, & making you feel uncomfortable lost all your real affection. None of his sons are his friends, because he is not understanding & helpful to them.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 January 1934 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so very kind of you to write me such a charming letter for Xmas, and I was indeed delighted to receive it. I love to have your Benediction for ourselves & for our children for the coming year. I hope that it will be a happier one for many people in this land, and their happiness will certainly make us happier. One cannot help worrying over the misery & hardship suffered by so many good people, and their courage in facing hardship is the thing that I admire most in them. It is a great example to all of us luxurious minded creatures – not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(", but us, I mean! Everything seems to be so much better everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With every possible good wish for 1934, & with again so many thanks for your kind thought of us at Xmas.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours always affec:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 January 1934 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so kind of you to send me the essays of Max Beerbohm,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn278",
      "id": "fn_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and I have read ‘King George the Fourth’ with great enjoyment, and much satisfaction. I read everything that I can lay hands on which has anything to say about that attractive old naughty, & it was a joy to realise that Mr Beerbohm was a cordial admirer of ‘a swaying figure & a wine-red face.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also I would wish to thank you for giving us supper after that most charming disappointment of a play that we saw last week.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I could have talked so much, but perhaps the E..… y"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn279",
      "id": "fn_279",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is not an encouraging place for anything but light conversation! The little house in Windsor Park that we live in now, was the last ‘favoured residence’ of George IV, and although it was practically demolished by Queen Adelaide after old Naughty died, we still have one deliciously Gothic & expensive room left – the last one built by order of G.IV.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again my grateful thanks for the Book.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 July 1934 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is so")]), _vm._v(" sad that you were not able to come here this summer for your reunions, and all your friends have missed you sadly. It is the first time for many years that I have failed to mix you a White Lady, and I do hope that you will soon be with us again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t come until October, because we shall all be out of London – though of course you could come & stay with us which would be nice, because then we could talk & talk – & talk.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("London has been very gay these past few months – many balls every night, and a few very grand & much appreciated affairs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The fact that people enjoy a ‘show’ once again is a very good sign I think, and tiaras are worn almost as a matter of course! A few years ago people were embarrassed and unhappy if they glimpsed a diamond or ate quails in company, which was a shame and a stupid feeling really – as it had no relation to one’s misery at the poverty and sadness of the people of this country. And yet I suppose on second thoughts that this was the right feeling, & is perhaps one of the reasons for our triumph as the only civilised country in Europe today.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There was a lovely ball at Syon given by the Duchess of Northumberland. The house was floodlit & the garden looked quite perfect, & exactly like a Canaletto of London, with exquisite little figures strolling in front of an eighteenth century house. It was delicious to watch.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The opera went well, & the Russian Ballet is having a great success in Covent Garden. I do wish that you were here, because I would so like to go with you. I have been several times and it is beautifully done. I know that you would like it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How is America? The only news lately has been of Dillinger"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn280",
      "id": "fn_280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – all the papers (except the Times) had huge pictures of his dead body which filled all stolid Englishmen with horror, and today huge pictures of poor little Dollfuss"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn281",
      "id": "fn_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" lying in state – that was a tragedy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been wishing to write to you for many moons and because I cannot put pen to paper does not mean that I don’t think of you often & with affection. I have been very busy this last 3 months, and am looking forward to going to Scotland in about 10 days’ time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Next week I am going to Cowes to race with the King, which I rather enjoy – I like the feel of yacht racing – it is very exciting and very peaceful. No noise, except the creak of the sails & the water rushing by – and a glow of health after a few days at sea!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must go, & do tell me when you are coming home again,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess was a lover of the arts, especially ballet, giving her support to the Camargo Society for the Production of Ballet from the early 1930s. She would later tell Eric Anderson that")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘going way back I did see Pavlova.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn282",
      "id": "fn_282",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("I suppose I must have been nine or ten and luckily my mother thought it was a good thing to go. And she was doing the Swan, I think, and Karsavina.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn283",
      "id": "fn_283",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("I remember it so vividly, you know. This wonderfully graceful little creature.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 August 1934 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do so want to thank you for my perfect few days with you in the Yacht. I enjoyed myself very much "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("indeed")]), _vm._v(" last year, and this year I was just as happy. In fact it was all quite blissful, and I am so grateful to you for having me to stay and for giving me such a wonderful few days.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so sad that it was only possible to race one day, but I enjoyed that day madly, and was thrilled to hear of your marvellous win on my birthday. I only wish that I could have been there; I expect that I would have blown up with excitement! It is very odd, but nothing in the whole year gives me such pleasure as my few days at Cowes. I feel quite different, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" happy. Of course the fact of sailing is enough to explain this effect on me. The excitement, & the wonderful "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("peace")]), _vm._v(" of a day in the Britannia – no noise, but the creaking of the sails, & the cooing voice of Sir Philip [Hunloke],"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn284",
      "id": "fn_284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" softly inviting the crew to Lee-o! And there is something so exhilarating about the elements, the sea & the wind & the sun, and one feels far away from the horrors of modern civilization with its noise and eternal hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a very good passage to Portsmouth in the destroyer, & was chaperoned most beautifully by the Commander-in-Chief, who placed me in my train in a very successful manner.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("London was too horrible, & I kept on thinking of you sailing in Britannia with deep envy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I can never thank you enough dearest Papa for all your angelic goodness to me – & also I must send my grateful thanks for my lovely birthday presents. I am indeed a lucky creature.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love, and 1000 thanks for my heavenly week at Cowes,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Always your loving & dutiful daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18 August 1934 to the Hon. Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("PRIVATE AND STRICTLY CONFIDENTIAL IF THAT IS POSSIBLE FOR DICK")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Gannochy"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn285",
      "id": "fn_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Edzell")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("CLUB BUSINESS")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Dick")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As Treasurer of the Windsor Wets I think that you should know that "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" have decided to make Lady [Magdalen] Eldon (spouse of our valued Secretary) an honorary Lady Member of the Club. And no interference from you please. It’s quite time that I took the reins again I can see.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, aqua vitae non aqua pura still holds good, & I hope that you will have a good week here & will live up to the motto of the Club. Elizabeth (Patroness)")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 February 1935 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for remembering to send me Mr Belloc’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn286",
      "id": "fn_286",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" most touching ‘Ballade of Illegal Ornaments’ – The right feeling of anger is in it, and it made me want to cry when I read it this morning. What a good poet he is – it is wonderful to be able to know the fundamental things, and to be able to write about them so beautifully.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have copied it, and so return to you the copy you kindly sent me, with my grateful thanks and a tear or two.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v. sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 April 1935 to Clare Vyner")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Clare,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How nice of you to write and thank for dinner. It was angelic of you & Doris to come. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been so worked up by your wonderful scheme for settling unemployed, that I have written to our friend the riveter in Sunderland & offered him a job here with us."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn287",
      "id": "fn_287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" The man with children. I do think that it’s up to people like us who can afford to dine at a restaurant & go to a night club to try & employ as many as we can. Oh dear – it makes one furious & despairing that one can’t do more. Anyway, nobody has done more than you, and it is a real bright spot in life that you have done such a good work. I do hope that I shall be able to see your settlement soon. I would like to very much. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If I ever meet a rich man, I am going to tactfully bring up the subject of the one good amateur scheme that I know – or perhaps not ‘amateur’ but non-government – most important. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye and many thanks for your letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 June 1935 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Forgive me please, for having been so long in writing to thank you for the most enchanting books that I have ever read, but I wished so much to have read a little before attempting to convey my gratitude to you in words.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And having now finished the first volume, I feel incapable of expressing what I feel – if "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" I could write you a little poem, ‘as the wings of the dove beat softly in the air, so is my heart stirred by your offering’ is lame – but indeed my heart is grateful and I do thank you for giving me such real pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been very busy lately, and unable to read much, but the first volume of the ‘Tale of Genji’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn288",
      "id": "fn_288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is a joy, and I am now in the middle of the second book. It has been an eye-opener to me – the simplicity & beauty of Murasaki’s language is wonderful. ‘Her construction is in fact classical; elegance, symmetry, restraint’ says the Introduction to ‘The Sacred Tree,’ and I am so pleased to think that I can look forward to four more volumes. Thank you a thousand times for such a lovely present.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 August 1935 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We were both so sad at leaving yesterday, and I hadn’t enjoyed myself so much since last Cowes! The whole week is such a perfect rest in every way, and I do so love sailing in the Britannia. Thank you a thousand times for all your kindness and angelicness – I adore being with you always, and this last week was perfect. It is such a complete change to get away from telephones, letters, & the eternal questions that ruin one’s life in one’s own home, and I feel ten times better than when we left London last Tuesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We got back here at 5 o’clock which made a very easy journey – left Portsmouth at 3.25, & got home in good time for tea, and found the children waiting with their presents, & little bouquets of flowers that they had picked themselves. They are looking so well after their week here – London is very trying towards the end of July, & they were looking rather white when I left last Tuesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie & I are taking on a man from Sunderland in Durham to work in the wood & garden, & he arrived here this evening. He is a most excellent type of superior artisan, & he has been out of work for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("seven")]), _vm._v(" years. It is such a tragedy, & his gratitude is touching. We felt that it would be a useful act, & this man is an ex-soldier who was badly wounded in the arm – I wish that one could do more for the poor things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Margaret Rose came up to me today, & after looking at me very affectionately, & giving me a sweet kiss said, ‘Mummy darling, I really do believe that I love Papa much more than I do you’! I felt very small!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was delicious seeing Mary Beaufort"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn289",
      "id": "fn_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" for a minute yesterday, she is an angel & I wish that we met more often. This house is singing with mosquitoes and I am rather glad to be leaving tomorrow as the biting insects are very bad.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop this letter, as I fear I am boring you with tittle-tattle.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again darling Mama for such a divine week, ever your devoted daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 October 1935 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so kind of you to send me ‘Haig’,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn290",
      "id": "fn_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and to write in it for me. I have been reading it with great interest and delight, and I think that it is very clever of you to make it so fascinating. It must have been a great work, and I cannot imagine how you did it in such a short time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The few critics have been quite idiotic in writing about the book. Their only cry being ‘why is it not more sensational,’ which is too foolish to even speak about. The only people I have seen up here who have read it, are the King & one or two tough Scottish Majors & Captains (ex), & they are all enthusiastic. Being sane because they do not live too much in cities they are grateful to you for giving a true picture of Haig, & for writing a very difficult book so brilliantly. I do hope that you are pleased with its reception & great success. Are you calm about it, or are you a cauldron, seething and boiling?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you will forgive me for not writing before, but I wished to read anyway part of the book before sending you my grateful thanks for your kindness in sending it to me. I was so pleased to have it before it came out in the shops.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Archbishop of Canterbury came to luncheon with me here, and instead of the comfortable heart to hearter that I had been looking forward to after luncheon, he pounced on your book with a cry of joy, & then there was silence only punctuated by ‘ah those were the days’ (he was at Oxford with Haig) & ‘dear old so & so’ & other old-time remarks – not at all the sort of thing that had been expected by his lonely and forgotten hostess.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am still reading ‘Genji’ with great enjoyment, & lent the first volume to the local Minister here who gobbled it up and asked for more! I shall always be grateful to you for having given me so much pleasure with Talleyrand, Genji & Haig. What a nice party they would make.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("‘The desolate autumn hurries through the fields apace, to nodding flowers the wind’s cold breath betrays’ and soon we must leave this peaceful place & return to London. It is so lovely now, the birches are turning from silver to gold, the air is cold & the sun shines, so that I am sorry to go.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you have had a peaceful & happy time, & are feeling well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again my very grateful thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess of York had another severe bout of influenza over Christmas 1935. She had to remain in bed at The Royal Lodge while her husband and daughters went to Sandringham for the Royal Family’s traditional celebration. It was King George V’s last Christmas.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("29 December 1935 to Princess Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Lilibet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It seems such a long time since I last saw you and Margaret, and I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope that I shall be allowed to get up in a day or two, and then I shall soon be with you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you are having a lovely time at Sandringham, and being very polite to everybody. Mind you answer very nicely when you are asked questions, even though they may be silly ones!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you manage to practise the piano a little bit?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Dookie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn291",
      "id": "fn_291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is very well, and sends his love & a big lick. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have got a very nice Nurse, and she gives me a good wash every day in bed. I haven’t been so clean for years! Please give Alah my love, I hope that she is being good. Give Margaret some GREAT BIG KISSES from me, and a great many to your darling self.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye angel, from your very loving Mummy")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("29 December 1935 to the Hon. Sir Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Dick")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I am so glad that you missed us at Xmas, tho’ I daresay you all managed to be pretty gay & pretty tight all right. I say, what do you think of CHAMPAGNE stripes on a CLARET ground for the Club Tie?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you had to wear your long snow boots yet?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am much better, but the doctor told me this morning that I can’t get up just yet. It is too sickening, but apparently I’ve had that old fashioned flu that has pneumonia with it, and it’s very slow to get rid of. I expect that when I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" well again I shall be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("VERY")]), _vm._v(" well. Oh Boy. Well, be good if you can, which I doubt, and I should stay away from Abyssinia if I were you just for a bit. I know it’s very tempting, but make it one of your New Year resolutions & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("stick")]), _vm._v(" to it. I couldn’t give you better advice – remember what happened last time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A very happy New Year to you from your suffering President Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Is it true that you have been sold with the house in Charles Street? Rather cunning of you Dick.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 December 1935 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so delighted to receive your lovely Xmas card this morning, with your kind message inside. It is quite the most charming card that I have seen, and will be a wonderful souvenir of that never-to-be-forgotten day in Westminster Hall. I thought it almost the most moving ceremony of the many Jubilee celebrations – in fact, it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" the most moving, and I am so glad to have such a nice picture of a wonderful moment."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn292",
      "id": "fn_292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are having better weather at Sandringham than we are here. It has "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("poured")]), _vm._v(" with rain all today again, and last night there was a noise like a terrific crash of thunder, which turned out to be one of the best beeches falling down. It has spoilt another good beech, & I expect it is the heavy rain after a long drought which had loosened the roots. So sad to lose good trees.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling so much better the last two or three days, and it is sickening how slowly this lung business is ‘clearing up’. I believe it is always very slow. I am longing to come & get well at Sandringham. I feel that the good bracing air will work wonders, and soon make me well. One gets so weak in bed, but I shall have some massage in a few days to try & coax some muscles to work!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you have kept well, and are able to get some shooting. I am so glad that the children are being good. I am pining to see them again. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you heard what the Abyssinian soldier said about Mussolini? ‘He is my enema, the Douche’. Blackie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn293",
      "id": "fn_293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" will appreciate that!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With so many thanks again for the card, and much love dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving and")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("dutiful daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS May I wish you a very happy & peaceful New Year.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 January 1936 to Princess Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Lilibet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your darling letter. It made me laugh very much the idea of having to go upstairs whilst the water rushed about downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Fancy Dookie’s disgust if he had to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("paddle")]), _vm._v(" to the door to go out! And how would Annie clean the carpet with her roaring machine under water! And Ainslie would have to swim round the dining room offering food, and Papa & I would have to have a boat to go round the garden. Mr Stone & Cripps would have to wade about in the Chapel splash, splosh. & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("how")]), _vm._v(" would Owen exercise the horses! I think that it would be easier to build an ark like old Noah, and live in it until the rain stops! However luckily it has not rained today, so I hope the poor people in Windsor will be happier.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is three weeks tomorrow since I went to bed. Isn’t it a long time – much too long "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" think. But I am feeling much better today, my cough has practically gone, so I hope that the doctor will let me get up. After being in bed so long, one’s legs feel a bit wibbly wobbly, so I shall have to get them strong.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well my darling, I hope that you are quite happy & that your cold is gone. Give Alah & Margaret a kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye my Angel from your")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("very loving Mummy")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 January 1936 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" kind of you to send me two such FUNNY books for Xmas, and I have enjoyed them both enormously. Thank you very much for thinking of such a nice present, I am extremely grateful. They arrived just at the right moment, when I was beginning to come back to life after having pneumonia. I never thought that I would be really ill. I suppose that is the optimism that one is born with! But it’s really very pleasant, nothing matters; people, things, food & drink don’t exist, in fact one becomes a NOTHING.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The only unpleasant thing is returning to Life & feelings. However, even that is made bearable when kind friends send one amusing books.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What do you think of everything? All that Sam Hoare & Laval & Baldwin business"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn294",
      "id": "fn_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" was going on when I had a very high temperature. Consequently I am not sure whether it all really happened or not. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have spoken to Mrs Greville on the telephone who, I may say, takes the gravest view of everything. ‘I can’t tell you on the telephone but Austen"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn295",
      "id": "fn_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" told me’ etc. I believe somebody heard her speaking of her ‘dear little brown shirts’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn296",
      "id": "fn_296",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been in bed for a whole month, & the last week or so I have been able suddenly to think clearly (for me) instead of being in a fog. It is very interesting. Especially about people. One "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("realises")]), _vm._v(" them if you know what I mean. Silly people, who one forgave for being silly & probably rather cruel because one liked them, become what they are – cowardly, futile & unhappy. And nice dull people become valuable, & one’s real friends turn to gold, and become more important than anything else in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("At the end of November we went to Paris for a St Andrew’s Day Scottish Dinner, & were worked very hard. We lunched with the President,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn297",
      "id": "fn_297",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" when I sat between the old boy & Laval, who was very pleasant of course, & a huge dinner party at the Embassy & Reception, & French people at odd hours, M. Pietri"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn298",
      "id": "fn_298",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" twice running for dinner, and an enormous man who said that he was Herriot’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn299",
      "id": "fn_299",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" chief man, who practically sank to his knees beside me, & gurgled ‘If "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" we had people like you both in France’ etc etc whilst I pretended that it was quite O.K. to have a Huge Frenchman with a Légion d’Honneur in his buttonhole kneeling violently beside one. They don’t mean a word they say, but they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("are")]), _vm._v(" so nice, & so nasty. I like their sense of humour – it’s so delicious, & yet, how can one trust them? They are so unsentimental when it comes to politics & horribly straight seeing. What do you think of them?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been wondering what you are going to do about moving to Rome."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn300",
      "id": "fn_300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" It all seems so unnecessary. I have always hated the League of Nations"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn301",
      "id": "fn_301",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" – do you think that they will be stronger or weaker after this business? Do tell me what you think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I gather that America is determined to keep out of any European trouble, before anything else. One can be sympathetic with that, but is the British Empire exactly an European country? It’s all very complicated, and I am sure that you must be tired with this disjointed letter. Half the blame for its stupidity I put on this Fountain Pen that I am trying to write with. Only the most boring words come from its horrid nib, and I have the greatest difficulty stopping it writing words like ‘dainty’ and ‘afternoon tea’. So you see I am labouring under a disadvantage.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much again for the books")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours gratefully")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18 January 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must send you one little line to tell you that I am thinking & praying for you & Papa all the time. I cannot think of anything else, my life has been so bound up with yours the last twelve years, and I cannot bear to think of your anxiety. I feel so cut off & far away from you here, & I do hope that you will let me come down to Sandringham if I can be of "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("any")]), _vm._v(" use, I would like to. I won’t write any more darling Mama, but send all my love & devotion.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please do not dream of an answer")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King George V was growing weaker every day. The Duchess of York was still recuperating from influenza at The Royal Lodge and was unable to join the rest of the family around the King’s bedside. He died on the night of 20 January and his son David, Prince of Wales, became King, taking the name Edward VIII.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 March 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Compton Place,")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Eastbourne")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have been here a week now, and so far have had very mixed weather.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday was divine, and in the morning we went down to the little ‘chalet’ on the beach, and the sun was heavenly. The people were rather a bore, and though they stared quite politely, they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("stared")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("STARED")]), _vm._v(". I do think it is such bad manners, especially in the type of rather prosperous middle class people that they were! However, we shall try again on the next fine day. In the afternoon we went to Cooden Beach, & the children enjoyed themselves enormously. I am feeling "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much better, and feel sure that a fortnight or so more will put me quite right.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are feeling well, and not feeling the reaction from all that terrible time too much. I find that from my own point of view one misses Papa more & more, and I cannot imagine what it must mean to you, darling Mama. You have been so wonderful all this time, but the strain must have been terrific.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also I feel that the Family, as a family, will now revolve round you. Thank God we have all got you as a central point, because without that point it might easily disintegrate. And a united family is the strongest thing in the world, & so important, don’t you think?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also it provides a check on all those little jealousies and backbitings that occur even in the best regulated of families!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This house, for me, is full of memories of you & Papa, & when we went to the nice service on Sunday, it was almost too much for Bertie & I.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 August 1936 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to thank you most gratefully for so kindly sending me the copy of your speech in Paris. I have read it again, & most cordially agree that in no part of it did you say anything that could have raised ire. In fact it’s a dashed good speech.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also, permit me to thank you for the translations of the three Japanese poems. They are so romantic & exquisite. I am sending you (this sounds so grand) a pair of porcelain vases!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But wait. They are only a couple of inches high, & were painted in the 18th century. The translation of the verse is as follows –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("‘The blossoms tipping the branches")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("of the trees flourish in the splendour,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And even the lower creation")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("makes virtue its chief concern.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s a rather disappointing little poem, but I thought that I would like to send you a little nothing with a verse, & these vases were the only suitable means of conveying my gratitude for having introduced to me so charming a person as Prince Genji.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Could you not arrange to accept into the Army men who are not quite fit, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("make")]), _vm._v(" them fit? Say ‘C’ men, & after 6 months they will be ‘B’ men.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It seems such a pity nowadays that men who wish to join the Army should not have the chance through the horrible system under which they live. I mean the ‘keep unfit’ system so prevalent in our towns & villages nowadays.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh do.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just returned from some days spent in Durham, Northumberland & Yorks. We went to Jarrow, which I regret very much, as it really made me unhappy. I always dread going up to Tyneside, because I admire the people there with all my heart, & it darkens my thoughts for months afterwards, to know how desperate they are. Thank God that they can still feel desperate, as they have not yet given way to that dreadful apathy that seems to follow on prolonged unemployment.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went to see Palmers Shipyard,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn302",
      "id": "fn_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Jarrow’s sole means of employment – a horrible scene of desolation, & then out through the streets – driving through large crowds of emaciated, ragged, unhappy & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("undaunted")]), _vm._v(" people, who gave us a wonderful reception. It made me weep – their courage is so high. I hope that you do not think that I am carried away by just a glimpse of the tragedy up in the North. I often think about it all, it seems terrible that such good material should be wasted.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a pity that the Trades Union officials etc are so foolishly anti-military – it would solve the problem of these young boys – if they would join the Army.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did not mean to write at such length, but got carried away!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I really only wished to thank you very much for the speech, & to say that we shall hope to see you in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 August 1936 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" sad at leaving Glamis on Sunday, I always feel the same every year, but was so glad that you were feeling a little better darling. It was such bad luck getting ill again, and I would have been very unhappy to have left you feeling miserable & ill. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Do")]), _vm._v(" promise not to do a little too much when you feel well! And "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("please")]), _vm._v(" don’t go to Chapel. I am sure that Father won’t mind, because he really did get worried about you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It has been "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("too")]), _vm._v(" lovely up here the last three days, and yesterday was boiling on the hill. Where Bertie is shooting the views are too marvellous for words. You see over the Dee valley, and the hills are spread out for miles & miles, I do wish that you could see them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lilibet enjoys coming out very much, as you can imagine!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The garden is really looking lovely. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish that you could come up very soon & see it. The phloxes are perfect, and in great huge masses, and everything seems to have done well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you remember you gave me some seed of a blue Columbine? It is very well & strong here, & I wondered whether you would like some seed in return, as I remember the old gardener at Glamis pulled up all your seedlings thinking they were weeds!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If you feel well enough for a motor drive on a lovely day, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" come up here. But "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" when you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did love my time at Glamis darling, but I do wish that the time did not go so quickly there. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye duckie, from")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 September 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is too kind of you to send us that charming picture of Birkhall, and it is exactly the right size for a little room too. Thank you a thousand times – it fits in most beautifully.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went to Balmoral the other day and chose out the photographs that you wanted. I do hope that they will prove the ones that you wanted sent, as in one or two cases I was a little puzzled. However, the nice housemaid was a great help, as of course the housekeeper did not know very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The latter seemed a very nice woman, & most capable and intelligent, and very happy at Balmoral.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Next week we go to Aberdeen to open the new Hospital."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn303",
      "id": "fn_303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I do wish that David could have done it, as they have all worked so hard for so long, & it will be one of the best in Scotland, and it would have given such enormous pleasure to the countryside round here. But he won’t, so there it is!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am secretly rather dreading next week, but I haven’t heard if a certain person is coming or not – I do hope not, as everything is so talked of up here. I suppose it is natural, the place being empty for eleven months, that the time it is occupied every detail is discussed with gusto! Mr Pierpont Morgan"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn304",
      "id": "fn_304",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is coming up to luncheon tomorrow, and David may come over too, which would be very nice of him, & it would give the old man such pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We went to the Gelder"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn305",
      "id": "fn_305",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" for a picnic yesterday, it was too divine for words, the mountains heavenly, the sun hot, and the air like champagne. In fact Scotland at its most lovely, & it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" hard to beat then. We have been round to see a few of the people, and the schools – I could not remember how many people you used to visit beyond the obvious ones like Abercromby & the Stirtons"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn306",
      "id": "fn_306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & Arthur Grant etc – are there any others that you would like us to do?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With so much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I do hope that Marlborough H. is getting on well.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 October 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have been thinking so much of you this last week, and are so glad to hear that you are getting settled at Marlborough House. It sounds as if you have made it quite lovely, and I am simply longing to see it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are leaving here today, and spend a week at Glamis on our way to London, and are looking forward "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much to seeing you again. It seems such ages since July. It has been so lovely up here this year, the weather has been heavenly & the gardens blazing with colour, but there has also been a great sadness & sense of loss both for us & all the people. It will never be quite the same again for us. You & Papa made such a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("family")]), _vm._v(" feeling by your great kindness & thought for everybody, but David does not seem to possess the faculty of making others feel "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wanted")]), _vm._v(". It is very sad, and I feel that the whole difficulty is a certain person. I do not feel that I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" make advances to her & ask her to our house, as I imagine would be liked, & this fact is bound to make relations a little difficult. However, luckily Bertie is quite outside all that, & I am sure that it is very important for him to steer clear of those very difficult questions. The whole situation is complicated & "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("horrible,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn307",
      "id": "fn_307",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and I feel so unhappy about it sometimes, so you must forgive me darling Mama for letting myself go so indiscreetly. There is nobody that I can talk to, as ever since I married I have made a strict rule never to discuss anything of Family matters with my own relations – nor would they wish it, but it leaves so few people to let off steam to occasionally!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It will be heavenly to see you again. Has anything transpired about Xmas? Can we all spend it together – do suggest it to David as he loves & admires you & I am sure would arrange what you wished.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & I do pray that you will be blessed & happy at Marlborough House,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn308",
      "id": "fn_308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21 October 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tuesday December 3rd will suit me very well indeed, & I shall look forward so much to bringing the children. It was so wonderful to see you again today. In these anxious & depressing days you are indeed ‘a rock of defence’ darling Mama, & I feel sure that the whole country agrees. It was a great joy to us to be with you again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your always devoted daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 October 1936 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("miserable")]), _vm._v(" at leaving Glamis & you on Tuesday, and each year I think that we all enjoy being there more & more. It was heavenly this year and the only sadness was that you were not feeling well. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that you won’t have another attack just yet, & give it time to heal up. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("horrible")]), _vm._v(" for you darling, and worries me very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t think that there is anybody else who would make so little fuss as you do – you are very brave duckie.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We had a very good journey down, and found London looking very dirty & horrid, & all felt very sorry that we were not at Glamis! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have got Lilibet down here alone, & she is sleeping in my room which is very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling, & please take great care of yourself, & a million thanks for all our delicious time at Glamis.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn309",
      "id": "fn_309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("29 October 1936 to King Edward VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do want to thank you most gratefully for lending us Birkhall this year. It is the most wonderful holiday for us, and I cannot tell you how much better we both feel after 6 weeks of complete peace. I honestly don’t believe that I could cope with all the problems of modern life, if it wasn’t for Birkhall, & it was ANGELIC and kind of you to let us have it. I do thank you from my heart – you are always so sweet & thoughtful for us, and I wish that I could thank you as I would wish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now please may I bother you with something? It really isn’t my business at all, but I am implicated with the St John of Jerusalem as Commandant of the Nursing Divisions, and I know that the Order is very anxious for you to do some function for them next summer. I am wondering whether it would be possible for you to do such a thing as a Review or Inspection of the Brigade in Hyde Park some time? It would do an incredible amount of good, because you know the men are practically all working men who give up holidays & ordinary leisure to do Ambulance service on great & little occasions. They hardly ever get a pat on the back, & yet are absolutely essential to us, and I cannot begin to tell you what a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("marvellous")]), _vm._v(" effect it would have if you could possibly spare a day next summer. Oh dear – I do hate to ask you this, but the St John gets things like Investitures for the grand people, and I do feel that the thousands of working men who give up their hard earned leisure to cope with accidents & public occasions would feel so set up if you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("could")]), _vm._v(" have a look at them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please forgive me for asking you this, but you are so understanding about these things. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Please")]), _vm._v(" don’t give me away, as it really has nothing to do with me. I am being an interfering busybody, but the St John order is run by "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("old old")]), _vm._v(" men, & they forget the rank & file! I felt I would so like to ask you this – it means so much to these excellent people. At all public functions the police notify the London District as to how many men & nurses they require, & the Brigade carry out these street duties absolutely free – a service gladly given by people like porters, postmen, shopmen etc. If you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("possibly")]), _vm._v(" can – it would be wonderful if you could inspect them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving sister in law Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday undated [17 November 1936] to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie has just told me of what has happened,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn310",
      "id": "fn_310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and I feel quite overcome with horror & emotion. My first thought was of you, & your note, just arrived as I was starting to write to you, was very helpful. One feels so helpless against such obstinacy. Would 10.30 be too early for you tomorrow morning? Bertie has a meeting later on in the morning. If we don’t hear to the contrary we will come at that hour. God help us all to be calm & wise.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your devoted daughter in law, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 20 November 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Wilton House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Salisbury"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn311",
      "id": "fn_311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter, it was indeed kind of you to write so fully, and I am deeply grateful. What you say gives Bertie & I much courage and to know that we have your support at this turning point in not only "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("our")]), _vm._v(" lives, but the lives of millions of people in the Empire is a wonderful encouragement & support.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Staying here, in a very normal English shooting party, it seems almost incredible that David contemplates such a step, & every day I pray to God that he will see reason, and not abandon his people.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am sure that it would be a great shock to everybody and a horrible position for us naturally. However, it is no good going over the same ground again, but I must repeat that I do "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" know what we should do without you darling Mama. Please believe that Bertie & I will always do everything in our power to please you, and we do feel so thankful for your unfailing help & sympathy & wise advice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is a great strain having to talk & behave as if nothing was wrong during these difficult days – especially as I do not think that anybody here "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreams")]), _vm._v(" of what is worrying all of us. [ … ] it is truly the sword of Damocles again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 November 1936 to King Edward VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Private")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Please")]), _vm._v(" read this. Please be kind to Bertie when you see him, because he loves you, and minds terribly all that happens to you. I wish that you could realize how loyal & true he is to you, and you have no idea how hard it has been for him lately. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("know")]), _vm._v(" that he is fonder of you than anybody else, & as his wife, I must write & tell you this. I am terrified for him – so DO help him. And "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("for God’s sake")]), _vm._v(" don’t tell him that I have written – we both uphold you always.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("E."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn312",
      "id": "fn_312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS We want you to be happy, more than anything else, but it’s awfully difficult for Bertie to say what he thinks, you know how shy he is – so do help him.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 November 1936 to Helen Hardinge")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Helen,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was very kind, and just like you to write me such a nice letter. I would love to see you, because there is nobody that I can talk to, and I know that you understand the horrible complications of the situation. It’s bad whichever way one looks at it, both from our point of view, and the country’s, and the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" thing that matters is the support and sympathy of one’s friends. I feel very depressed and miserable, and so am extra grateful for your support. You and Alec"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn313",
      "id": "fn_313",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" are angels. E.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 December 1936 to the Hon. Sir Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Dick")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have put off lunching with Oswald Birley,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn314",
      "id": "fn_314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" because I do not feel able to cope today. I am sure that he will understand, & you too. It is a great help to us to feel that we have good friends like yourself, for indeed we both are unhappy & terribly worried. We have just arrived back from Scotland, to be greeted with the bombshell of the daily papers"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn315",
      "id": "fn_315",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" – it is all so dreadful & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wasteful")]), _vm._v(". Please tell the Birleys how sorry I am.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v. sincerely Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 December 1936 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you 1000 times for being so angelic to us at Carberry. I can’t tell you what a joy it was to be with you all again, and I really don’t think that we could have got through the Edinburgh functions, in the present state of unhappiness, unless we had been with you. It made all the difference, and I am "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" grateful. Bertie and I are feeling very despairing and the strain is terrific.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Every day lasts a week, & the only hope we have is in the affection & support of our family & friends.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel so sad, & yet there is only a very straightforward case – if Mrs Simpson is not fit to be Queen, she is not fit to be the King’s morganatic wife. The Crown "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be above all controversy –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again for all your wonderful kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 December 1936 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am deeply grateful to you for your very kind letter, I wish that I could tell you how much encouragement & support we feel in what you say. In these last few days, when every minute has seemed an hour, we have been sustained & helped by the sympathy of our friends. Please believe that your letter has been read with real gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is extraordinary how one’s heart lightens at the kindness of friends, and I feel sure that you understand the great difficulties of the present situation – therefore your sympathy is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much appreciated. I thank you from my heart, & hope that we shall see you again soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 December 1936 to the Marchioness of Londonderry")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Lady Londonderry"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn316",
      "id": "fn_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so grateful to you for your very kind letter. Your sympathy is a great encouragement to us both during these terrible days that seem to last so long, and we are much encouraged by what you say. It is specially hard for my husband, involving as it does a much loved brother, and we are both feeling miserable, but sustained & helped by our friends indeed. Thank you from my heart for your kind thought in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do so agree with you about the calamity of Lord Beaverbrook & Lord Rothermere"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn317",
      "id": "fn_317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" bringing this very vital & constitutional matter down into an attack on Mr Baldwin. But I also think that it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("essential")]), _vm._v(" for the Queen to remain outside any controversy – she "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be above everything and her calm & dignity will prove to the people the futility of the cheap Press. I feel very sure of this – she must remain a serene and wise figure outside the ravings & ramblings of this agitated world. Do tell me that you agree with my view? Thank you again for your support, & kind thought in writing, & with messages from us both")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours affec.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 December 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so distressed that at this most vital and unhappy moment in the history of our country, I cannot leave the house to come & be with you."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn318",
      "id": "fn_318",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Old Weir insists that I remain in my room, at least for today, and very unwillingly I have accepted his advice. My thoughts are continually with you, and we are sustained & encouraged more than I can say by your wonderful example of dignity and wisdom. Darling Mama, you are indeed a beacon of light to all the poor bewildered people who are now groping in the darkness of disillusionment, and with your leadership we must all combine to get the country back to what it was this time last year.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As I write, your message has come, & I shall look forward with great joy to your visit today at 3.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have great faith in Bertie – he sees very straight, & if this terrible responsibility comes to him he will face it bravely.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Much love, darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Many years later, Queen Elizabeth reflected on the Abdication in her series of conversations with Eric Anderson:")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘It was a terrible surprise to everybody when he [the King] decided that he had to leave. It was the whole Commonwealth who said no no, we don’t want you to marry this lady. And it was just a terrible tragedy, it really was. We all loved the Prince of Wales and we all thought he was going to be a wonderful King. It was the most ghastly shock when he decided to go. It was a dreadful blow to his brother because, you see, they were great friends. It’s a terrible, bitter blow when somebody you love behaves like that.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Fortunately he was never crowned, and that was one of the good things he did. If he was going to make up his mind to go away, to do it before.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I wonder. I don’t think he ever wanted to be King. I don’t think he thought of it as something he ought to do. Very odd. People do change in a strange way. He had this extraordinary charm, and then it all disappeared. I don’t know what happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Nobody knows, really. He was frightfully popular. Everybody adored him. I think he may have thought he was so popular that people would want him back, whatever. I imagine that might have been in his mind. Oh, he was immensely popular all over the Commonwealth. He was extremely attractive. That makes it all the more strange, the whole thing. He must have been bemused with love, I suppose.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘You couldn’t reason with him, nobody could. The whole Government tried, everybody tried. The only good thing is, I think he was quite happy with her.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King Edward VIII signed the Instrument of Abdication on the evening of 10 December 1936, and it was given legislative assent on 11 December. The Duke of York became King George VI and the Duchess of York his Queen Consort. The former King, now to be known as Duke of Windsor, made a radio broadcast that night to explain his decision, and left by sea for France en route to Austria.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 December 1936 to the Duke of Windsor")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so miserable that I cannot come down to Royal Lodge owing to being ill in bed, as I wanted so much to see you before you go, and say ‘God bless you’ from my heart. We are all overcome with misery, and can only pray that you will find happiness in your new life.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I often think of the old days, & how you helped Bertie & I in the first years of our marriage. I shall always mention you in my prayers, & bless you, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 December 1936 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot tell you how touched I am at receiving your most kind and helpful letter today. I can hardly now believe that we have been called to this tremendous task, and, (I am writing to you quite intimately) the curious thing is that we are not afraid. I feel that God has enabled us to face the situation calmly, and although I at least feel most inadequate, we have been sustained during these last terrible days by many many good friends. I know that we may count you among them, and it means a great deal to us to know this. When we spoke together at Birkhall only three months ago, how little did I think that such drama & unhappiness was in store for our dear Country. Thank you from my heart for your unfailing sympathy & good advice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I would love to see you soon, as there are so many things to talk over, and for many years now, you have been so kind and wise about our troubles & joys that I fear you cannot escape this time. We both feel our responsibilities very deeply, and though quite prepared for a difficult time, are determined to do our best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your dear kind letter has helped us more than I can say – we were so very unhappy over the loss of a dear brother – because one can only feel that exile from this country is death indeed. We were miserable, as you know, over his change of heart and character during the last few years, and it is alarming how little in touch he was, with ordinary human feeling – Alas! he had lost the ‘common touch’. I thank you again from my heart for your wishes & prayers for our future, we pray most sincerely that we shall not fail our country, & I sign myself for the first time, & with great affection")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 December 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write you one line to tell you that this evening Bertie gave me the Garter."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn319",
      "id": "fn_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" He had discovered that Papa gave it to you on his Papa’s birthday June 3rd, and the coincidence was so charming that he has now followed suit, & given it to me on his own birthday. I felt that I must let you know this. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever darling Mama, your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 December 1936 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your dear, understanding letter. I do wish that you had been here during these days of drama & tragedy and disappointment. It is hard to believe that the one that we knew as Prince of Wales could possibly have done what King Edward did.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I won’t say anything about it, except that you can imagine what a misery it has been to the present King to lose a loved brother in such a way. He is tackling the business very calmly, and we can only do our best. Do let me know what the reaction has been in Rome. I hope that when you come home again you will come and see us in exactly the same way as before.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am keeping an open mind about everything at the moment, so will wait until later to write more fully.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been feeling ill with influenza for the last ten days, so forgive an extremely unintelligent letter – everything seems like a bad dream. But the curious thing is that I am not afraid. Inadequate, but unfrightened.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish you a very happy Xmas, & do believe that the knowledge that we have your friendship and sympathy is a great support to us just now. I mean that from my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("again")]), _vm._v(" for your kind letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 December 1936 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish that I could tell you how much real pleasure your most enchanting Xmas present has given me. I have long wished to have a book about the Pavilion"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn320",
      "id": "fn_320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & never dreamt that I could ever have such a lovely one. Not only are the illustrations & drawings exquisite, but the binding & coat of arms are also a dream of beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please believe that I am deeply grateful to you for your very kind thought of me, and I want to thank you from my heart for giving me such a very perfect present.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also, I want to thank you for your sympathetic and understanding letter of last week. I cannot tell you what a help it has been to us in the sad and tragic days that we have been through, to feel that we have the support & wishes of friends like yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("One can hardly believe that we could have survived such drama & tragedy, & yet, here we are, back at the old business – Buckling to, doing our best, keeping the old Flag flying hoorah, and of course it is the only thing that "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" worth doing now. I believe now, more than ever before, that this country is worth sacrificing a good deal for. In fact, if I was exiled, I should die, anyway in the spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Again a thousand grateful thanks for the really beautiful book.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The new King and Queen, their children and Queen Mary spent Christmas, New Year and most of January at Sandringham, recuperating from the shock of the abdication and coming to terms with the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The King was able to stop the sale, ordered by his brother, of much of the Sandringham Estate. To the relief of the tenant farmers and the Household, he also reversed many of the changes that Edward VIII had made in the running of both Sandringham and Balmoral.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Owen Morshead, the Royal Librarian at Windsor Castle, who was at Sandringham over Christmas, found the King and Queen very frank. The only topic of conversation was the new Duke of Windsor. The King and Queen dwelt on his extraordinary personality – ‘his amazing power of charming people, his flair for making any party go’. The Queen praised his ‘unique talents’ but was concerned that if he and Mrs Simpson did not remain together, ‘it would be dangerous to have such a powerful personality, so magnetic, hanging about doing nothing.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn321",
      "id": "fn_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 January 1937 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to thank you most gratefully for the book on the Coronation that you have so kindly sent me. I have read it with great interest, and shall look at it very often I expect. I am afraid that I was very ignorant anent (as we say in Scotland!) the wonderful amount of History & tradition that goes to make the great ceremony, and after reading your book I realize even more, the significance of what we have undertaken. I feel now, rather as if I was coming to after a heavy blow on the head. I think that the shock of those terrible days in December was literally stunning, and a merciful numbness overcame one at the time. The return to life is rather unpleasant – we shall need all our courage in the days to come.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you from my heart for your unfailing sympathy & understanding, it has been, & will be, the greatest help that we could wish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affec:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("2 February 1937 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do want to send you one line of grateful thanks for all your angelic kindness & help during our few weeks at Sandringham. I really do not know what we would have done without your unfailing sympathy & understanding through those first bewildering days when we were still stunned by the shock of David’s going.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall never forget what you did for us, and shall always love you for it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so wonderful having the old happy family atmosphere again. I feel sure that it is our great strength in these difficult days, and as for Bertie & myself, we shall do all in our power to keep it alive.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am looking forward so much to coming at 11 tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love darling Mama, your always devoted daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 February 1937 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I cannot tell you what a joy it is to receive an amusing and friendly one amongst the vast amount of begging letters, complaints, appeals, warnings, lunatic ramblings etc which go to make up one’s daily postbag. Not forgetting bad poetry, bad drawings & paintings, bad music and other bad things sent by the mad and bad who seem to people the world. So you can imagine how one falls greedily on the few friendly letters that come, and yours was very welcome!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must tell you first of all that we all thought your satire"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn322",
      "id": "fn_322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" absolutely brilliant. It really is perfect – it hits hard (and never too hard for me) and is wickedly amusing. I do congratulate you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You can imagine how deeply I feel about these people. I will not write about them though, & if, by the time I see you again I have any spirit left, I will tell you myself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s safer too!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May I ask whether you would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" kind and let me have a copy of your satire to put in the Windsor Castle Library? It would be quite private, but with other papers will be of great interest to future generations. Would you sign it? I would not trouble you, but I sent Lady Cholmondeley’s copy back to her, & have none myself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have moved into temporary rooms at Buckingham Palace whilst our own are being done up, and escape here for weekends, which is very healing and peaceful. We are going through a fairly difficult time here in England. As you can guess, after an upheaval like that of last December’s, gossip & ill natured stories are rife, and of course it is a heaven sent opportunity for Communist propaganda against Monarchies.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel rather ‘Morning Post’ saying that, but it’s true, & their ways are so subtle. Gossip is a godsend when there is a wish to be cruel.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The whole situation is very interesting – I fully expect that we may be moderately unpopular for some time, but as long as our friends stick to us, one can shoulder any amount of trouble. Certainly what is called the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("burden")]), _vm._v(" of Kingship is truly said. The whole thing is a burden – when you are youngish and an Aunt Sally for verbal skittles, especially; & yet, the more difficult it all is, the more worth while. Anyway, I will tell you about it when we see you again, which I hope will be soon. You must come to Windsor in April, & see how Queen Victoria imposed her taste onto George IV’s.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall look forward to your novel – if it seems long to you, it will of course seem much too short for your readers.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, always yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 April 1937 to Kenneth Clark")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Windsor Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Clark,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn323",
      "id": "fn_323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I want to send you my very sincere thanks for telling me about the busts. I am delighted that I had the luck to get them, and Sir Eric Maclagan"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn324",
      "id": "fn_324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has been most kind and forgiving about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I will never divulge the horrible truth, and I trust that your fair name will remain unsullied in Sir Eric’s eyes!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am communicating with Lord Gerald Wellesley,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn325",
      "id": "fn_325",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and am looking forward so much to seeing them here."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn326",
      "id": "fn_326",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Sir Eric has just written to ask whether I will lend them to his Exhibition of Kings and Queens of England at the V & A this summer. After his honourable conduct I cannot refuse, so fear that they will not be seen here just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have changed the pictures round in my sitting room here in the way that you suggested, and am so pleased with their appearance. As I write, the Duchess of Cumberland"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn327",
      "id": "fn_327",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" is looking down on me, and she looks heavenly on her new wall – I am already very fond of her.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have lit the Gainsborough walky-talky"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn328",
      "id": "fn_328",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" (also D. of Cumberland) & it looks too lovely. Perhaps the next time that you come here, you will have a look at it, as it looks a little dry & crackly when lit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was a great pleasure to us to have been able to go round with you here, and we are so grateful to you for all your interest and good advice. The Rubens look wonderful now that they have come down from the sky, & Dick’s hawk man"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn329",
      "id": "fn_329",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" too – Goodness only knows what he is up to now!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King George VI and Queen Elizabeth were crowned at Westminster Abbey on 12 May 1937.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("15 May 1937 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to you with a very full heart, to thank you for making our Coronation such a spiritual and wonderful service, & to congratulate you on the incredibly beautiful way that you did everything. I am sure that you have had many letters from people who were moved deeply by the immense significance of the day and I do want to add my affectionate and grateful appreciation of all that you did & meant to us that day.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was more moved, & more helped than I could have believed possible. It is curious, on thinking it over now, that I was not conscious of there being anybody else there at the Communion – you told us last Sunday evening that we would be helped and we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" sustained & carried above the ordinary fear of a great ceremony. Our great hope now, is that as so many millions of people were impressed by the feeling of service and goodness that came from Westminster Abbey, perhaps that day will result in strength and good feeling in individuals all over the world, and be a calming & strengthening influence on affairs in general.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thank you with all my heart for what you have been to us during these last difficult and tragic months – a good counsellor and true friend – we are indeed grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your affec: friend")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781466827745',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(265)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(267);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 267 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.8782f2cd5612020079e1.js